/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/view-v2/web/site/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 342);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(31);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = $;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(1),
    __webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    EventBus,
    Events,
    $,
    _
){
    var cdnOrigin = 'https://static.fnji.com';
    var testCdnOrigin = 'http://static.fnji.com';
    var imageOrigin = getImageOrigin();
    var baseUrl = getBaseUrl();

    function genImageUrl(imageName, options, origin){
        if (!imageName) return '';
        if(imageName.substr(0,4) == 'http')
            return imageName;


        imageName = imageName.split('?')[0];

        var defaultOptions = {
            width: 1440,
            useOriginal: false,
            usePng: false,
            color: ''
        };
        options = _.assign({}, defaultOptions, options);
        var query = '?';
        if(imageName.split('?').length>1)
            query+=imageName.split('?')[1]+"&";

        if (!options.useOriginal){
            query += 'imageMogr2/thumbnail/'+options.width+'x>';
            if (isPngImage(imageName) && !options.usePng){
                query += '/format/jpg';
                if (options.color){
                    query += '/background/'+options.color;
                }
            }
        }
        return (origin || cdnOrigin) + '/temp/upload/' + imageName + query;
    }
    function genFnjiImageUrl(imageName, options){
        return genImageUrl(imageName, options, imageOrigin);
    }

    function genCdnImageUrl(imageName, options){
        return genImageUrl(imageName, options, cdnOrigin);
    }
    function genCdnImageUrlOrg(imageName, options){
        return genImageUrl(imageName, {useOriginal:true}, cdnOrigin);
    }

    function isPngImage(imageName){
        imageName = (imageName || '').split('?')[0];
        return /\.png$/i.test(imageName || '');
    }

    function getImageOrigin(){
        switch(window.location.hostname){
            case 'fnji.com':
            case 'www.fnji.com':
            case 'm.fnji.com':
                return cdnOrigin;
            default:
                return testCdnOrigin;
        }
    }

    function emitPageReady(){
        setTimeout(function(){
            EventBus.$emit(Events.PageReady);
        }, 100);
    }

    function genPageLink(path){
        return baseUrl + path;
    }

    function getBaseUrl(){
        var path = window.location.pathname;
        if (path.match(/^\/v2\/src\//)){
            return '/v2/src';
        }
        if (path.match(/^\/v2\//)){
            return '/v2';
        }
        return '';
    }

    function getUrlParam(name){
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]);
        return null;
    }

    // function lazyLoadImages(options){
    //     $('[data-original][data-original!=""]').lazyload(_.assign({
    //         threshold: 100
    //     }, options));
    // }

    function scrollToSelector(selector, options){
        var $selector = $(selector);
        if (!$selector.length) return;
        if (options === 0) {
            $selector[0].scrollIntoView();
        } else {
            var top = $selector.offset().top;
            scrollTo(top, options);
        }
    }
    function scrollTo(top, options){
        var defaultOptions = {
            speed: 1000,
            easing: 'swing'
        };
        $('html,body').animate({scrollTop: top || 0}, _.assign(defaultOptions, options));
    }

    function scrollIntoView(el, times){
        if (!el) return;
        var fixedHeaderHeight = $('.page-header').height();
        var offsetTop = $(el).offset().top;
        // console.log(offsetTop, fixedHeaderHeight, offsetTop-fixedHeaderHeight);
        window.scroll({top: offsetTop - fixedHeaderHeight});
        if (!times) {
            setTimeout(function(){
                scrollIntoView(el, 1);
            }, 100);
        }
    }

    function getUrlHash(name, defval)
    {
        var hash = window.location.hash ? window.location.hash : "";
        var hashObj = $.deparam.fragment( hash, true );
        if(hashObj[name] != undefined)
            return hashObj[name];

        return defval;
    }

    return {
        getUrlHash:getUrlHash,
        emitPageReady: emitPageReady,
        genPageLink: genPageLink,
        genFnjiImageUrl: genFnjiImageUrl,
        genCdnImageUrl: genCdnImageUrl,
        genCdnImageUrlOrg:genCdnImageUrlOrg,
        getUrlParam: getUrlParam,
        scrollTo: scrollTo,
        scrollToSelector: scrollToSelector,
        scrollIntoView: scrollIntoView
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    // var BaseUrl = 'https://fnji.test.com';
    var BaseUrl = 'https://fnji.com';
    // var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        getMemberInfoApi: new Api('/s/member/getMemberInfo'),
        loginApi: new Api('/s/member/login', {type: 'POST'}),
        getWxLoginInfoApi: new Api('/s/member/getWxLoginInfo'),
        logoutApi: new Api('/s/member/logOut'),
        sendVerifyCodeApi: new Api('/s/member/sendPhoneVerify'),
        registerApi: new Api('/s/member/reg', {type: 'POST'}),
        resetPassApi: new Api('/s/member/forgot',{type: 'POST'}),

        addAddressApi: new Api('/s/member-address/add', {type: 'POST'}),
        modAddressApi: new Api('/s/member-address/mod', {type: 'POST'}),
        getProvinceApi: new Api('/s/common/getProvince'),
        getCityApi: new Api('/s/common/getCity'),

        getMenuByCategoryApi: new Api('/m/s/product-list/getMenuByCategory'),

        switchZhEnApi: new Api('/m/s/SiteIndexEntity/switchZhEn')//中英文切换
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),

    __webpack_require__(35)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $
){
    var backDropClass = 'modal-backdrop';
    var modalOpenClass = 'modal-open';
    var duration = 200;

    function onModalShow(){
        var $el = $('.'+backDropClass);
        if (!$el.length){
            $el = $('<div/>').addClass(backDropClass).appendTo('body');
        }
        $el.fadeIn(duration);
        $('body').addClass(modalOpenClass);
    }

    function onModalHide(){
        $('.'+backDropClass).fadeOut(duration);
        $('body').removeClass(modalOpenClass);
    }

    return {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            modalData: {
                type: Object
            }
        },
        watch: {
            value: function(value){
                if (value){
                    onModalShow();
                    $(this.$el).fadeIn(duration);
                } else {
                    onModalHide();
                    $(this.$el).fadeOut(duration);
                }
            }
        },
        methods: {
            show: function(){
                this.$emit('input', true);
            },
            hide: function(){
                this.$emit('input', false);
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(Vue){
    return new Vue();
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){
    return {
        PageReady: 'page-ready',
        UpdateMemberInfo: 'update-member-info'
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(27),
    __webpack_require__(1)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Vue,
    LoadingToast,
    $
){
    var $toastOverlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $toastOverlay[0],
        template: '<loading-toast v-show="loadingToast.isShow"></loading-toast>',
        components: {
            LoadingToast: LoadingToast
        },
        data: {
            loadingToast: {
                isShow: false
            }
        },
        methods: {
            showLoadingToast: function(){
                this.loadingToast.isShow = true;
            },
            hideLoadingToast: function(){
                this.loadingToast.isShow = false;
            }
        }
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(32),
    __webpack_require__(4),
    __webpack_require__(33),
    __webpack_require__(1),
    __webpack_require__(40),
    __webpack_require__(44),
    __webpack_require__(48),
    __webpack_require__(52),

    __webpack_require__(56)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    Vue,
    MemberLoginModal,
    $,
    MemberRegisterModal,
    PassResetModal,
    FnjiWeixinModal,
    FnjiWeixinSrvModal

){
    var $modalOverlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $modalOverlay[0],
        template: tpl,
        components: {
            MemberLoginModal: MemberLoginModal,
            MemberRegisterModal: MemberRegisterModal,
            PassResetModal: PassResetModal,
            FnjiWeixinModal: FnjiWeixinModal,
            FnjiWeixinSrvModal: FnjiWeixinSrvModal

        },
        data: {
            memberLoginModal: {
                isShow: false,
                data: {
                    from: ''
                }
            },
            memberRegisterModal: {
                isShow: false,
                data: {}
            },
            passResetModal: {
                isShow: false,
                data: {}
            },
            fnjiWeixinModal: {
                isShow: false,
                data: {}
            },
            fnjiWeixinSrvModal: {
                isShow: false,
                data: {}
            }
        },
        methods: {
            showMemberLoginModal: function(from){
                this.memberLoginModal = {
                    isShow: true,
                    data: {
                        from: from || ''
                    }
                };
            },
            showMemberRegisterModal: function(){
                this.memberRegisterModal.isShow = true;
            },
            showPassResetModal: function(){
                this.passResetModal.isShow = true;
            },
            showFnjiWeixinModal: function(){
                this.fnjiWeixinModal.isShow = true;
            },
            showFnjiWeixinSrvModal: function(){
                this.fnjiWeixinSrvModal.isShow = true;
            }
        }
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-i18n v8.15.5 
 * (c) 2020 kazuya kawaguchi
 * Released under the MIT License.
 */
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.VueI18n = factory());
}(this, (function () { 'use strict';

  /*  */

  /**
   * constants
   */

  var numberFormatKeys = [
    'style',
    'currency',
    'currencyDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'localeMatcher',
    'formatMatcher',
    'unit'
  ];

  /**
   * utilities
   */

  function warn (msg, err) {
    if (typeof console !== 'undefined') {
      console.warn('[vue-i18n] ' + msg);
      /* istanbul ignore if */
      if (err) {
        console.warn(err.stack);
      }
    }
  }

  function error (msg, err) {
    if (typeof console !== 'undefined') {
      console.error('[vue-i18n] ' + msg);
      /* istanbul ignore if */
      if (err) {
        console.error(err.stack);
      }
    }
  }

  function isObject (obj) {
    return obj !== null && typeof obj === 'object'
  }

  var toString = Object.prototype.toString;
  var OBJECT_STRING = '[object Object]';
  function isPlainObject (obj) {
    return toString.call(obj) === OBJECT_STRING
  }

  function isNull (val) {
    return val === null || val === undefined
  }

  function parseArgs () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var locale = null;
    var params = null;
    if (args.length === 1) {
      if (isObject(args[0]) || Array.isArray(args[0])) {
        params = args[0];
      } else if (typeof args[0] === 'string') {
        locale = args[0];
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        locale = args[0];
      }
      /* istanbul ignore if */
      if (isObject(args[1]) || Array.isArray(args[1])) {
        params = args[1];
      }
    }

    return { locale: locale, params: params }
  }

  function looseClone (obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  function remove (arr, item) {
    if (arr.length) {
      var index = arr.indexOf(item);
      if (index > -1) {
        return arr.splice(index, 1)
      }
    }
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  function hasOwn (obj, key) {
    return hasOwnProperty.call(obj, key)
  }

  function merge (target) {
    var arguments$1 = arguments;

    var output = Object(target);
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments$1[i];
      if (source !== undefined && source !== null) {
        var key = (void 0);
        for (key in source) {
          if (hasOwn(source, key)) {
            if (isObject(source[key])) {
              output[key] = merge(output[key], source[key]);
            } else {
              output[key] = source[key];
            }
          }
        }
      }
    }
    return output
  }

  function looseEqual (a, b) {
    if (a === b) { return true }
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
      try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);
        if (isArrayA && isArrayB) {
          return a.length === b.length && a.every(function (e, i) {
            return looseEqual(e, b[i])
          })
        } else if (!isArrayA && !isArrayB) {
          var keysA = Object.keys(a);
          var keysB = Object.keys(b);
          return keysA.length === keysB.length && keysA.every(function (key) {
            return looseEqual(a[key], b[key])
          })
        } else {
          /* istanbul ignore next */
          return false
        }
      } catch (e) {
        /* istanbul ignore next */
        return false
      }
    } else if (!isObjectA && !isObjectB) {
      return String(a) === String(b)
    } else {
      return false
    }
  }

  /*  */

  function extend (Vue) {
    if (!Vue.prototype.hasOwnProperty('$i18n')) {
      // $FlowFixMe
      Object.defineProperty(Vue.prototype, '$i18n', {
        get: function get () { return this._i18n }
      });
    }

    Vue.prototype.$t = function (key) {
      var values = [], len = arguments.length - 1;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

      var i18n = this.$i18n;
      return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
    };

    Vue.prototype.$tc = function (key, choice) {
      var values = [], len = arguments.length - 2;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

      var i18n = this.$i18n;
      return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
    };

    Vue.prototype.$te = function (key, locale) {
      var i18n = this.$i18n;
      return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
    };

    Vue.prototype.$d = function (value) {
      var ref;

      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
      return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
    };

    Vue.prototype.$n = function (value) {
      var ref;

      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
      return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
    };
  }

  /*  */

  var mixin = {
    beforeCreate: function beforeCreate () {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18n ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          if (options.__i18n) {
            try {
              var localeMessages = {};
              options.__i18n.forEach(function (resource) {
                localeMessages = merge(localeMessages, JSON.parse(resource));
              });
              Object.keys(localeMessages).forEach(function (locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
              {
                error("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
        } else if (isPlainObject(options.i18n)) {
          // component local i18n
          if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
            options.i18n.root = this.$root;
            options.i18n.formatter = this.$root.$i18n.formatter;
            options.i18n.fallbackLocale = this.$root.$i18n.fallbackLocale;
            options.i18n.formatFallbackMessages = this.$root.$i18n.formatFallbackMessages;
            options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
            options.i18n.silentFallbackWarn = this.$root.$i18n.silentFallbackWarn;
            options.i18n.pluralizationRules = this.$root.$i18n.pluralizationRules;
            options.i18n.preserveDirectiveContent = this.$root.$i18n.preserveDirectiveContent;
          }

          // init locale messages via custom blocks
          if (options.__i18n) {
            try {
              var localeMessages$1 = {};
              options.__i18n.forEach(function (resource) {
                localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
              {
                warn("Cannot parse locale messages via custom blocks.", e);
              }
            }
          }

          var ref = options.i18n;
          var sharedMessages = ref.sharedMessages;
          if (sharedMessages && isPlainObject(sharedMessages)) {
            options.i18n.messages = merge(options.i18n.messages, sharedMessages);
          }

          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();

          if (options.i18n.sync === undefined || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }
        } else {
          {
            warn("Cannot be interpreted 'i18n' option.");
          }
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        // root i18n
        this._i18n = this.$root.$i18n;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        // parent i18n
        this._i18n = options.parent.$i18n;
      }
    },

    beforeMount: function beforeMount () {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18n ? {} : null);

      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          // init locale messages via custom blocks
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else {
          {
            warn("Cannot be interpreted 'i18n' option.");
          }
        }
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },

    beforeDestroy: function beforeDestroy () {
      if (!this._i18n) { return }

      var self = this;
      this.$nextTick(function () {
        if (self._subscribing) {
          self._i18n.unsubscribeDataChanging(self);
          delete self._subscribing;
        }

        if (self._i18nWatcher) {
          self._i18nWatcher();
          self._i18n.destroyVM();
          delete self._i18nWatcher;
        }

        if (self._localeWatcher) {
          self._localeWatcher();
          delete self._localeWatcher;
        }

        self._i18n = null;
      });
    }
  };

  /*  */

  var interpolationComponent = {
    name: 'i18n',
    functional: true,
    props: {
      tag: {
        type: String
      },
      path: {
        type: String,
        required: true
      },
      locale: {
        type: String
      },
      places: {
        type: [Array, Object]
      }
    },
    render: function render (h, ref) {
      var data = ref.data;
      var parent = ref.parent;
      var props = ref.props;
      var slots = ref.slots;

      var $i18n = parent.$i18n;
      if (!$i18n) {
        {
          warn('Cannot find VueI18n instance!');
        }
        return
      }

      var path = props.path;
      var locale = props.locale;
      var places = props.places;
      var params = slots();
      var children = $i18n.i(
        path,
        locale,
        onlyHasDefaultPlace(params) || places
          ? useLegacyPlaces(params.default, places)
          : params
      );

      var tag = props.tag || 'span';
      return tag ? h(tag, data, children) : children
    }
  };

  function onlyHasDefaultPlace (params) {
    var prop;
    for (prop in params) {
      if (prop !== 'default') { return false }
    }
    return Boolean(prop)
  }

  function useLegacyPlaces (children, places) {
    var params = places ? createParamsFromPlaces(places) : {};

    if (!children) { return params }

    // Filter empty text nodes
    children = children.filter(function (child) {
      return child.tag || child.text.trim() !== ''
    });

    var everyPlace = children.every(vnodeHasPlaceAttribute);
    if (everyPlace) {
      warn('`place` attribute is deprecated in next major version. Please switch to Vue slots.');
    }

    return children.reduce(
      everyPlace ? assignChildPlace : assignChildIndex,
      params
    )
  }

  function createParamsFromPlaces (places) {
    {
      warn('`places` prop is deprecated in next major version. Please switch to Vue slots.');
    }

    return Array.isArray(places)
      ? places.reduce(assignChildIndex, {})
      : Object.assign({}, places)
  }

  function assignChildPlace (params, child) {
    if (child.data && child.data.attrs && child.data.attrs.place) {
      params[child.data.attrs.place] = child;
    }
    return params
  }

  function assignChildIndex (params, child, index) {
    params[index] = child;
    return params
  }

  function vnodeHasPlaceAttribute (vnode) {
    return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
  }

  /*  */

  var numberComponent = {
    name: 'i18n-n',
    functional: true,
    props: {
      tag: {
        type: String,
        default: 'span'
      },
      value: {
        type: Number,
        required: true
      },
      format: {
        type: [String, Object]
      },
      locale: {
        type: String
      }
    },
    render: function render (h, ref) {
      var props = ref.props;
      var parent = ref.parent;
      var data = ref.data;

      var i18n = parent.$i18n;

      if (!i18n) {
        {
          warn('Cannot find VueI18n instance!');
        }
        return null
      }

      var key = null;
      var options = null;

      if (typeof props.format === 'string') {
        key = props.format;
      } else if (isObject(props.format)) {
        if (props.format.key) {
          key = props.format.key;
        }

        // Filter out number format options only
        options = Object.keys(props.format).reduce(function (acc, prop) {
          var obj;

          if (numberFormatKeys.includes(prop)) {
            return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
          }
          return acc
        }, null);
      }

      var locale = props.locale || i18n.locale;
      var parts = i18n._ntp(props.value, locale, key, options);

      var values = parts.map(function (part, index) {
        var obj;

        var slot = data.scopedSlots && data.scopedSlots[part.type];
        return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
      });

      return h(props.tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
    }
  };

  /*  */

  function bind (el, binding, vnode) {
    if (!assert(el, vnode)) { return }

    t(el, binding, vnode);
  }

  function update (el, binding, vnode, oldVNode) {
    if (!assert(el, vnode)) { return }

    var i18n = vnode.context.$i18n;
    if (localeEqual(el, vnode) &&
      (looseEqual(binding.value, binding.oldValue) &&
       looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

    t(el, binding, vnode);
  }

  function unbind (el, binding, vnode, oldVNode) {
    var vm = vnode.context;
    if (!vm) {
      warn('Vue instance does not exists in VNode context');
      return
    }

    var i18n = vnode.context.$i18n || {};
    if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
      el.textContent = '';
    }
    el._vt = undefined;
    delete el['_vt'];
    el._locale = undefined;
    delete el['_locale'];
    el._localeMessage = undefined;
    delete el['_localeMessage'];
  }

  function assert (el, vnode) {
    var vm = vnode.context;
    if (!vm) {
      warn('Vue instance does not exists in VNode context');
      return false
    }

    if (!vm.$i18n) {
      warn('VueI18n instance does not exists in Vue instance');
      return false
    }

    return true
  }

  function localeEqual (el, vnode) {
    var vm = vnode.context;
    return el._locale === vm.$i18n.locale
  }

  function t (el, binding, vnode) {
    var ref$1, ref$2;

    var value = binding.value;

    var ref = parseValue(value);
    var path = ref.path;
    var locale = ref.locale;
    var args = ref.args;
    var choice = ref.choice;
    if (!path && !locale && !args) {
      warn('value type not supported');
      return
    }

    if (!path) {
      warn('`path` is required in v-t directive');
      return
    }

    var vm = vnode.context;
    if (choice) {
      el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
    } else {
      el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
    }
    el._locale = vm.$i18n.locale;
    el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
  }

  function parseValue (value) {
    var path;
    var locale;
    var args;
    var choice;

    if (typeof value === 'string') {
      path = value;
    } else if (isPlainObject(value)) {
      path = value.path;
      locale = value.locale;
      args = value.args;
      choice = value.choice;
    }

    return { path: path, locale: locale, args: args, choice: choice }
  }

  function makeParams (locale, args) {
    var params = [];

    locale && params.push(locale);
    if (args && (Array.isArray(args) || isPlainObject(args))) {
      params.push(args);
    }

    return params
  }

  var Vue;

  function install (_Vue) {
    /* istanbul ignore if */
    if (install.installed && _Vue === Vue) {
      warn('already installed.');
      return
    }
    install.installed = true;

    Vue = _Vue;

    var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
    /* istanbul ignore if */
    if (version < 2) {
      warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
      return
    }

    extend(Vue);
    Vue.mixin(mixin);
    Vue.directive('t', { bind: bind, update: update, unbind: unbind });
    Vue.component(interpolationComponent.name, interpolationComponent);
    Vue.component(numberComponent.name, numberComponent);

    // use simple mergeStrategies to prevent i18n instance lose '__proto__'
    var strats = Vue.config.optionMergeStrategies;
    strats.i18n = function (parentVal, childVal) {
      return childVal === undefined
        ? parentVal
        : childVal
    };
  }

  /*  */

  var BaseFormatter = function BaseFormatter () {
    this._caches = Object.create(null);
  };

  BaseFormatter.prototype.interpolate = function interpolate (message, values) {
    if (!values) {
      return [message]
    }
    var tokens = this._caches[message];
    if (!tokens) {
      tokens = parse(message);
      this._caches[message] = tokens;
    }
    return compile(tokens, values)
  };



  var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
  var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

  function parse (format) {
    var tokens = [];
    var position = 0;

    var text = '';
    while (position < format.length) {
      var char = format[position++];
      if (char === '{') {
        if (text) {
          tokens.push({ type: 'text', value: text });
        }

        text = '';
        var sub = '';
        char = format[position++];
        while (char !== undefined && char !== '}') {
          sub += char;
          char = format[position++];
        }
        var isClosed = char === '}';

        var type = RE_TOKEN_LIST_VALUE.test(sub)
          ? 'list'
          : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
            ? 'named'
            : 'unknown';
        tokens.push({ value: sub, type: type });
      } else if (char === '%') {
        // when found rails i18n syntax, skip text capture
        if (format[(position)] !== '{') {
          text += char;
        }
      } else {
        text += char;
      }
    }

    text && tokens.push({ type: 'text', value: text });

    return tokens
  }

  function compile (tokens, values) {
    var compiled = [];
    var index = 0;

    var mode = Array.isArray(values)
      ? 'list'
      : isObject(values)
        ? 'named'
        : 'unknown';
    if (mode === 'unknown') { return compiled }

    while (index < tokens.length) {
      var token = tokens[index];
      switch (token.type) {
        case 'text':
          compiled.push(token.value);
          break
        case 'list':
          compiled.push(values[parseInt(token.value, 10)]);
          break
        case 'named':
          if (mode === 'named') {
            compiled.push((values)[token.value]);
          } else {
            {
              warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
            }
          }
          break
        case 'unknown':
          {
            warn("Detect 'unknown' type of token!");
          }
          break
      }
      index++;
    }

    return compiled
  }

  /*  */

  /**
   *  Path parser
   *  - Inspired:
   *    Vue.js Path parser
   */

  // actions
  var APPEND = 0;
  var PUSH = 1;
  var INC_SUB_PATH_DEPTH = 2;
  var PUSH_SUB_PATH = 3;

  // states
  var BEFORE_PATH = 0;
  var IN_PATH = 1;
  var BEFORE_IDENT = 2;
  var IN_IDENT = 3;
  var IN_SUB_PATH = 4;
  var IN_SINGLE_QUOTE = 5;
  var IN_DOUBLE_QUOTE = 6;
  var AFTER_PATH = 7;
  var ERROR = 8;

  var pathStateMachine = [];

  pathStateMachine[BEFORE_PATH] = {
    'ws': [BEFORE_PATH],
    'ident': [IN_IDENT, APPEND],
    '[': [IN_SUB_PATH],
    'eof': [AFTER_PATH]
  };

  pathStateMachine[IN_PATH] = {
    'ws': [IN_PATH],
    '.': [BEFORE_IDENT],
    '[': [IN_SUB_PATH],
    'eof': [AFTER_PATH]
  };

  pathStateMachine[BEFORE_IDENT] = {
    'ws': [BEFORE_IDENT],
    'ident': [IN_IDENT, APPEND],
    '0': [IN_IDENT, APPEND],
    'number': [IN_IDENT, APPEND]
  };

  pathStateMachine[IN_IDENT] = {
    'ident': [IN_IDENT, APPEND],
    '0': [IN_IDENT, APPEND],
    'number': [IN_IDENT, APPEND],
    'ws': [IN_PATH, PUSH],
    '.': [BEFORE_IDENT, PUSH],
    '[': [IN_SUB_PATH, PUSH],
    'eof': [AFTER_PATH, PUSH]
  };

  pathStateMachine[IN_SUB_PATH] = {
    "'": [IN_SINGLE_QUOTE, APPEND],
    '"': [IN_DOUBLE_QUOTE, APPEND],
    '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
    ']': [IN_PATH, PUSH_SUB_PATH],
    'eof': ERROR,
    'else': [IN_SUB_PATH, APPEND]
  };

  pathStateMachine[IN_SINGLE_QUOTE] = {
    "'": [IN_SUB_PATH, APPEND],
    'eof': ERROR,
    'else': [IN_SINGLE_QUOTE, APPEND]
  };

  pathStateMachine[IN_DOUBLE_QUOTE] = {
    '"': [IN_SUB_PATH, APPEND],
    'eof': ERROR,
    'else': [IN_DOUBLE_QUOTE, APPEND]
  };

  /**
   * Check if an expression is a literal value.
   */

  var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
  function isLiteral (exp) {
    return literalValueRE.test(exp)
  }

  /**
   * Strip quotes from a string
   */

  function stripQuotes (str) {
    var a = str.charCodeAt(0);
    var b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27)
      ? str.slice(1, -1)
      : str
  }

  /**
   * Determine the type of a character in a keypath.
   */

  function getPathCharType (ch) {
    if (ch === undefined || ch === null) { return 'eof' }

    var code = ch.charCodeAt(0);

    switch (code) {
      case 0x5B: // [
      case 0x5D: // ]
      case 0x2E: // .
      case 0x22: // "
      case 0x27: // '
        return ch

      case 0x5F: // _
      case 0x24: // $
      case 0x2D: // -
        return 'ident'

      case 0x09: // Tab
      case 0x0A: // Newline
      case 0x0D: // Return
      case 0xA0:  // No-break space
      case 0xFEFF:  // Byte Order Mark
      case 0x2028:  // Line Separator
      case 0x2029:  // Paragraph Separator
        return 'ws'
    }

    return 'ident'
  }

  /**
   * Format a subPath, return its plain form if it is
   * a literal string or number. Otherwise prepend the
   * dynamic indicator (*).
   */

  function formatSubPath (path) {
    var trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(path)) { return false }

    return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
  }

  /**
   * Parse a string path into an array of segments
   */

  function parse$1 (path) {
    var keys = [];
    var index = -1;
    var mode = BEFORE_PATH;
    var subPathDepth = 0;
    var c;
    var key;
    var newChar;
    var type;
    var transition;
    var action;
    var typeMap;
    var actions = [];

    actions[PUSH] = function () {
      if (key !== undefined) {
        keys.push(key);
        key = undefined;
      }
    };

    actions[APPEND] = function () {
      if (key === undefined) {
        key = newChar;
      } else {
        key += newChar;
      }
    };

    actions[INC_SUB_PATH_DEPTH] = function () {
      actions[APPEND]();
      subPathDepth++;
    };

    actions[PUSH_SUB_PATH] = function () {
      if (subPathDepth > 0) {
        subPathDepth--;
        mode = IN_SUB_PATH;
        actions[APPEND]();
      } else {
        subPathDepth = 0;
        if (key === undefined) { return false }
        key = formatSubPath(key);
        if (key === false) {
          return false
        } else {
          actions[PUSH]();
        }
      }
    };

    function maybeUnescapeQuote () {
      var nextChar = path[index + 1];
      if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
        (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
        index++;
        newChar = '\\' + nextChar;
        actions[APPEND]();
        return true
      }
    }

    while (mode !== null) {
      index++;
      c = path[index];

      if (c === '\\' && maybeUnescapeQuote()) {
        continue
      }

      type = getPathCharType(c);
      typeMap = pathStateMachine[mode];
      transition = typeMap[type] || typeMap['else'] || ERROR;

      if (transition === ERROR) {
        return // parse error
      }

      mode = transition[0];
      action = actions[transition[1]];
      if (action) {
        newChar = transition[2];
        newChar = newChar === undefined
          ? c
          : newChar;
        if (action() === false) {
          return
        }
      }

      if (mode === AFTER_PATH) {
        return keys
      }
    }
  }





  var I18nPath = function I18nPath () {
    this._cache = Object.create(null);
  };

  /**
   * External parse that check for a cache hit first
   */
  I18nPath.prototype.parsePath = function parsePath (path) {
    var hit = this._cache[path];
    if (!hit) {
      hit = parse$1(path);
      if (hit) {
        this._cache[path] = hit;
      }
    }
    return hit || []
  };

  /**
   * Get path value from path string
   */
  I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
    if (!isObject(obj)) { return null }

    var paths = this.parsePath(path);
    if (paths.length === 0) {
      return null
    } else {
      var length = paths.length;
      var last = obj;
      var i = 0;
      while (i < length) {
        var value = last[paths[i]];
        if (value === undefined) {
          return null
        }
        last = value;
        i++;
      }

      return last
    }
  };

  /*  */



  var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
  var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|.]+|\([\w\-_|.]+\)))/g;
  var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
  var bracketsMatcher = /[()]/g;
  var defaultModifiers = {
    'upper': function (str) { return str.toLocaleUpperCase(); },
    'lower': function (str) { return str.toLocaleLowerCase(); },
    'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
  };

  var defaultFormatter = new BaseFormatter();

  var VueI18n = function VueI18n (options) {
    var this$1 = this;
    if ( options === void 0 ) options = {};

    // Auto install if it is not done yet and `window` has `Vue`.
    // To allow users to avoid auto-installation in some cases,
    // this code should be placed here. See #290
    /* istanbul ignore if */
    if (!Vue && typeof window !== 'undefined' && window.Vue) {
      install(window.Vue);
    }

    var locale = options.locale || 'en-US';
    var fallbackLocale = options.fallbackLocale || 'en-US';
    var messages = options.messages || {};
    var dateTimeFormats = options.dateTimeFormats || {};
    var numberFormats = options.numberFormats || {};

    this._vm = null;
    this._formatter = options.formatter || defaultFormatter;
    this._modifiers = options.modifiers || {};
    this._missing = options.missing || null;
    this._root = options.root || null;
    this._sync = options.sync === undefined ? true : !!options.sync;
    this._fallbackRoot = options.fallbackRoot === undefined
      ? true
      : !!options.fallbackRoot;
    this._formatFallbackMessages = options.formatFallbackMessages === undefined
      ? false
      : !!options.formatFallbackMessages;
    this._silentTranslationWarn = options.silentTranslationWarn === undefined
      ? false
      : options.silentTranslationWarn;
    this._silentFallbackWarn = options.silentFallbackWarn === undefined
      ? false
      : !!options.silentFallbackWarn;
    this._dateTimeFormatters = {};
    this._numberFormatters = {};
    this._path = new I18nPath();
    this._dataListeners = [];
    this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
      ? false
      : !!options.preserveDirectiveContent;
    this.pluralizationRules = options.pluralizationRules || {};
    this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';

    this._exist = function (message, key) {
      if (!message || !key) { return false }
      if (!isNull(this$1._path.getPathValue(message, key))) { return true }
      // fallback for flat key
      if (message[key]) { return true }
      return false
    };

    if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
      Object.keys(messages).forEach(function (locale) {
        this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
      });
    }

    this._initVM({
      locale: locale,
      fallbackLocale: fallbackLocale,
      messages: messages,
      dateTimeFormats: dateTimeFormats,
      numberFormats: numberFormats
    });
  };

  var prototypeAccessors = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true } };

  VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
    var paths = [];

    var fn = function (level, locale, message, paths) {
      if (isPlainObject(message)) {
        Object.keys(message).forEach(function (key) {
          var val = message[key];
          if (isPlainObject(val)) {
            paths.push(key);
            paths.push('.');
            fn(level, locale, val, paths);
            paths.pop();
            paths.pop();
          } else {
            paths.push(key);
            fn(level, locale, val, paths);
            paths.pop();
          }
        });
      } else if (Array.isArray(message)) {
        message.forEach(function (item, index) {
          if (isPlainObject(item)) {
            paths.push(("[" + index + "]"));
            paths.push('.');
            fn(level, locale, item, paths);
            paths.pop();
            paths.pop();
          } else {
            paths.push(("[" + index + "]"));
            fn(level, locale, item, paths);
            paths.pop();
          }
        });
      } else if (typeof message === 'string') {
        var ret = htmlTagMatcher.test(message);
        if (ret) {
          var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
          if (level === 'warn') {
            warn(msg);
          } else if (level === 'error') {
            error(msg);
          }
        }
      }
    };

    fn(level, locale, message, paths);
  };

  VueI18n.prototype._initVM = function _initVM (data) {
    var silent = Vue.config.silent;
    Vue.config.silent = true;
    this._vm = new Vue({ data: data });
    Vue.config.silent = silent;
  };

  VueI18n.prototype.destroyVM = function destroyVM () {
    this._vm.$destroy();
  };

  VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
    this._dataListeners.push(vm);
  };

  VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
    remove(this._dataListeners, vm);
  };

  VueI18n.prototype.watchI18nData = function watchI18nData () {
    var self = this;
    return this._vm.$watch('$data', function () {
      var i = self._dataListeners.length;
      while (i--) {
        Vue.nextTick(function () {
          self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
        });
      }
    }, { deep: true })
  };

  VueI18n.prototype.watchLocale = function watchLocale () {
    /* istanbul ignore if */
    if (!this._sync || !this._root) { return null }
    var target = this._vm;
    return this._root.$i18n.vm.$watch('locale', function (val) {
      target.$set(target, 'locale', val);
      target.$forceUpdate();
    }, { immediate: true })
  };

  prototypeAccessors.vm.get = function () { return this._vm };

  prototypeAccessors.messages.get = function () { return looseClone(this._getMessages()) };
  prototypeAccessors.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
  prototypeAccessors.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
  prototypeAccessors.availableLocales.get = function () { return Object.keys(this.messages).sort() };

  prototypeAccessors.locale.get = function () { return this._vm.locale };
  prototypeAccessors.locale.set = function (locale) {
    this._vm.$set(this._vm, 'locale', locale);
  };

  prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
  prototypeAccessors.fallbackLocale.set = function (locale) {
    this._vm.$set(this._vm, 'fallbackLocale', locale);
  };

  prototypeAccessors.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
  prototypeAccessors.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

  prototypeAccessors.missing.get = function () { return this._missing };
  prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

  prototypeAccessors.formatter.get = function () { return this._formatter };
  prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

  prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
  prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

  prototypeAccessors.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
  prototypeAccessors.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

  prototypeAccessors.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
  prototypeAccessors.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

  prototypeAccessors.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
  prototypeAccessors.warnHtmlInMessage.set = function (level) {
      var this$1 = this;

    var orgLevel = this._warnHtmlInMessage;
    this._warnHtmlInMessage = level;
    if (orgLevel !== level && (level === 'warn' || level === 'error')) {
      var messages = this._getMessages();
      Object.keys(messages).forEach(function (locale) {
        this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
      });
    }
  };

  VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
  VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
  VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

  VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
    if (!isNull(result)) { return result }
    if (this._missing) {
      var missingRet = this._missing.apply(null, [locale, key, vm, values]);
      if (typeof missingRet === 'string') {
        return missingRet
      }
    } else {
      if (!this._isSilentTranslationWarn(key)) {
        warn(
          "Cannot translate the value of keypath '" + key + "'. " +
          'Use the value of keypath as default.'
        );
      }
    }

    if (this._formatFallbackMessages) {
      var parsedArgs = parseArgs.apply(void 0, values);
      return this._render(key, interpolateMode, parsedArgs.params, key)
    } else {
      return key
    }
  };

  VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
    return !val && !isNull(this._root) && this._fallbackRoot
  };

  VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
    return this._silentFallbackWarn instanceof RegExp
      ? this._silentFallbackWarn.test(key)
      : this._silentFallbackWarn
  };

  VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
    return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
  };

  VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
    return this._silentTranslationWarn instanceof RegExp
      ? this._silentTranslationWarn.test(key)
      : this._silentTranslationWarn
  };

  VueI18n.prototype._interpolate = function _interpolate (
    locale,
    message,
    key,
    host,
    interpolateMode,
    values,
    visitedLinkStack
  ) {
    if (!message) { return null }

    var pathRet = this._path.getPathValue(message, key);
    if (Array.isArray(pathRet) || isPlainObject(pathRet)) { return pathRet }

    var ret;
    if (isNull(pathRet)) {
      /* istanbul ignore else */
      if (isPlainObject(message)) {
        ret = message[key];
        if (typeof ret !== 'string') {
          if (!this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
            warn(("Value of key '" + key + "' is not a string!"));
          }
          return null
        }
      } else {
        return null
      }
    } else {
      /* istanbul ignore else */
      if (typeof pathRet === 'string') {
        ret = pathRet;
      } else {
        if (!this._isSilentTranslationWarn(key) && !this._isSilentFallback(locale, key)) {
          warn(("Value of key '" + key + "' is not a string!"));
        }
        return null
      }
    }

    // Check for the existence of links within the translated string
    if (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0) {
      ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
    }

    return this._render(ret, interpolateMode, values, key)
  };

  VueI18n.prototype._link = function _link (
    locale,
    message,
    str,
    host,
    interpolateMode,
    values,
    visitedLinkStack
  ) {
    var ret = str;

    // Match all the links within the local
    // We are going to replace each of
    // them with its translation
    var matches = ret.match(linkKeyMatcher);
    for (var idx in matches) {
      // ie compatible: filter custom array
      // prototype method
      if (!matches.hasOwnProperty(idx)) {
        continue
      }
      var link = matches[idx];
      var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
      var linkPrefix = linkKeyPrefixMatches[0];
        var formatterName = linkKeyPrefixMatches[1];

      // Remove the leading @:, @.case: and the brackets
      var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

      if (visitedLinkStack.includes(linkPlaceholder)) {
        {
          warn(("Circular reference found. \"" + link + "\" is already visited in the chain of " + (visitedLinkStack.reverse().join(' <- '))));
        }
        return ret
      }
      visitedLinkStack.push(linkPlaceholder);

      // Translate the link
      var translated = this._interpolate(
        locale, message, linkPlaceholder, host,
        interpolateMode === 'raw' ? 'string' : interpolateMode,
        interpolateMode === 'raw' ? undefined : values,
        visitedLinkStack
      );

      if (this._isFallbackRoot(translated)) {
        if (!this._isSilentTranslationWarn(linkPlaceholder)) {
          warn(("Fall back to translate the link placeholder '" + linkPlaceholder + "' with root locale."));
        }
        /* istanbul ignore if */
        if (!this._root) { throw Error('unexpected error') }
        var root = this._root.$i18n;
        translated = root._translate(
          root._getMessages(), root.locale, root.fallbackLocale,
          linkPlaceholder, host, interpolateMode, values
        );
      }
      translated = this._warnDefault(
        locale, linkPlaceholder, translated, host,
        Array.isArray(values) ? values : [values],
        interpolateMode
      );

      if (this._modifiers.hasOwnProperty(formatterName)) {
        translated = this._modifiers[formatterName](translated);
      } else if (defaultModifiers.hasOwnProperty(formatterName)) {
        translated = defaultModifiers[formatterName](translated);
      }

      visitedLinkStack.pop();

      // Replace the link with the translated
      ret = !translated ? ret : ret.replace(link, translated);
    }

    return ret
  };

  VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
    var ret = this._formatter.interpolate(message, values, path);

    // If the custom formatter refuses to work - apply the default one
    if (!ret) {
      ret = defaultFormatter.interpolate(message, values, path);
    }

    // if interpolateMode is **not** 'string' ('row'),
    // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
    return interpolateMode === 'string' && typeof ret !== 'string' ? ret.join('') : ret
  };

  VueI18n.prototype._translate = function _translate (
    messages,
    locale,
    fallback,
    key,
    host,
    interpolateMode,
    args
  ) {
    var res =
      this._interpolate(locale, messages[locale], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) { return res }

    res = this._interpolate(fallback, messages[fallback], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale."));
      }
      return res
    } else {
      return null
    }
  };

  VueI18n.prototype._t = function _t (key, _locale, messages, host) {
      var ref;

      var values = [], len = arguments.length - 4;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
    if (!key) { return '' }

    var parsedArgs = parseArgs.apply(void 0, values);
    var locale = parsedArgs.locale || _locale;

    var ret = this._translate(
      messages, locale, this.fallbackLocale, key,
      host, 'string', parsedArgs.params
    );
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to translate the keypath '" + key + "' with root locale."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
    } else {
      return this._warnDefault(locale, key, ret, host, values, 'string')
    }
  };

  VueI18n.prototype.t = function t (key) {
      var ref;

      var values = [], len = arguments.length - 1;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
    return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
  };

  VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
    var ret =
      this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key)) {
        warn(("Fall back to interpolate the keypath '" + key + "' with root locale."));
      }
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n.i(key, locale, values)
    } else {
      return this._warnDefault(locale, key, ret, host, [values], 'raw')
    }
  };

  VueI18n.prototype.i = function i (key, locale, values) {
    /* istanbul ignore if */
    if (!key) { return '' }

    if (typeof locale !== 'string') {
      locale = this.locale;
    }

    return this._i(key, locale, this._getMessages(), null, values)
  };

  VueI18n.prototype._tc = function _tc (
    key,
    _locale,
    messages,
    host,
    choice
  ) {
      var ref;

      var values = [], len = arguments.length - 5;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
    if (!key) { return '' }
    if (choice === undefined) {
      choice = 1;
    }

    var predefined = { 'count': choice, 'n': choice };
    var parsedArgs = parseArgs.apply(void 0, values);
    parsedArgs.params = Object.assign(predefined, parsedArgs.params);
    values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
    return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
  };

  VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
    /* istanbul ignore if */
    if (!message && typeof message !== 'string') { return null }
    var choices = message.split('|');

    choice = this.getChoiceIndex(choice, choices.length);
    if (!choices[choice]) { return message }
    return choices[choice].trim()
  };

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  VueI18n.prototype.getChoiceIndex = function getChoiceIndex (choice, choicesLength) {
    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this.locale in this.pluralizationRules) {
      return this.pluralizationRules[this.locale].apply(this, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };

  VueI18n.prototype.tc = function tc (key, choice) {
      var ref;

      var values = [], len = arguments.length - 2;
      while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
    return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
  };

  VueI18n.prototype._te = function _te (key, locale, messages) {
      var args = [], len = arguments.length - 3;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

    var _locale = parseArgs.apply(void 0, args).locale || locale;
    return this._exist(messages[_locale], key)
  };

  VueI18n.prototype.te = function te (key, locale) {
    return this._te(key, this.locale, this._getMessages(), locale)
  };

  VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
    return looseClone(this._vm.messages[locale] || {})
  };

  VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
    if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
      this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
      if (this._warnHtmlInMessage === 'error') { return }
    }
    this._vm.$set(this._vm.messages, locale, message);
  };

  VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
    if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
      this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
      if (this._warnHtmlInMessage === 'error') { return }
    }
    this._vm.$set(this._vm.messages, locale, merge({}, this._vm.messages[locale] || {}, message));
  };

  VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
    return looseClone(this._vm.dateTimeFormats[locale] || {})
  };

  VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
    this._vm.$set(this._vm.dateTimeFormats, locale, format);
  };

  VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
    this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
  };

  VueI18n.prototype._localizeDateTime = function _localizeDateTime (
    value,
    locale,
    fallback,
    dateTimeFormats,
    key
  ) {
    var _locale = locale;
    var formats = dateTimeFormats[_locale];

    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + fallback + "' datetime formats from '" + locale + "' datetime formats."));
      }
      _locale = fallback;
      formats = dateTimeFormats[_locale];
    }

    if (isNull(formats) || isNull(formats[key])) {
      return null
    } else {
      var format = formats[key];
      var id = _locale + "__" + key;
      var formatter = this._dateTimeFormatters[id];
      if (!formatter) {
        formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
      }
      return formatter.format(value)
    }
  };

  VueI18n.prototype._d = function _d (value, locale, key) {
    /* istanbul ignore if */
    if (!VueI18n.availabilities.dateTimeFormat) {
      warn('Cannot format a Date value due to not supported Intl.DateTimeFormat.');
      return ''
    }

    if (!key) {
      return new Intl.DateTimeFormat(locale).format(value)
    }

    var ret =
      this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to datetime localization of root: key '" + key + "'."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n.d(value, key, locale)
    } else {
      return ret || ''
    }
  };

  VueI18n.prototype.d = function d (value) {
      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    var locale = this.locale;
    var key = null;

    if (args.length === 1) {
      if (typeof args[0] === 'string') {
        key = args[0];
      } else if (isObject(args[0])) {
        if (args[0].locale) {
          locale = args[0].locale;
        }
        if (args[0].key) {
          key = args[0].key;
        }
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        key = args[0];
      }
      if (typeof args[1] === 'string') {
        locale = args[1];
      }
    }

    return this._d(value, locale, key)
  };

  VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
    return looseClone(this._vm.numberFormats[locale] || {})
  };

  VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
    this._vm.$set(this._vm.numberFormats, locale, format);
  };

  VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
    this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
  };

  VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
    value,
    locale,
    fallback,
    numberFormats,
    key,
    options
  ) {
    var _locale = locale;
    var formats = numberFormats[_locale];

    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + fallback + "' number formats from '" + locale + "' number formats."));
      }
      _locale = fallback;
      formats = numberFormats[_locale];
    }

    if (isNull(formats) || isNull(formats[key])) {
      return null
    } else {
      var format = formats[key];

      var formatter;
      if (options) {
        // If options specified - create one time number formatter
        formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
      } else {
        var id = _locale + "__" + key;
        formatter = this._numberFormatters[id];
        if (!formatter) {
          formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
        }
      }
      return formatter
    }
  };

  VueI18n.prototype._n = function _n (value, locale, key, options) {
    /* istanbul ignore if */
    if (!VueI18n.availabilities.numberFormat) {
      {
        warn('Cannot format a Number value due to not supported Intl.NumberFormat.');
      }
      return ''
    }

    if (!key) {
      var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
      return nf.format(value)
    }

    var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
    var ret = formatter && formatter.format(value);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to number localization of root: key '" + key + "'."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
    } else {
      return ret || ''
    }
  };

  VueI18n.prototype.n = function n (value) {
      var args = [], len = arguments.length - 1;
      while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    var locale = this.locale;
    var key = null;
    var options = null;

    if (args.length === 1) {
      if (typeof args[0] === 'string') {
        key = args[0];
      } else if (isObject(args[0])) {
        if (args[0].locale) {
          locale = args[0].locale;
        }
        if (args[0].key) {
          key = args[0].key;
        }

        // Filter out number format options only
        options = Object.keys(args[0]).reduce(function (acc, key) {
            var obj;

          if (numberFormatKeys.includes(key)) {
            return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
          }
          return acc
        }, null);
      }
    } else if (args.length === 2) {
      if (typeof args[0] === 'string') {
        key = args[0];
      }
      if (typeof args[1] === 'string') {
        locale = args[1];
      }
    }

    return this._n(value, locale, key, options)
  };

  VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
    /* istanbul ignore if */
    if (!VueI18n.availabilities.numberFormat) {
      {
        warn('Cannot format to parts a Number value due to not supported Intl.NumberFormat.');
      }
      return []
    }

    if (!key) {
      var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
      return nf.formatToParts(value)
    }

    var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
    var ret = formatter && formatter.formatToParts(value);
    if (this._isFallbackRoot(ret)) {
      if (!this._isSilentTranslationWarn(key)) {
        warn(("Fall back to format number to parts of root: key '" + key + "' ."));
      }
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      return this._root.$i18n._ntp(value, locale, key, options)
    } else {
      return ret || []
    }
  };

  Object.defineProperties( VueI18n.prototype, prototypeAccessors );

  var availabilities;
  // $FlowFixMe
  Object.defineProperty(VueI18n, 'availabilities', {
    get: function get () {
      if (!availabilities) {
        var intlDefined = typeof Intl !== 'undefined';
        availabilities = {
          dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
          numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
        };
      }

      return availabilities
    }
  });

  VueI18n.install = install;
  VueI18n.version = '8.15.5';

  return VueI18n;

})));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
   __webpack_require__(7),
    __webpack_require__(8)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    EventBus,
    Events
){
    return {
        data: function(){
            return {
                isPageReady: false
            };
        },
        mounted: function(){
            var _this = this;
            EventBus.$on(Events.PageReady, function(){
                _this.isPageReady = true;
            });
        },
        destroy: function(){
            EventBus.$off(Events.PageReady);
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(14),
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Auth,
    EventBus,
    Events,
    Utils
){
    return {
        data: function(){
            return {
                auth: {
                    user: Auth.getUser(),
                    member: Auth.getMember(),
                    memberLink: Utils.genPageLink('/member')
                }
            };
        },
        computed: {
            isLoggedIn: function(){
                console.log(this.auth.user.login)
                return this.auth.user.login;
            }
        },
        methods: {
            fetchMemberInfo: Auth.fetchMemberInfo,
            logout: Auth.logout
        },
        created: function(){
            var _this = this;
            EventBus.$on(Events.UpdateMemberInfo, function(member){
                _this.auth.member = member;
                // console.log(_this.auth);
            });
        },
        destroy: function(){
            EventBus.$off(Events.UpdateMemberInfo);
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(5),
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Api,
    EventBus,
    Events,
    Utils
){
    var user = window.FNJISite?window.FNJISite.user:{};
    var member = {};
    function fetchMemberInfo(){
        if (!user.login){
            member = {};
            emitMemberInfo();
            return;
        }
        Api.getMemberInfoApi.ajax()
            .done(function(data){
                member = data;
                emitMemberInfo();
            });
    }
    function emitMemberInfo(){
        EventBus.$emit(Events.UpdateMemberInfo, member);
    }
    function getMember(){
        return member;
    }
    function getUser(){
        return user;
    }
    function isLoggedIn(){
        return !!user.login;
    }

    function loginRedirect(from){
        console.log(from)
        from = from || Utils.getUrlParam('from') || location.href;
        // window.location.href = decodeURIComponent(from);
        window.location.href = from;

        setTimeout(function () {
            window.location.reload();
        }, 100);

    }
    function login(info, from){
        Api.loginApi.ajax({data_json: JSON.stringify(info)})
            .done(function(){
                loginRedirect(from);
            });
    }
    function logout(){
        Api.logoutApi.ajax()
            .done(function(){
                window.location.reload();
            });
    }

    return {
        fetchMemberInfo: fetchMemberInfo,
        getMember: getMember,
        getUser: getUser,
        isLoggedIn: isLoggedIn,
        loginRedirect: loginRedirect,
        login: login,
        logout: logout
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports) {

/*
 * jQuery BBQ: Back Button & Query Library - v1.3pre - 8/26/2010
 * http://benalman.com/projects/jquery-bbq-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($,r){var h,n=Array.prototype.slice,t=decodeURIComponent,a=$.param,j,c,m,y,b=$.bbq=$.bbq||{},s,x,k,e=$.event.special,d="hashchange",B="querystring",F="fragment",z="elemUrlAttr",l="href",w="src",p=/^.*\?|#.*$/g,u,H,g,i,C,E={};function G(I){return typeof I==="string"}function D(J){var I=n.call(arguments,1);return function(){return J.apply(this,I.concat(n.call(arguments)))}}function o(I){return I.replace(H,"$2")}function q(I){return I.replace(/(?:^[^?#]*\?([^#]*).*$)?.*/,"$1")}function f(K,P,I,L,J){var R,O,N,Q,M;if(L!==h){N=I.match(K?H:/^([^#?]*)\??([^#]*)(#?.*)/);M=N[3]||"";if(J===2&&G(L)){O=L.replace(K?u:p,"")}else{Q=m(N[2]);L=G(L)?m[K?F:B](L):L;O=J===2?L:J===1?$.extend({},L,Q):$.extend({},Q,L);O=j(O);if(K){O=O.replace(g,t)}}R=N[1]+(K?C:O||!N[1]?"?":"")+O+M}else{R=P(I!==h?I:location.href)}return R}a[B]=D(f,0,q);a[F]=c=D(f,1,o);a.sorted=j=function(J,K){var I=[],L={};$.each(a(J,K).split("&"),function(P,M){var O=M.replace(/(?:%5B|=).*$/,""),N=L[O];if(!N){N=L[O]=[];I.push(O)}N.push(M)});return $.map(I.sort(),function(M){return L[M]}).join("&")};c.noEscape=function(J){J=J||"";var I=$.map(J.split(""),encodeURIComponent);g=new RegExp(I.join("|"),"g")};c.noEscape(",/");c.ajaxCrawlable=function(I){if(I!==h){if(I){u=/^.*(?:#!|#)/;H=/^([^#]*)(?:#!|#)?(.*)$/;C="#!"}else{u=/^.*#/;H=/^([^#]*)#?(.*)$/;C="#"}i=!!I}return i};c.ajaxCrawlable(0);$.deparam=m=function(L,I){var K={},J={"true":!0,"false":!1,"null":null};$.each(L.replace(/\+/g," ").split("&"),function(O,T){var N=T.split("="),S=t(N[0]),M,R=K,P=0,U=S.split("]["),Q=U.length-1;if(/\[/.test(U[0])&&/\]$/.test(U[Q])){U[Q]=U[Q].replace(/\]$/,"");U=U.shift().split("[").concat(U);Q=U.length-1}else{Q=0}if(N.length===2){M=t(N[1]);if(I){M=M&&!isNaN(M)?+M:M==="undefined"?h:J[M]!==h?J[M]:M}if(Q){for(;P<=Q;P++){S=U[P]===""?R.length:U[P];R=R[S]=P<Q?R[S]||(U[P+1]&&isNaN(U[P+1])?{}:[]):M}}else{if($.isArray(K[S])){K[S].push(M)}else{if(K[S]!==h){K[S]=[K[S],M]}else{K[S]=M}}}}else{if(S){K[S]=I?h:""}}});return K};function A(K,I,J){if(I===h||typeof I==="boolean"){J=I;I=a[K?F:B]()}else{I=G(I)?I.replace(K?u:p,""):I}return m(I,J)}m[B]=D(A,0);m[F]=y=D(A,1);$[z]||($[z]=function(I){return $.extend(E,I)})({a:l,base:l,iframe:w,img:w,input:w,form:"action",link:l,script:w});k=$[z];function v(L,J,K,I){if(!G(K)&&typeof K!=="object"){I=K;K=J;J=h}return this.each(function(){var O=$(this),M=J||k()[(this.nodeName||"").toLowerCase()]||"",N=M&&O.attr(M)||"";O.attr(M,a[L](N,K,I))})}$.fn[B]=D(v,B);$.fn[F]=D(v,F);b.pushState=s=function(L,I){if(G(L)&&/^#/.test(L)&&I===h){I=2}var K=L!==h,J=c(location.href,K?L:{},K?I:2);location.href=J};b.getState=x=function(I,J){return I===h||typeof I==="boolean"?y(I):y(J)[I]};b.removeState=function(I){var J={};if(I!==h){J=x();$.each($.isArray(I)?I:arguments,function(L,K){delete J[K]})}s(J,2)};e[d]=$.extend(e[d],{add:function(I){var K;function J(M){var L=M[F]=c();M.getState=function(N,O){return N===h||typeof N==="boolean"?m(L,N):m(L,O)[N]};K.apply(this,arguments)}if($.isFunction(I)){K=I;return J}else{K=I.handler;I.handler=J}}})})(jQuery,this);
/*
 * jQuery hashchange event - v1.3 - 7/21/2010
 * http://benalman.com/projects/jquery-hashchange-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
/*(function($,e,b){var c="hashchange",h=document,f,g=$.event.special,i=h.documentMode,d="on"+c in e&&(i===b||i>7);function a(j){j=j||location.href;return"#"+j.replace(/^[^#]*#?(.*)$/,"$1")}$.fn[c]=function(j){return j?this.bind(c,j):this.trigger(c)};$.fn[c].delay=50;g[c]=$.extend(g[c],{setup:function(){if(d){return false}$(f.start)},teardown:function(){if(d){return false}$(f.stop)}});f=(function(){var j={},p,m=a(),k=function(q){return q},l=k,o=k;j.start=function(){p||n()};j.stop=function(){p&&clearTimeout(p);p=b};function n(){var r=a(),q=o(m);if(r!==m){l(m=r,q);$(e).trigger(c)}else{if(q!==m){location.href=location.href.replace(/#.*!/,"")+q}}p=setTimeout(n,$.fn[c].delay)}$.browser.msie&&!d&&(function(){var q,r;j.start=function(){if(!q){r=$.fn[c].src;r=r&&r+a();q=$('<iframe tabindex="-1" title="empty"/>').hide().one("load",function(){r||l(a());n()}).attr("src",r||"javascript:0").insertAfter("body")[0].contentWindow;h.onpropertychange=function(){try{if(event.propertyName==="title"){q.document.title=h.title}}catch(s){}}}};j.stop=k;o=function(){return a(q.location.href)};l=function(v,s){var u=q.document,t=$.fn[c].domain;if(v!==s){u.title=h.title;u.open();t&&u.write('<script>document.domain="'+t+'"<\/script>');u.close();q.location.hash=v}}})();return j})()})(jQuery,this);*/


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    // var BaseUrl = 'https://fnji.com';
    var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        // ridgeListApi: new Api('/m/s/SiteIndexEntity/ridge'),//山脊线产品（高端线）
        // earthListApi: new Api('/m/s/SiteIndexEntity/earth'),//大地线产品（高端线）
        // highListApi: new Api('/s/product-list/getLineProducts'),//高端线产品
        getIndexImagesApi: new Api('/m/s/SiteIndexEntity/getIndexImages'),//首页图片

        switchZhEnApi: new Api('/m/s/SiteIndexEntity/switchZhEn')//中英文切换
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(65);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fangzheng.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fangzheng.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(89);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./common.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./common.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(11),
    __webpack_require__(20),
    __webpack_require__(21)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Vue,
    VueI18n,
    zh,en
){
    Vue.use(VueI18n);

    var i18n = new VueI18n({
        //设置默认语言
        locale: localStorage.getItem('locale')||'zh',//语言标识
        //添加多语言（每一种语言对应一个语言文件）
        messages: {
            zh:zh,//中文
            en:en//英文
        }
    });
    //暴露i18n
    return i18n;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){
    var zh = {
        detail: {name: '案例展示'},
        topBarLinks: [
            {name: '上海客厅预约', class: 'sh-appoint'},

            // {name: '如何购买', link: '/shop'},
            // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
            {name: '联系我们', link: '/site/cooperate'}
        ],
        headLeft: {
            brand: '品牌',
            crest: '山脊线',
            earth: '大地线',
            ff: 'FF线',
            register: '注册',
            login: '登录',
            logout: '注销',
            cart: '购物车',
            order: '订单'
        },
        // navMenu: [
        //     {name: '首页', link: '/', menu: []},
        //     {name: '家具', link: '',category: '1',
        //         menu: [{name: '全部',link: '/furniture?tab=all'},
        //                 {name: '椅',link: '/furniture?tab=all#chair'},
        //                 {name: '桌',link: '/furniture?tab=all#desk'},
        //                 {name: '床',link: '/furniture?tab=all#bed'},
        //                 {name: '几',link: '/furniture?tab=all#lowtable'},
        //                 {name: '柜',link: '/furniture?tab=all#cab'},
        //                 {name: '沙发',link: '/furniture?tab=all#sofa'},
        //                 {name: '一枚板',link: '/furniture?tab=all#ymb'},
        //                 {name: '其他',link: '/furniture?tab=all#other'},
        //             ],
        //         newMenu: [{name: '大地线',link: '/furniture-l2?bom=base'},
        //             {name: '山脊线',link: '/furniture-l2?bom=high'},
        //             {name: 'FF线',link: '/furniture-l2?bom=ff'}
        //         ]},
        //     {name: '家居', link: '',category: '2', menu:
        //             [{name: '全部',link: '/grocery?tab=all'},
        //                 {name: '灯具',link: '/grocery-l2?bom=C01-11'},
        //                 {name: '家纺',link: '/grocery-l2?bom=C01-12'},
        //                 {name: '餐厨用品',link: '/grocery-l2?bom=C01-13'},
        //                 {name: '收纳杂物',link: '/grocery-l2?bom=C01-14'},
        //                 {name: '香氛洗护',link: '/grocery-l2?bom=C01-15'},
        //                 {name: '装饰',link: '/grocery-l2?bom=C01-16'},
        //                 {name: '家居电器',link: '/grocery-l2?bom=C01-17'},
        //                 {name: '户外园艺',link: '/grocery-l2?bom=C01-18'},
        //                 {name: '文创',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: '艺术', link: '/gallery', menu:
        //             [
        //                 // {name:"艺术家", link:"/gallery#artist"},
        //                 // {name:"作品", link:"/gallery#works"},
        //                 // {name:"展览", link:"/gallery#exhibit"}
        //             ]},
        //     {name: '栏目', link: '',menu: [
        //             {name:"全部", link:"/home"},
        //             {name:"梵几在家", link:"/home#home"},
        //             {name:"串门", link:"/home#drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     {name: '关于梵几', link: '/fnjinews', menu: []},
        //     {name: '如何购买', link: '/buyChannel', menu: []}
        // ],
        // navMenu: [
        //     {name: '首页', link: '/', menu: []},
        //     {name: '家具', link: '',category: '1',
        //          menu: [{name: '全部',link: '/furniture?tab=all'},
        //                 {name: '椅',link: '/furniture?tab=all#chair'},
        //                 {name: '桌',link: '/furniture?tab=all#desk'},
        //                 {name: '床',link: '/furniture?tab=all#bed'},
        //                 {name: '几',link: '/furniture?tab=all#lowtable'},
        //                 {name: '柜',link: '/furniture?tab=all#cab'},
        //                 {name: '沙发',link: '/furniture?tab=all#sofa'},
        //                 {name: '一枚板',link: '/furniture?tab=all#ymb'},
        //                 {name: '其他',link: '/furniture?tab=all#other'},
        //             ],
        //          newMenu: [{name: '新品',link: '/furniture-l2?bom=recommend'},
        //                  {name: '大地线',link: '/furniture-l2?bom=base'},
        //                  {name: '山脊线',link: '/furniture-l2?bom=high'},
        //                  {name: 'FF线',link: '/furniture-l2?bom=ff'},
        //                  // {name: '回顾',link: '/furniture-l2?bom=ff'}
        //              ]},
        //     {name: '家居', link: '',category: '2', menu:
        //             [{name: '全部',link: '/grocery?tab=all'},
        //                 {name: '灯具',link: '/grocery-l2?bom=C01-11'},
        //                 {name: '家纺',link: '/grocery-l2?bom=C01-12'},
        //                 {name: '餐厨用品',link: '/grocery-l2?bom=C01-13'},
        //                 {name: '收纳杂物',link: '/grocery-l2?bom=C01-14'},
        //                 {name: '香氛洗护',link: '/grocery-l2?bom=C01-15'},
        //                 {name: '装饰',link: '/grocery-l2?bom=C01-16'},
        //                 {name: '家居电器',link: '/grocery-l2?bom=C01-17'},
        //                 {name: '户外园艺',link: '/grocery-l2?bom=C01-18'},
        //                 {name: '文创',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: 'ART', link: '/gallery', menu:
        //             [
        //                 // {name:"展览", link:"/gallery#artist"},
        //                 // {name:"橱窗", link:"/gallery#works"},
        //                 // {name:"快闪", link:"/gallery#exhibit"}
        //             ]},
        //     {name: 'JOURNAL', link: '',menu: [
        //             {name:"全部", link:"/home"},
        //             {name:"梵几在家", link:"/home-athome"},
        //             {name:"串门", link:"/home-drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     // {name: 'PROJECT', link: '',menu: []},
        //     {name: '关于梵几', link: '/fnjinews', menu: []},
        //     {name: '如何购买', link: '/buyChannel', menu: []}
        // ],
        navMenu: [
            {name: '首页', link: '/', children: []},
            {name: '家具', link: '/furniture?tab=C09',category: '1', children: []},
            {name: '家居', link: '/grocery?tab=G01',category: '2', children: []},
            {name: '案例', link: '/caseNew', children: [
                    {name: '梵几在家',link: '/athome',type: 1},
                    {name: '商业',link: '/project',type: 2}
                ]},
            {name: '实体展厅', link: '/shops', children: [
                    {name: '北京·梵几三里屯太古里店',phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {name: '北京·梵几颐堤港店',phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                    {name: '北京·梵几客厅国子监店（升级中）',phoneTitle: '国子监店（升级中）',phoneName: '',link: '/exhibitionhall?id=4',type: 1},
                    {name: '上海·梵几上海前滩太古里店',phoneTitle: '上海',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                    {name: '上海·梵几客厅武康路店',phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                    {name: '广州·梵几广州粤海天地店',phoneTitle: '广州',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                    {name: '深圳·梵几万象前海店',phoneTitle: '深圳',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                    {name: '深圳·梵几卓越中心店',phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                    // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                    {name: '杭州·梵几留和路店',phoneTitle: '杭州',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                    {name: '苏州·梵几苏州诚品店',phoneTitle: '苏州',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                    // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                    {name: '南京·梵几南京金鹰世界店',phoneTitle: '南京',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                    {name: '成都·梵几成都富森店',phoneTitle: '成都',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                    {name: '西安·梵几西安万象城店',phoneTitle: '西安',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                ]},
            {name: '艺术/栏目', link: '/gallery', children: [
                    {name: '艺术展览·艺术橱窗·艺术快闪',link: '/gallery',type: 1,phoneChildren: [
                            {name: '艺术展览',link: '/gallery'},
                            {name: '艺术橱窗',link: '/gallery'},
                            {name: '艺术快闪',link: '/gallery'}
                        ]},
                    {name: '串门',link: '/home-drop',type: 2}
                ]},
            // {name: '栏目', link: '/home'},
            {name: '关于梵几', link: '/fnjinews', children: []},
            {name: '下载区', link: '/download', children: [
                    {name: '产品模型',link: '/download',type: 1},
                    {name: '产品册',link: '/catalog',type: 2},
                ]},
            {name: '如何购买', link: '/buyChannel', children: []}
        ],
        footerNew: [
            {name: '媒体报道', link: '/fnjimedia'},
            {name: '招聘信息', link: '/job'},
            {name: '售后服务', link: '/aboutservice'},
            {name: '联系我们', link: '/site/cooperate?type=1'}
        ],
        menuGroups: [
            {
                title: '关于我们',
                list: [
                    {name: '关于梵几', link: '/fnjinews'},
                    {name: '如何购买', link: '/buyChannel'},
                    {name: '媒体报道', link: '/fnjimedia'},
                    {name: '招聘信息', link: '/job'}
                ]
            },
            {
                title: '购物指南',
                list: [
                    {name: '购物流程', link: '/howshop'},
                    {name: '会员制度', link: '/membership'}
                ]
            },
            {
                title: '关于配送',
                list: [
                    {name: '家具配送', link: '/aboutdeliver?index=0'},
                    {name: '家居配送', link: '/aboutdeliver?index=1'},
                    {name: '一枚板配送', link: '/aboutdeliver?index=2'}
                ]
            },
            {
                title: '售后服务',
                list: [
                    {name: '家具售后', link: '/aboutservice?index=0'},
                    {name: '家居售后', link: '/aboutservice?index=1'}
                ]
            },
            {
                title: '联系我们',
                list: [
                    {name: '项目批量采购', link: '/site/cooperate?type=1'},
                    {name: '设计公司合作', link: '/site/cooperate?type=2'},
                    {name: '家居品牌合作', link: '/site/cooperate?type=3'},
                    {name: '市场&媒体合作', link: '/site/cooperate?type=4'},
                    {name: '艺术品合作', link: '/site/cooperate?type=5'},
                    {name: '产品目录下载', link: '/temp/upload/productinfo/产品目录.zip'}
                ]
            }
        ],
        fnjiIndexNew: {
            aboutFnji: '关于梵几',
            // aboutFnjiCon: '“生长于野，安于室”是梵几扎根东方土壤的理念传达，取自然之材，拟自然之态，使其共生与传承。',
            // aboutFnjiCon2: '梵几希望在设计与生活、东方与西方、现代与未来之间找到一种平衡，将自然带入居家空间中，',
            // aboutFnjiCon3: '并成为人们日常生活里的长久陪伴。',
            aboutFnjiCon: '梵几创立于2010年，是集家具与家居为一体的生活美学品牌。“梵”是净空与安静的意思，“几”是家具，',
            aboutFnjiCon2: '意为净空安静的家具，同时梵几的谐音是“凡几”一平凡的家具。“东方现代，自然隽永”是品牌的关键词，',
            aboutFnjiCon3: '是梵几扎根东方土壤、不断探索美学生活的理念和坚持。“生长于野，安于室”，取自然之材，拟自然之态。',
            aboutFnjiCon4: '梵几坚持以木为主体，融合皮、羊毛、石材等多种自然材质，将取诸山野的灵气回归日常生活之中。',
            aboutFnjiBt: '更多关于梵几',
            furnitureTitle: '家具',
            furniture: '梵几家具围绕生野安室的理念，融合深沉肃穆、简单质朴、现代多元等多种设计语言',
            furniture2: '探索东方与西方之间、现代与传统之间、记忆与未来之间的美学平衡与灵感世界',
            earth: '大地线',
            earthInfo: '简练淳厚  如无垠大地',
            crest: '山脊线',
            crestInfo: '沉穆缥缈，如云上山影',
            fnjiFore: 'FF线',
            fnjiForeInfo: '探索中国未来生活的可能',
            moreFur: '更多家具',
            fnjiathome: '梵几在家',
            fnjiathomeCon: '为了深入探索家具主人的生活态度，观察家具与人',
            fnjiathomeCon2: '人与人之间的亲密连结，梵几自制栏目“梵几在家”',
            fnjiathomeCon3: '从不同维度出发，讲述家具，设计与人的故事',
            cooperation: '商业',
            cooperationCon: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度',
            cooperationCon2: '与无限可能性。',
            furnishings: '家居',
            homeCon: '甄选源自全球的家居好物，用充盈细节点缀家中空间，勾勒质感生活的完满形态',
            homeCon2: '将梵几认可、推崇的生活美学体系更加极致地呈现出来',
            moreHome: '更多家居',
            artTitle: '艺术/栏目',
            artCon: 'ART包含艺术展览、艺术橱窗以及快闪等多个艺术相关活动',
            artCon2: '梵几拓展传统艺术的界限，挖掘艺术的无限可能性，让观众感知以不同载体呈现的艺术',
            artCon3: '并带领他们进入无限遐想的艺术世界',
            moreInfo: '更多详情',
            journalCon: '为了深入探索家具主人的生活态度，观察家具与人、人与人之间的亲密连结，梵几自制栏目“梵几在家”、“串门”，',
            journalCon2: '从不同维度出发，讲述家具，设计与人的故事。',
            projectCon: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度',
            projectCon2: '与无限可能性。',
            morePro: '更多项目',
            howtobuy: '如何购买',
            lineStore: '线上店铺',
            lineStores: '| 天猫 | 京东 | 微信小程序 |',
            phyStore: '实体门店',
            phyStores: ['北京','上海','广州','深圳','成都','杭州','苏州','南京'],
            aboutAllBt: '查看全部购买方式',
            footerInfo: '探寻东方与西方之间',
            footerInfo2: '现代与传统之间',
            footerInfo3: '记忆与未来之间的美学平衡与灵感世界'
        },
        fnjiIndexPhoneNew: {
            // aboutFnjiCon: '“生长于野，安于室”是梵几扎根东方土壤的理念传',
            // aboutFnjiCon2: '达，取自然之材，拟自然之态，使其共生与传承。梵',
            // aboutFnjiCon3: '几希望在设计与生活、东方与西方、现代与未来之间',
            // aboutFnjiCon4: '找到一种平衡，将自然带入居家空间中，并成为人们',
            // aboutFnjiCon5: '日常生活里的长久陪伴。',
            aboutFnjiCon: '梵几创立于2010年，是集家具与家居为一体的生活美学',
            aboutFnjiCon2: '品牌。“梵”是净空与安静的意思，“几”是家具，意为净',
            aboutFnjiCon3: '空安静的家具，同时梵几的谐音是“凡几”一平凡的家具。',
            aboutFnjiCon4: '“东方现代，自然隽永”是品牌的关键词，是梵几扎根东',
            aboutFnjiCon5: '方土壤、不断探索美学生活的理念和坚持。“生长于野，',
            aboutFnjiCon6: '安于室”，取自然之材，拟自然之态。梵几坚持以木为主',
            aboutFnjiCon7: '体，融合皮、羊毛、石材等多种自然材质，将取诸山野的',
            aboutFnjiCon8: '灵气回归日常生活之中。',
            furniture: '梵几家具围绕生野安室的理念，融合深沉肃',
            furniture2: '穆、简单质朴、现代多元等多种设计语言，探',
            furniture3: '索东方与西方之间、现代与传统之间、记忆与',
            furniture4: '未来之间的美学平衡与灵感世界',
            homeCon: '甄选源自全球的家居好物，用充盈细节点缀家',
            homeCon2: '中空间，勾勒质感生活的完满形态，将梵几认',
            homeCon3: '可、推崇的生活美学体系更加极致地呈现出来',
            fnjiathomeCon: '为了深入探索家具主人的生活态度，观察家具与人',
            fnjiathomeCon2: '人与人之间的亲密连结，梵几自制栏目“梵几在家”',
            fnjiathomeCon3: '从不同维度出发，讲述家具，设计与人的故事',
            cooperationCon: '梵几与商业空间、设计师及',
            cooperationCon2: '主理人产生联动，在不同风格中共同演绎',
            cooperationCon3: '梵几家具的包容度与无限可能性。',

            fnjiAtHomeDesc:'为了深入探索家具主人的生活态度，观察家具与人\n' +
                '人与人之间的亲密连结，梵几自制栏目“梵几在家”\n' +
                '从不同维度出发，讲述家具，设计与人的故事',

            fnjiProjectDesc: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度\n' +
                '与无限可能性。',
            fnjiProject: '商业',

            EXHIBITION: '展览',
            EXHIBITION2: 'EXHIBITION',
            ARTSTAGE: '橱窗',
            ARTSTAGE2: 'ART STAGE',
            STORE: '快闪店',
            STORE2: 'POP-UP STORE',
            artCon: 'ART包含艺术展览、艺术橱窗以及快闪等多个',
            artCo2: '艺术相关活动梵几拓展传统艺术的界限，挖掘',
            artCon3: '艺术的无限可能性，让观众感知以不同载体呈',
            artCon4: '现的艺术，并带领他们进入无限遐想的艺术世',
            artCon5: '界。',
            journalCon: '为了深入探索家具主人的生活态度，观察家具',
            journalCon2: '与人、人与人之间的亲密连结，梵几自制栏目',
            journalCon3: '“梵几在家”、“串门”，从不同维度出发，',
            journalCon4: '讲述家具，设计与人的故事。',
            projectCon: '梵几与商业空间、设计师及主理人产生联动，',
            projectCon2: '在不同风格中共同演绎梵几家具的包容度与无',
            projectCon3: '限可能性。',
        },
        aboutFnjiNew: {
            titleOne: '记忆',
            titleTwo: '传承',
            titleThree: '自然',
            titleFour: '隽永',
            memory: '梵几的设计灵感源于对中国文化与传统生活的感知，将东方韵味与哲思凝练于设计中。把中国人的共同记',
            memory2: '忆和文化共鸣以符合现代生活方式的设计语言传达出来，让记忆中逐渐消逝的过去，以新的方式长久地存',
            memory3: '在于当今人们的生活中，留住记忆里的烟火气。',
            productsImg: [
                {img:'s20480_1627452972_1499.png',name: '竹椅',ename: ' BAMBOO CHAIR',info1: '以木代替竹子，外形经过提炼与简化，线条呈现粗细变化，简洁质朴中流动着',info2: '中式意蕴，是梵几品牌的开端。'},
                {img:'s20480_1627452940_9411.png',name: '团扇屏风',ename: ' CIRCULAR FAN SCREEN',info1: '木与藤虚实交错，空气流转之间，让传统中式元素融入现代的空间动线和生活方式，',info2: '空间隔断不再是一种切割，而是成为一种人与人之间既可交流、又相互独立的关系。'},
                {img:'s20480_1627452916_7972.png',name: '胡同推车',ename: ' LITTLE CART',info1: '以中国传统的竹推车为灵感依托，用中式特有的设计语言回归记忆中最质朴的',info2: '空间需求，不为家具功能所限定，灵活适用于家中的各个空间和场景。'},
                {img:'s20480_1627452875_7826.png',name: '线轴几',ename: ' REEL SIDE TABLE',info1: '细腻变化的自然石材肌理形成更加丰富的触感，',info2: '高低错落组合衬出独具灵气的东方美。'},
                {img:'s20480_1627452846_8757.png',name: 'CIGAR置物架',ename: ' CIGAR DISPLAY SHELF',info1: '取竹编簸箕架之形，又灌之以现代设计的巧思，四个方向均可拿取和展示物',info2: '品，纵横交错中勾勒出重叠的美感。'},
                {img:'s20480_1627452815_5473.png',name: '马扎',ename: ' CAMPSTOOL',info1: '圆滑细腻的木质架构形成可随身提携的拎手，色泽温润的植鞣坐面注入时间的',info2: '自然印记。'},
                {img:'s20480_1627452661_7271.png',name: '鸟笼立柜',ename: ' CAGE CABINET',info1: '参照鸟笼的笼体，厚实且造型独特的木条温润包围，柔和灯光中呈现虚实互通',info2: '的视觉体系。'}
            ],
            inheritance: '传承中国传统工艺，通过木工匠人的亲手打磨，保留木材原生纹理与质感。为了在结构、性能和感官上凝',
            inheritance2: '聚最佳的体验，每一道工艺都承载着梵几追寻的情感表达。是对中国传统技艺的传承与保护，也是对设计',
            inheritance3: '的极致追求。',
            nature: '人与自然的亲近感是与生俱来的，契合“生于野，安于室”的本质，坚持以实木为主体，融合皮、羊毛、',
            nature2: '石材等多种自然材质，将取诸山野的灵气回归日常生活之中。甄选世界级品牌进口材料，保障安全与环',
            nature3: '保的同时经久耐用。',
            timeLess: '什么才是真正属于中国的设计——是梵几一直以来的思考与探索。',
            timeLess2: '每一个设计背后，都隐藏着对自然万物与人文艺术的大爱与珍视。',
            events: '梵几事件',
            commercials: '历年广告回顾',
            commercialsInfo: '十年间，除了探寻自身产品的可能性，我们也同样思考产品多样的视觉呈现。这是梵几对艺术美感的思考，也同样是',
            commercialsInfo2: '品牌精神的表达。梵几希望，在东方与西方之间，当代与传统之间，记忆与未来之间，取得一种平衡，进而探索属于',
            commercialsInfo3: '中国人未来的家具。',
            designer: '梵几设计师'
        },
        aboutFnjiPhoneNew: {
            memory: '梵几的设计灵感源于对中国文化与传统生活',
            memory2: '的感知，将东方韵味与哲思凝练于设计中。',
            memory3: '把中国人的共同记忆和文化共鸣以符合现代',
            memory4: '生活方式的设计语言传达出来，让记忆中逐',
            memory5: '渐消逝的过去，以新的方式长久地存在于当',
            memory6: '今人们的生活中，留住记忆里的烟火气。',
            inheritance: '传承中国传统工艺，通过木工匠人的亲手',
            inheritance2: '打磨，保留木材原生纹理与质感。为了在',
            inheritance3: '结构、性能和感官上凝聚最佳的体验，每',
            inheritance4: '一道工艺都承载着梵几追寻的情感表达。',
            inheritance5: '是对中国传统技艺的传承与保护，也是对',
            inheritance6: '设计的极致追求。',
            nature: '人与自然的亲近感是与生俱来的，契合“生',
            nature2: '于野，安于室”的本质，坚持以实木为主体，',
            nature3: '融合皮、羊毛、石材等多种自然材质，将取',
            nature4: '诸山野的灵气回归日常生活之中。甄选世界',
            nature5: '级品牌进口材料，保障安全与环保的同时经',
            nature6: '久耐用。',
            timeLess: '什么才是真正属于中国的设计——是梵几一',
            timeLess2: '直以来的思考与探索。',
            timeLess3: '每一个设计背后，都隐藏着对自然万物与人',
            timeLess4: '文艺术的大爱与珍视。',
            commercialsInfo: '十年间，除了探寻自身产品的可能性，我们也',
            commercialsInfo2: '同样思考产品多样的视觉呈现。这是梵几对艺',
            commercialsInfo3: '术美感的思考，也同样是品牌精神的表达。梵',
            commercialsInfo4: '几希望，在东方与西方之间，当代与传统之间，',
            commercialsInfo5: '记忆与未来之间，取得一种平衡，进而探索属',
            commercialsInfo6: '于中国人未来的家具。',
        },
        artInfoNew: {

            artTypeList: [
                {id: '100',artType: '艺术展览',info: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
                    infoPhone1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',infoPhone2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。'},
                {id: '101',artType: '艺术橱窗',info: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……',
                    infoPhone2: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……'},
                {id: '102',artType: '艺术快闪',info: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
                    infoPhone2: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。'},
            ],
        },
        moreBtn: '查看更多',
        fnjiIndex: {
            aboutFnjiLogo: '/view-v2/web/static/img/index/fnji_about.png',
            indexFurnitureLogo: '/view-v2/web/static/img/index/fnji_furture.png',
            indexGroLogo: '/view-v2/web/static/img/index/fnji_gro_zh.png',
            indexArtLogo: '/view-v2/web/static/img/index/fnji_art.png',
            indexColumnLogo: '/view-v2/web/static/img/index/fnji_column_zh.png',
            indexHowBuyLogo: '/view-v2/web/static/img/index/fnji_how_buy_zh.png',

            aboutFnjiCon: '传承中国传统工艺，甄选优质自然材质，凝练记忆中的灵感，用世界级严苛标准，创造真正属于中国人的家具。',
            aboutFnjiBt: '了解更多梵几',
            aboutBt: '了解更多',
            aboutAllBt: '查看全部购买方式',
            furnitureLine: '| 山脊线 | 大地线 | FF线 |',
            crestInfo: '梵几山脊线系列的灵感来源于大自然以及儿时记忆，扎根中国传统文化，将更具东方空灵艺术性的元素融合深沉肃穆的设计语言。以螳螂椅为首款产品，历时3年，从设计、结构到工艺，不断推敲升级，采用大曲线，多细节的实木加工，配合国际品牌的面料，突出现代中国家具的雕塑感，艺术感以及为生活带来仪式感。',
            earthInfo: '梵几大地线，品牌中最早的一条线，关注寻常人家生活中真实所需的家居设计，简单质朴，在葆有中国的设计语言的基础上，将大自然中的树木变为与家相融的家具，在四季更迭中长久陪伴，慢慢变成我们的家人。',
            ffInfo: 'FF=Fnji Fore，代表梵几向前一步，是梵几品牌全新实验性的产品线。有别于延续传统工艺探索的设计，FF系列在设计语言上更为简洁直接， 以多元材质和工艺结合赋予家具更多可能，现代简约而不失温度感。',
            groceryInfo: '家居馆延续生野安室的理念，用挑剔的品位甄选源自全球的家居好物。',
            groceryInfo2: '美好家居品可以提升幸福感，增加仪式感，与家具完美搭配，亦是过节送礼的佳选。',
            groceryInfo3: '更重要的是，它们将梵几认可、推崇的生活美学体系更加极致地呈现出来。',
            galleryInfo: '梵几艺术画廊包含艺术展览、艺术橱窗以及快闪等多个艺术相关活动。',
            galleryInfo2: '梵几拓展传统艺术的界限，挖掘艺术的无限可能性，让观众感知以不同载体呈现的艺术，',
            galleryInfo3: '并带领他们进入无限遐想的艺术世界。',
            columnInfo: '为了深入探索家具主人的生活态度，观察家具与人、人与人之间的亲密连结，梵几自制栏目“梵几在家”、“串门”，从不同维度出发，讲述家具，设计与人的故事。',
            phyStore: '实体门店',
            phyStores: '| 北京 | 上海 | 广州 | 深圳 | 成都 | 杭州 | 苏州 | 南京 |',
            lineStore: '线上店铺',
            lineStores: '| 天猫 | 京东 | 微信小程序 |',
            indexDown: '/view-v2/web/static/img/index/index2020_zh.png',
            indexDown2: ''
        },
        catalog: {
            name: '产品册',
            btn: '点击下载产品册'
        },
        aboutFnji: {
            aboutFnji1Title: '十年雕琢 初心未改',
            aboutFnji1: '梵几由设计师高古奇创立于2010年，是中国原创家具的先锋代表。“梵”是净空与安静，“几”是家具，意为净空安静的家具。“什么才是真正属于中国的设计”是梵几一直以来的思考与探索。',
            aboutFnji2Title: '传承中国 传统工艺',
            aboutFnji2: '通过木工匠人的亲手打磨，保留木材原生纹理与质感。每一处转角和线条的细节处理，非十年功底不可得。是对中国传统技艺的传承与保护，也是对设计的极致追求。',
            aboutFnji3Title: '甄选优质 自然材质',
            aboutFnji3: '坚持以实木为主体，融合皮、羊毛、石材等多种自然材质。选用世界级品牌进口材料，保障安全与环保的同时经久耐用。契合“生于野，安于室”的本质，回归自然与练达。',
            aboutFnji4Title: '凝练记忆中的灵感',
            aboutFnji4: '设计不应只是线条与元素的堆砌，梵几的设计灵感源于对中国文化与传统生活的感知，将东方韵味与哲思凝练于设计中。每一个设计背后，都隐藏着对自然万物与人文艺术的大爱与珍视。',
            aboutFnji5Title: '十年 寻河',
            aboutFnji5: '十年。寻河。',
            aboutFnji51: '“不知道从什么时候开始，我经常做一个类似的梦。梦里的自己在寻找一条河，那条河清澈见底，应该就在不远处。',
            aboutFnji52: '但这也许只是我梦中的景象，',
            aboutFnji53: '那条河，我仍未找到。”',
            aboutFnji54: '梵几从创立到不断变得完整，也如同一场寻河之旅。'
        },
        cooperateItem: [
            { title: '项目批量采购', desc: '', type: 1, class: 'project'},
            { title: '设计公司合作', desc: '', type: 2, class: 'desgin'},
            { title: '家居品牌合作', desc: '', type: 3, class: 'grocery'},
            { title: '市场&媒体合作', desc: '', type: 4, class: 'marketing'},
            { title: '艺术品合作', desc: '', type: 5, class: 'gallery'}
        ],
        cooperateFnji: {
            topTitle: '商业合作',
            topCon: '梵几对外开放多方向商业合作，',
            topCon2: '如果您有合作意向请点击相应入口填写信息。',
            topCon3: '若有需要我们将会在5个工作日内回复您。',
            companyName: '公司名称',
            projectName: '项目名称',
            city: '城市',
            budget: '预算',
            time: '进场时间',
            contact: '联系人',
            position: '职务',
            phoneNumber: '电话',
            phone: '联系电话',
            companyIntro: '公司介绍',
            project: '合作项目',
            artistBrandstudio: '艺术家/品牌/工作室',
            summary: '简介',
            email: '邮箱',
            importantEmail: '邮箱（很重要，请填写常用邮箱）',
            attachFile: '添加附件',
            fileTips: '附件不得超过15M，支持jpg，pdf',
            note: '备注',
            submit: '提交',
            successfully: '提交成功'
        },
        fnjiAtHome: '[梵几在家] 是梵几品牌的自媒体栏目，透过栏目展现梵几家具在不同人家中的状态，分享家具不同的搭配使用，传达家具主人的生活态度......',
        fnjiVisitFriend: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设计师）来到北京，那时和朋友们见面不是约在咖啡管就是商场，而小时候，父母友人间相互串门的方式让他难以忘怀，那时古奇就在朋友圈发起了一场“串门“活动......',
        addCart: '加入购物车',

        buyChannel:{
            online: '线上商城',
            project: '商业采购',
            shop: '实体门店',
        },
        buy: '直接购买',

        clickShow: {
            partOne: '点击查看',
            partTwo: '配送详情',
            partThree: '或',
            partFour: '会员制度'
        },
        usingClick: {
            partOne: '点击购买',
            partTwo: '家具保养套装'
        },
        artInfo: {
            artExhibtion1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',
            artExhibtion2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
            artExhibtionBtn: '查看全部展览',
            artStage1: '通过木工匠人的亲手打磨，保留木材原生纹理与质感',
            artStage2: '每一处转角和线条的细节处理，非十年功底不可得',
            artStage3: '是对中国传统技艺的传承与保护，也是对设计的极致追求',
            artStageBtn: '查看全部橱窗',
            artStore1: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，',
            artStore2: '期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
        },
        homeInfo: {
            homeTitle: '梵几在家',
            homeAtHome1: '梵几在家是梵几品牌的自媒体栏目，透过展现梵几家具在不同人家中的状态',
            homeAtHome2: '分享家具不同的搭配使用以及传达家具主人的生活态度',
            homeBtn: '查看全部',
            homeVisitTitle: '串门',
            homeVisit1: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设计师）来到北京，那时和朋',
            homeVisit2: '友们见面不是约在咖啡馆就是商场，而小时候，父母友人间相互串门的方式让他难',
            homeVisit3: '以忘怀，那时古奇就在朋友圈发起了一场“串门“活动……'
        },
        homeInfoPhone: {
            homeAtHome1: '梵几在家是梵几品牌的自媒体栏目，',
            homeAtHome2: '透过展现梵几家具在不同人家中的状态。',
            homeAtHome3: '分享家具不同的搭配使用以及传达家具主人的生活态度。',
            homeVisit1: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设',
            homeVisit2: '计师）来到北京，那时和朋友们见面不是约在咖啡馆就是',
            homeVisit3: '商场，而小时候，父母友人间相互串门的方让他难以忘',
            homeVisit4: '怀，那时古奇就在朋友圈发起了一场“串门“活动……'
        },
        typeList: [
            {name: '全部',tab: '',link: '/furniture?tab=all'},
            {name: '椅',tab: '#chair',link: '/furniture?tab=all#chair'},
            {name: '桌',tab: '#desk',link: '/furniture?tab=all#desk'},
            {name: '床',tab: '#bed',link: '/furniture?tab=all#bed'},
            {name: '几',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
            {name: '柜',tab: '#cab',link: '/furniture?tab=all#cab'},
            {name: '沙发',tab: '#sofa',link: '/furniture?tab=all#sofa'},
            {name: '一枚板',tab: '#ymb',link: '/furniture?tab=all#ymb'},
            {name: '其他',tab: '#other',link: '/furniture?tab=all#other'}
        ],
        newTypeList: [
            {name: '新品',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
            {name: '大地线',tab: 'base',link: '/furniture-l2?bom=base'},
            {name: '山脊线',tab: 'high',link: '/furniture-l2?bom=high'},
            {name: 'FF线',tab: 'ff',link: '/furniture-l2?bom=ff'},
            // {name: '回顾',tab: '',link: '/furniture-l2?bom=ff'},
        ],
        groTypeList: [
            {theName: '全部',name: '全部',bom: '',link: '/grocery?tab=all'},
            {theName: '灯具',name: '灯具',bom: 'C01-11',link: '/grocery-l2?bom=C01-11'},
            {theName: '家纺',name: '家纺',bom: 'C01-12',link: '/grocery-l2?bom=C01-12'},
            {theName: '餐厨用品',name: '餐厨用品',bom: 'C01-13',link: '/grocery-l2?bom=C01-13'},
            {theName: '收纳杂物',name: '收纳杂物',bom: 'C01-14',link: '/grocery-l2?bom=C01-14'},
            {theName: '香氛洗护',name: '香氛洗护',bom: 'C01-15',link: '/grocery-l2?bom=C01-15'},
            {theName: '装饰',name: '装饰',bom: 'C01-16',link: '/grocery-l2?bom=C01-16'},
            {theName: '家居电器',name: '家居电器',bom: 'C01-17',link: '/grocery-l2?bom=C01-17'},
            {theName: '户外园艺',name: '户外园艺',bom: 'C01-18',link: '/grocery-l2?bom=C01-18'},
            {theName: '文创',name: '文创',bom: 'C01-19',link: '/grocery-l2?bom=C01-19'}
        ]
    };
    return  zh;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){
    var en = {
        detail: {name: 'Case Presentation Images'},
        topBarLinks: [
            {name: 'Visit Shanghai Living Room', class: 'sh-appoint'},

            // {name: 'How to Shop', link: '/shop'},
            // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
            {name: 'Contact Us', link: '/site/cooperate'}
        ],
        headLeft: {
            brand: 'Brand',
            crest: 'CrestLine',
            earth: 'EarthLine',
            ff: 'FnjiFore',
            register: 'Register',
            login: 'Login',
            logout: 'Logout',
            cart: 'Cart',
            order: 'Order'
        },
        // navMenu: [
        //     {name: 'FNJI', link: '/', menu: []},
        //     {name: 'FURNITURE', link: '/furniture?tab=all',category: '1',menu:
        //             [{name: 'All',link: '/furniture?tab=all'},
        //                 {name: 'Chair',link: '/furniture?tab=all#chair'},
        //                 {name: 'Table',link: '/furniture?tab=all#desk'},
        //                 {name: 'Bed',link: '/furniture?tab=all#bed'},
        //                 {name: 'Teapoy',link: '/furniture?tab=all#lowtable'},
        //                 {name: 'Cabinet',link: '/furniture?tab=all#cab'},
        //                 {name: 'Sofa',link: '/furniture?tab=all#sofa'},
        //                 {name: 'Fnji Plank',link: '/furniture?tab=all#ymb'},
        //                 {name: 'Others',link: '/furniture?tab=all#other'},
        //             ]},
        //     {name: 'HOME', link: '/grocery?tab=all',category: '2', menu:
        //             [{name: 'All',link: '/grocery?tab=all'},
        //                 {name: 'Lighting',link: '/grocery-l2?bom=C01-11'},
        //                 {name: 'Textiles',link: '/grocery-l2?bom=C01-12'},
        //                 {name: 'Dinning&Kitchen',link: '/grocery-l2?bom=C01-13'},
        //                 {name: 'Storage',link: '/grocery-l2?bom=C01-14'},
        //                 {name: 'Fragrance',link: '/grocery-l2?bom=C01-15'},
        //                 {name: 'Accessories',link: '/grocery-l2?bom=C01-16'},
        //                 {name: 'Electronics',link: '/grocery-l2?bom=C01-17'},
        //                 {name: 'Outdoor',link: '/grocery-l2?bom=C01-18'},
        //                 {name: 'Lifestyle',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: 'GALLERY', link: '/gallery', menu:
        //             [
        //                 // {name:"Exhibit", link:"/gallery#artist"},
        //                 // {name:"Stage", link:"/gallery#works"},
        //                 // {name:"POP-UP Store", link:"/gallery#exhibit"}
        //             ]},
        //     {name: 'COLUMN', link: '/home',menu: [
        //             {name:"FNJI at Home", link:"/home-athome"},
        //             {name:"FNJI visit Friend", link:"/home-drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     {name: 'ABOUT FNJI', link: '/fnjinews', menu: []},
        //     {name: 'PURCHASE', link: '/buyChannel', menu: []}
        // ],
        navMenu: [
            {name: 'Home', link: '/', children: []},
            {name: 'Furniture', link: '/furniture?tab=C09',category: '1', children: []},
            {name: 'Furnishings', link: '/grocery?tab=G01',category: '2', children: []},
            {name: 'Projects', link: '/caseNew', children: [
                    {name: 'Fnji At Home',link: '/athome',type: 1},
                    {name: 'Commercial Project',link: '/project',type: 2}
                ]},
            {name: 'ShowRooms', link: '/shops', children: [
                    {name: 'Beijing Sanlitun Taikooli Store',phoneTitle: 'Beijing',phoneName: 'Sanlitun Taikooli Store',link: '/exhibitionhall?id=2',type: 1},
                    {name: 'Beijing Indigo Store',phoneTitle: '',phoneName: 'Indigo Store',link: '/exhibitionhall?id=3',type: 1},
                    {name: 'Beijing Guozijian Living Room',phoneTitle: '',phoneName: 'Guozijian Living Room',link: '/exhibitionhall?id=4',type: 1},
                    {name: 'Shanghai Qiantan Taikoo Li store',phoneTitle: 'Shanghai',phoneName: 'Qiantan Taikoo Li store',link: '/exhibitionhall?id=5',type: 2},
                    {name: 'Shanghai Wukang Rd Living Room',phoneTitle: '',phoneName: 'Wukang Rd Living Room',link: '/exhibitionhall?id=6',type: 2},
                    {name: 'Guangzhou TEEM SENSES Store',phoneTitle: 'Guangzhou',phoneName: 'Yuehai Tiandi Store',link: '/exhibitionhall?id=7',type: 3},
                    {name: 'Shenzhen Wanxiang Qianhai Store ',phoneTitle: 'Shenzhen',phoneName: 'Wanxiang Qianhai Store',link: '/exhibitionhall?id=8',type: 4},
                    {name: 'Shenzhen Zhuoyue Center store',phoneTitle: '',phoneName: 'Zhuoyue Center store',link: '/exhibitionhall?id=9',type: 4},
                    // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                    {name: 'Hangzhou Liuhe Road Store',phoneTitle: 'Hangzhou',phoneName: 'Liuhe Road Store',link: '/exhibitionhall?id=11',type: 6},
                    {name: 'Suzhou Eslite Store',phoneTitle: 'Suzhou',phoneName: 'Eslite Store',link: '/exhibitionhall?id=12',type: 7},
                    // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                    {name: 'Nanjing Jinying Store',phoneTitle: 'Nanjing',phoneName: 'Jinying Store',link: '/exhibitionhall?id=14',type: 8},
                    {name: 'Chengdu Fusen Store',phoneTitle: 'Chengdu',phoneName: 'Fusen Store',link: '/exhibitionhall?id=15',type: 5},
                    {name: 'Xian Wanxiang Store',phoneTitle: 'Xian',phoneName: 'Wanxiang Store',link: '/exhibitionhall?id=16',type: 9}
                ]},
            {name: 'Arts/Column', link: '/gallery', children: [
                    {name: 'Exhibition·Stage·Pop-Up·',link: '/gallery',type: 1,phoneChildren: [
                            {name: 'Exhibition',link: '/gallery'},
                            {name: 'Stage',link: '/gallery'},
                            {name: 'Pop-Up',link: '/gallery'}
                        ]},
                    {name: 'VISITING FRIENDS',link: '/home-drop',type: 2}
                ]},
            // {name: '栏目', link: '/home'},
            {name: 'About', link: '/fnjinews', children: []},
            {name: 'Downloads', link: '/download', children: [
                    {name: 'Product Models',link: '/download',type: 1},
                    {name: 'Catalog',link: '/catalog',type: 2},
                ]},
            {name: 'Purchase', link: '/buyChannel', children: []}
        ],
        footerNew: [
            {name: 'PRESS', link: '/fnjimedia'},
            {name: 'HIRING', link: '/job'},
            {name: 'SERVICE', link: '/aboutservice'},
            {name: 'CONTACT', link: '/site/cooperate?type=1'}
        ],
        menuGroups: [
            {
                title: 'ABOUT US',
                list: [
                    {name: 'About Fnji', link: '/fnjinews'},
                    {name: 'How to Buy', link: '/buyChannel'},
                    {name: 'Press', link: '/fnjimedia'},
                    {name: 'Join Us', link: '/job'}
                ]
            },
            {
                title: 'SHOPPING GUIDANCE',
                list: [
                    {name: 'Placing an Order', link: '/howshop'},
                    {name: 'Membership', link: '/membership'}
                ]
            },
            {
                title: 'ABOUT DELIVERY',
                list: [
                    {name: 'Furniture Delivery', link: '/aboutdeliver?index=0'},
                    {name: 'Grocery Delivery', link: '/aboutdeliver?index=1'},
                    {name: 'Fnji Plank Delivery', link: '/aboutdeliver?index=2'}
                ]
            },
            {
                title: 'CUSTOMERSERVICE',
                list: [
                    {name: 'Furniture Service', link: '/aboutservice?index=0'},
                    {name: 'Grocery Delivery', link: '/aboutservice?index=1'}
                ]
            },
            {
                title: 'CONTACT US',
                list: [
                    {name: 'Bulk Purchase', link: '/site/cooperate?type=1'},
                    {name: 'Design Studio Collaboration', link: '/site/cooperate?type=2'},
                    {name: 'Home Furnishing Brand Cooperation', link: '/site/cooperate?type=3'},
                    {name: 'Marketing & Media Cooperation', link: '/site/cooperate?type=4'},
                    {name: 'Artwork Collaboration', link: '/site/cooperate?type=5'},
                    {name: 'Download Catalogs', link: '/temp/upload/productinfo/产品目录.zip'}
                ]
            }
        ],
        fnjiIndexNew: {
            aboutFnji: 'ABOUT FNJI',
            // aboutFnjiCon: 'Rooted in the profound oriental aesthetics, the design condenses the expression and inheritance, and',
            // aboutFnjiCon2: 'integrates the understanding and thinking of nature.It is Fnji\'s value and mission to be loyal to the self by',
            // aboutFnjiCon3: 'conveying its distinctive style, aesthetics and lifestyle delicately and effectively.',
            // aboutFnjiCon4: 'It is also an interpretation of the concept of “Nature bred, Home nourished”.',
            aboutFnjiCon: 'FNJI was founded in 2010 and is a lifestyle aesthetics brand that integrates furniture and home furnishings.',
            aboutFnjiCon2: '"Fan" means clean and quiet, and "Ji" means furniture, which means clean and quiet furniture. At the same time,',
            aboutFnjiCon3: 'the homonym of Fanji is "FANJI", which means ordinary furniture. "Oriental modern, natural and meaningful" is ',
            aboutFnjiCon4: 'the keyword of the brand, which is the concept and persistence of Fanji rooted in the soil of the East and ',
            aboutFnjiCon5: 'constantly exploring aesthetic life. "NATURE BRED HOME NOURISHED" takes natural materials and simulates the ',
            aboutFnjiCon6: 'state of nature. FNJI insists on using wood as the main body, integrating leather, wool, stone and other natural ',
            aboutFnjiCon7: 'materials, and returning the aura taken from the mountains to daily life.',
            aboutFnjiBt: 'More about FNJI',
            furnitureTitle: 'Furniture',
            furniture: 'The concept of "Nature bred, Home nourished" of Fnji furniture integrates a variety of',
            furniture2: 'design languages such as deep solemnity, simplicity, modern diversity and so on.',
            furniture3: 'Explore aesthetic balance and inspiration between East and West, between modernity',
            furniture4: 'and tradition, and between memory and future.',
            earth: 'EARTH LINE',
            earthInfo: 'Wise and pure as boundless earth.',
            crest: 'CREST LINE',
            crestInfo: 'Solemn as the misty shadow above the mountain crest.',
            fnjiFore: 'FNJI FORE',
            fnjiForeInfo: 'Explore the possibilities of future life in China.',
            moreFur: 'More Furniture',
            fnjiathome: 'Fnji At Home',
            fnjiathomeCon: 'In order to deeply explore the lifestyle attitude of furniture owners and observe the relationship ',
            fnjiathomeCon2: 'between furniture and people Intimate connections between people, Fnji self-made program ',
            fnjiathomeCon3: '"Fnji at Home" Starting from different dimensions, tell the story of furniture, design, and people',
            cooperation: 'Commercial Project',
            cooperationCon: 'FNJI and commercial space produce linkage, in different styles together interpret the tolerance and ',
            cooperationCon2: 'infinite possibilities of FNJI furniture. FNJI has been exploring the resonance of design and nature',
            cooperationCon3: 'between different places and objects. ',
            furnishings: 'HOME FURNlSHlNGS',
            homeCon: 'Life Store selects quality household goods from around the world with high',
            homeCon2: 'standards. Quality household goods make people feel happy and bring to life',
            homeCon3: 'a sense of ceremony. More importantly, they present the life aesthetic system',
            homeCon4: 'recognized and admired by Fnji.',
            moreHome: 'More Homeware',
            artTitle: 'Arts/Column',
            artCon: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-up Store. Fnji breaks the',
            artCon2: 'boundaries of traditional art and taps into the infinite possibilities of art. It allows',
            artCon3: 'the audience to perceive the art presented in different carriers and leads them into the',
            artCon4: 'art world of infinite imagination.',
            moreInfo: 'More Information',
            journalCon: 'In order to explore the living attitudes of furniture owners and observe the intimate',
            journalCon2: 'connections between furniture and people and among people, Fnji makes columns "FNJI at',
            journalCon3: 'Home" and "FNJI Visit Friend" to tell the stories of furniture, design and people from',
            journalCon4: 'different dimensions.',
            projectCon: 'Fnji cooperate with commercial spaces, designers and owner-principals to interpret',
            projectCon2: 'the comprehensive and infinite possibility of Fnji furniture in different styles.',
            morePro: 'More Project',
            howtobuy: 'Purchase',
            lineStore: 'ONLINE STORE',
            lineStores: '| TMALL | JD | Wechat mini program｜',
            phyStore: 'SHOWROOMS',
            phyStores: ['Beijing','Shanghai','Guangzhou','Shenzhen','Chengdu','Hangzhou','Suzhou','Nanjing'],
            aboutAllBt: 'More Purchase',
            footerInfo: 'Explore aesthetic balance and inspiration between oriental',
            footerInfo2: 'and occidental, between modernity and tradition, and',
            footerInfo3: 'between memory and future.'
        },
        fnjiIndexPhoneNew: {
            aboutFnjiCon: 'FNJI was founded in 2010 and is a lifestyle aesthetics brand that',
            aboutFnjiCon2: 'integrates furniture and home furnishings."Fan" means clean and',
            aboutFnjiCon3: 'quiet, and "Ji" means furniture, which means clean and quiet',
            aboutFnjiCon4: 'furniture. At thesame time, the homonym of Fanji is "FANJI", which',
            aboutFnjiCon5: 'means ordinary furniture."Oriental modern, natural and meaningful"',
            aboutFnjiCon6: 'is the keyword of the brand, which is the concept and persistence of',
            aboutFnjiCon7: 'Fanji rooted in the soil of the East and constantly exploring aesthetic',
            aboutFnjiCon8: 'life. "NATURE BRED HOME NOURISHED" takes natural materials and',
            aboutFnjiCon9: 'simulates the state of nature. FNJI insists on using wood as the main',
            aboutFnjiCon10: 'body, integrating leather, wool, stone and other natural materials,',
            aboutFnjiCon11: 'and returning the aura taken from the mountains to daily life.',
            // aboutFnjiCon: 'Rooted in the profound oriental aesthetics, the design condenses',
            // aboutFnjiCon2: 'the expression and inheritance, and integrates the understanding',
            // aboutFnjiCon3: 'and thinking of nature.It is Fnji\'s value and mission to be loyal to the',
            // aboutFnjiCon4: 'self by conveying its distinctive style, aesthetics and lifestyle',
            // aboutFnjiCon5: 'delicately and effectively.',
            // aboutFnjiCon6: 'It is also an interpretation of the concept of “Nature bred, Home nourished”.',
            furniture: 'The concept of "Nature bred, Home nourished" of Fnji furniture',
            furniture2: 'integrates a variety of design languages such as deep solemnity,',
            furniture3: 'simplicity, modern diversity and so on. Explore aesthetic balance',
            furniture4: 'and inspiration between East and West, between modernity and',
            furniture5: 'tradition, and between memory and future. ',
            homeCon: 'Life Store selects quality household goods from around the',
            homeCon2: 'world with high standards. Quality household goods make',
            homeCon3: 'people feel happy and bring to life a sense of ceremony. More',
            homeCon4: 'importantly, they present the life aesthetic system recognized',
            homeCon5: 'and admired by Fnji.',

            fnjiAtHomeDesc: 'Fnji At Home\n' +
                'In order to deeply explore the lifestyle attitude of furniture owners and observe the relationship between furniture and people\n' +
                'Intimate connections between people, Fnji self-made program "Fnji at Home"\n' +
                'Starting from different dimensions, tell the story of furniture, design, and people\n',

            fnjiProjectDesc: 'Cooperation\n' +
                'FNJI and commercial space produce linkage, in different styles together interpret \n' +
                ' the tolerance and infinite possibilities of FNJI furniture. FNJI has been exploring the \n' +
                'resonance of design and nature between different places and objects.',

            fnjiProject: 'Commercial Project',

            fnjiathomeCon: 'In order to deeply explore the lifestyle attitude of',
            fnjiathomeCon2: 'furniture owners and observe the relationship ',
            fnjiathomeCon3: 'between furniture and people Intimate connections',
            fnjiathomeCon4: 'between people, Fnji self-made program "Fnji at',
            fnjiathomeCon5: 'Home" Starting from different dimensions, tell',
            fnjiathomeCon6: 'the story of furniture, design, and people',
            cooperationCon: 'FNJI and commercial space produce linkage, in ',
            cooperationCon2: 'different styles together interpret the tolerance',
            cooperationCon3: 'and infinite possibilities of FNJI furniture. FNJI',
            cooperationCon4: 'has been exploring the resonance of design and ',
            cooperationCon5: 'nature between different places and objects. ',
            EXHIBITION: 'EXHIBITION',
            EXHIBITION2: '',
            ARTSTAGE: 'ART STAGE',
            ARTSTAGE2: '',
            STORE: 'POP-UP STORE',
            STORE2: '',
            artCon: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-',
            artCon2: 'up Store. Fnji breaks the boundaries of traditional art and',
            artCon3: 'taps into the infinite possibilities of art. It allows the',
            artCon4: 'audience to perceive the art presented in different carriers',
            artCon5: 'and leads them into the art world of infinite imagination.',
            journalCon: 'In order to explore the living attitudes of furniture owners',
            journalCon2: 'and observe the intimate connections between furniture',
            journalCon3: 'and people and among people, Fnji makes columns "FNJI',
            journalCon4: 'at Home" and "FNJI Visit Friend" to tell the stories of',
            journalCon5: 'furniture, design and people from different dimensions.',
            projectCon: 'Fnji cooperate with commercial spaces, designers and',
            projectCon2: 'owner-principals to interpret the comprehensive and',
            projectCon3: 'infinite possibility of Fnji furniture in different styles.',
        },
        aboutFnjiNew: {
            titleOne: 'MEMORY',
            titleTwo: 'INHERITANCE',
            titleThree: 'NATURE',
            titleFour: 'TIMELESS',
            memory: 'Inspired by the perception of Chinese culture and traditional life, Fnji condenses the oriental charm and philosophy in the design and',
            memory2: 'conveys the common memory and cultural resonance of the Chinese people with the design language in line with the modern lifestyle,',
            memory3: 'hence reproducing the disappearing bygones in people\'s life in a new and lasting way, and retaining the fireworks of the memory.',
            productsImg: [
                {img:'s20480_1627452972_1499.png',name: '竹椅',ename: ' BAMBOO CHAIR',info1: 'Replacing bamboo with wood, the shape is refined and simplified, the lines show changes in thickness,',info2: 'and the Chinese implications are revealed in the simplicity, which is the beginning of Fnji brand.'},
                {img:'s20480_1627452940_9411.png',name: '团扇屏风',ename: ' CIRCULAR FAN SCREEN',info1: 'Wood and rattan are intertwined with the air flowing between to integrate the traditional Chinese elements into the modern space with moving',info2: 'lines and lifestyle. The space partition is no longer a cutting, but an independent yet connected relationship that allows people to communicate.'},
                {img:'s20480_1627452916_7972.png',name: '胡同推车',ename: ' LITTLE CART',info1: 'Inspired by the traditional Chinese bamboo cart, we use the unique Chinese design language to reproduce the most simple space',info2: 'needs in memory. It is not limited by the functions of furniture, but applicable to all spaces and scenes at home in a flexible manner.'},
                {img:'s20480_1627452875_7826.png',name: '线轴几',ename: ' REEL SIDE TABLE',info1: 'The delicate and varied natural stone texture forms a richer touch, while the',info2: 'scattered combination of high and low highlights the unique Oriental beauty.'},
                {img:'s20480_1627452846_8757.png',name: 'CIGAR置物架',ename: ' CIGAR DISPLAY SHELF',info1: 'Decorated with the ingenious thinking of modern design on the shape of bamboo dustpan frame,',info2: 'items can be taken and displayed in four directions to outline the overlapping beauty.'},
                {img:'s20480_1627452815_5473.png',name: '马扎',ename: ' CAMPSTOOL',info1: 'The smooth and delicate wooden structure forms a portable handle, and the vegetable tanning',info2: 'seat with warm color reflects the natural mark of time.'},
                {img:'s20480_1627452661_7271.png',name: '鸟笼立柜',ename: ' CAGE CABINET',info1: 'Referring to the body of the bird cage, the cage is surrounded by thick and smooth wooden strips',info2: 'in a unique shape, forming a visual system of virtual and real communication under the soft light.'}
            ],
            inheritance: 'Inheritance of Chinese traditional crafts refers to preserving the original texture and quality of wood through the hand polishing of',
            inheritance2: 'carpenters.Each craft carries the emotional expression pursued by Fnji to present the best experience in structure, performance and',
            inheritance3: 'senses, which is not only the inheritance and protection of Chinese traditional crafts, but also the ultimate pursuit of design.',
            nature: 'Human beings are born to be close to the nature, which is in line with the essence of "originating from the wildness but settling in the house". We adhere to taking solid',
            nature2: 'wood as the main body and integrating a variety of natural materials such as leather, wool and stone, so as to introduce the aura of mountains and wildness to daily life.',
            nature3: 'We select imported materials from world-class brands to ensure safety and environmental protection and durability at the same time.',
            timeLess: '"What is the design that truly belongs to China" has always been the thinking and exploration of Fnji.',
            timeLess2: 'Behind every design there is a great love and treasure for all things in nature and humanities and art.',
            events: 'FNJI EVENTS',
            commercials: 'PREVIOUS COMMERCIALS',
            commercialsInfo: 'In addition to exploring the possibility of our own products, we also thought about the visual presentation of various',
            commercialsInfo2: 'products in last decade. This is Fnji\'s thinking on artistic beauty and the expression of brand spirit as well. Fnji hopes to',
            commercialsInfo3: 'achieve a balance between the East and the West, contemporary and tradition, memory and the future, and then explore the',
            commercialsInfo4: 'furniture belonging to the Chinese people in the future.',
            designer: 'DESIGNER'
        },
        aboutFnjiPhoneNew: {
            memory: 'Inspired by the perception of Chinese culture and traditional life, Fnji',
            memory2: 'condenses the oriental charm and philosophy in the design and',
            memory3: 'conveys the common memory and cultural resonance of the Chinese',
            memory4: 'people with the design language in line with the modern lifestyle,',
            memory5: 'hence reproducing the disappearing bygones in people\'s life in a new',
            memory6: 'and lasting way, and retaining the fireworks of the memory.',
            inheritance: 'Inheritance of Chinese traditional crafts refers to preserving the',
            inheritance2: 'original texture and quality of wood through the hand polishing of',
            inheritance3: 'carpenters.Each craft carries the emotional expression pursued by',
            inheritance4: 'Fnji to present the best experience in structure, performance and',
            inheritance5: 'senses, which is not only the inheritance and protection of Chinese',
            inheritance6: 'traditional crafts, but also the ultimate pursuit of design.',
            nature: 'Human beings are born to be close to the nature, which is in line with',
            nature2: 'the essence of "originating from the wildness but settling in the',
            nature3: 'house". We adhere to taking solid wood as the main body and',
            nature4: 'integrating a variety of natural materials such as leather, wool and',
            nature5: 'stone, so as to introduce the aura of mountains and wildness to daily',
            nature6: 'life. We select imported materials from world-class brands to ensure',
            nature7: 'safety and environmental protection and durability at the same time.',
            timeLess: '"What is the design that truly belongs to China" has always been the',
            timeLess2: 'thinking and exploration of Fnji. Behind every design there is a great',
            timeLess3: 'love and treasure for all things in nature and humanities and art.',
            commercialsInfo: 'In addition to exploring the possibility of our own products, we also',
            commercialsInfo2: 'thought about the visual presentation of various products in last',
            commercialsInfo3: 'decade. This is Fnji\'s thinking on artistic beauty and the expression',
            commercialsInfo4: 'of brand spirit as well. Fnji hopes to achieve a balance between the',
            commercialsInfo5: 'East and the West, contemporary and tradition, memory and the',
            commercialsInfo6: 'future, and then explore the furniture belonging to the Chinese',
            commercialsInfo7: 'people in the future.',
        },
        artInfoNew: {

            artTypeList: [
                {id: '100',artType: 'EXHIBITION',info: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji throughout the country and exchange and share their ' +
                        'inspirations at the scene. When there are common pursuit of aesthetics and encounters with art lovers, Fnji brings everyone who comes to the exhibition closer to art.',
                    infoPhone1: '',infoPhone2: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji throughout the country and exchange and share their inspirations ' +
                        'at the scene. When there are common pursuit of aesthetics and encounters with art lovers, Fnji brings everyone who comes to the exhibition closer to art.'},
                {id: '101',artType: 'STAGE',info: 'Fnji occasionally invites artists to create theme art stages through “playing”They are not strictly defined and they are cross-border new experiments of ' +
                        'brands and artists. They are a unique visual feast made by imagination and artworks.',
                    infoPhone2: 'Fnji occasionally invites artists to create theme art stages through “playing”They are not strictly defined and they are cross-border new experiments of brands and artists. ' +
                        'They are a unique visual feast made by imagination and artworks.'},
                {id: '102',artType: 'POP-UP',info: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique perspectives and tastes into Fnji space and inspire more sparks ' +
                        'and possibilities. ',
                    infoPhone2: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique perspectives and tastes into Fnji space and inspire more sparks and possibilities.'},
            ],
        },
        moreBtn: 'Check All',
        fnjiIndex: {
            aboutFnjiLogo: '/view-v2/web/static/img/index/fnji_about_en.png',
            indexFurnitureLogo: '/view-v2/web/static/img/index/fnji_furture_en.png',
            indexGroLogo: '/view-v2/web/static/img/index/fnji_gro_en_new.png',
            indexArtLogo: '/view-v2/web/static/img/index/fnji_art_en.png',
            indexColumnLogo: '/view-v2/web/static/img/index/fnji_column_en.png',
            indexHowBuyLogo: '/view-v2/web/static/img/index/fnji_how_buy_en.png',

            aboutFnjiCon: 'Fnji inherits traditional Chinese craftsmanship and selects quality natural materials. ',
            aboutFnjiCon2: 'With memories in life and inspiration from nature, ',
            aboutFnjiCon3: 'we create modern furniture that truly belongs to the Chinese.',
            aboutFnjiBt: 'MORE ABOUT FNJI',
            aboutBt: 'READ MORE',
            aboutAllBt: 'CHECK ALL',
            furnitureLine: '| CREST LINE | EARTH LINE | FNJI FORE |',
            crestInfo: 'Inspired by nature and childhood memories and rooted in traditional Chinese culture, the Crest Line incorporates oriental ethereal artistic elements into solemn designs. With Mantis Chair being its first product, the Crest Line has been continuously upgrading its design, structure, and craftsmanship in the last three years. It adopts solid wood with large curves and many details and fabrics of international brands to highlight the sculptural and artistic sense of modern Chinese furniture and brings to life a sense of ceremony.',
            earthInfo: 'The Earth Line is the earliest line of Fnji. With its simple style, it focuses on the home design that is needed by ordinary people in real life. While keeping traditional Chinese design, the Earth Line turns trees in nature into furniture integrated with home. These pieces of furniture accompany us through all seasons and gradually become our family members.',
            ffInfo: 'FF refers to Fnji Fore and represents a step forward of Fnji. It is a new experimental product line. Instead of inheriting traditional craftsmanship, the FF Line is simpler in its design and gives the furniture more possibilities with the combination of various materials and craftsmanship. It has both modern simplicity and a sense of warmth.',
            groceryInfo: 'Fnji Home Museum continues the concept of “born in nature and settled at home” and selects quality household goods from around the world with high standards. ',
            groceryInfo2: 'Quality household goods make people feel happy and bring to life a sense of ceremony.',
            groceryInfo3: 'They perfectly match with furniture and are also a good choice for holiday gifts. More importantly,',
            groceryInfo4: 'they present the life aesthetic system recognized and admired by Fnji.',
            galleryInfo: 'Fnji Art Gallery contains Art Exhibition, Artstage, and Pop-up Store. Fnji breaks the boundaries of traditional art',
            galleryInfo2: 'and taps into the infinite possibilities of art. ',
            galleryInfo3: 'It allows the audience to perceive the art presented in different carriers and leads them into the art world of infinite imagination.',
            columnInfo: 'In order to explore the living attitudes of furniture owners and observe the intimate connections between',
            columnInfo2: 'furniture and people and among people, Fnji makes columns "FNJI at Home" and "FNJI Visit Friend" to tell the',
            columnInfo3: 'stories of furniture, design and people from different dimensions.',
            phyStore: 'STORE LOCATOR',
            phyStores: '| BEIJING | SHANGHAI | Guangzhou | SHENZHEN | CHENGDU | HANGZHOU | SUZHOU | NANJING |',
            lineStore: 'ONLINE STORES',
            lineStores: '| TMALL | JD | WX |',
            indexDown: '/view-v2/web/static/img/index/index2020_new_en.png',
            indexDown2: 'BETWEEN MODERNITY AND TRADITION, AND BETWEEN MEMORY AND FUTURE. '
        },
        catalog: {
            name: 'Catalog',
            btn: 'Download'
        },
        aboutFnji: {
            aboutFnji1Title: 'REMAIN TRUE TO OUR ORIGINAL ASPIRATION WITH EFFORTS OVER THE PAST DECADE',
            aboutFnji1: 'Founded in 2010 by designer Gao Guqi, Fnji (梵几) is a pioneer representative of Chinese original',
            aboutFnji12: 'furniture. “梵” refers to serenity and “几” refers to furniture',
            aboutFnji13: 'so “梵几” refers to furniture with a sense of serenity',
            aboutFnji14: 'Fnji has been thinking about and exploring “what is the design that really belongs to China".',
            aboutFnji2Title: 'INHERIT TRADITIONAL CHINESE CRAFTS',
            aboutFnji2: 'Fnji preserves the original texture and feel of the wood through carpenters’ grinding.',
            aboutFnji22: 'For the treatment of each corner and line, the carpenter will need more than ten years’ experience.',
            aboutFnji23: 'This is  Fnji’s inheritance and protection of traditional Chinese crafts and pursuit of design.',
            aboutFnji3Title: 'SELECT QUALITY NATURAL MATERIALS',
            aboutFnji3: 'Fnji takes solid wood as the main material and uses many other natural materials like leather, wool, and stone. We select imported materials of world-class brands so that our products are both safe and environmentally friendly and durable. This is consistent with our concept of “born in nature and settled at home” and brings people back to nature. ',
            aboutFnji4Title: 'GET INSPIRATION FROM MEMORY',
            aboutFnji4: 'Design should not be simply loaded with lines and elements. Fnji\'s design is inspired by the perception of Chinese culture and traditional life and embodies oriental flavor and philosophy. Behind every design is our great love and cherishment of nature and humanities.',
            aboutFnji5Title: '十年 寻河',
            aboutFnji5: '十年。寻河。',
            aboutFnji51: '“不知道从什么时候开始，我经常做一个类似的梦。梦里的自己在寻找一条河，那条河清澈见底，应该就在不远处。',
            aboutFnji52: '但这也许只是我梦中的景象，',
            aboutFnji53: '那条河，我仍未找到。”',
            aboutFnji54: '梵几从创立到不断变得完整，也如同一场寻河之旅。'
        },
        cooperateItem: [
            { title: 'BULK PIRCHASE', desc: '', type: 1, class: 'project'},
            { title: 'DESIGN STUDIO COLLABORATION', desc: '', type: 2, class: 'desgin'},
            { title: 'HOME FURNISHING BRAND COOPERATION', desc: '', type: 3, class: 'grocery'},
            { title: 'MARKETING & MEDIA COOPERATION', desc: '', type: 4, class: 'marketing'},
            { title: 'ARTWORK COLLABORATION', desc: '', type: 5, class: 'gallery'}
        ],
        cooperateFnji: {
            topTitle: 'Contact Us',
            topCon: 'FNJI has opened to the outside world about multi-directional business cooperation.',
            topCon2: 'If you are interested in cooperation, please click the corresponding entry to fill',
            topCon3: 'in the information. We will reply to you within 5 working days if necessary.',
            companyName: 'Company Name',
            projectName: 'Project Name',
            city: 'City',
            budget: 'Budget',
            time: 'Time requirement for delivery',
            contact: 'Contact',
            position: 'Position',
            phoneNumber: 'Phone Number',
            phone: 'Phone Number',
            companyIntro: 'Company Introduction',
            project: 'Collaboration Project',
            artistBrandstudio: 'Artist/Brand/studio',
            summary: 'Summary',
            email: 'Email',
            importantEmail: 'Email(very important）',
            attachFile: 'Attach File',
            fileTips: 'The attachment must not exceed 15M; you may upload JPG or PDF files.',
            note: 'Note',
            submit: 'Submit',
            successfully: 'Submitted successfully'
        },
        fnjiAtHome: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji furniture in different people\'s homes, it shares different uses of furniture and conveys the living attitude of furniture owners.',
        fnjiVisitFriend: 'In 2009, one year before the founding of Fnji, Guqi (founder and chief designer of Fnji) came to Beijing. At that time, he met with friends either in a coffee shop or a shopping mall. When he was a child, however, parents and friends visited each other at home. With such an unforgettable memory, he launched a “visiting friends” activity among his friends.',
        addCart: 'ADD TO CART',
        buy: 'SHOP NOW',

        buyChannel:{
            online: 'Online Store',
            project: 'Commercial Project',
            shop: 'Showrooms',
        },

        clickShow: {
            partOne: 'Check',
            partTwo: 'delivery information',
            partThree: 'or',
            partFour: 'membership'
        },
        usingClick: {
            partOne: 'Click to buy',
            partTwo: 'Furniture Maintenance Set'
        },
        artInfo: {
            artExhibtion1: 'Fnji invites artists from all over the world to hold art exhibitions in the living room of Fnji',
            artExhibtion2: 'throughout the country and exchange and share their inspirations at the scene.',
            artExhibtion3: 'When there are common pursuit of aesthetics and encounters with art lovers,',
            artExhibtion4: 'Fnji brings everyone who comes to the exhibition closer to art.',
            artExhibtionBtn: 'Check All',
            artStage1: 'Fnji occasionally invites artists to create theme art stages through',
            artStage2: '“playing”. They are not strictly defined and they are cross-border new',
            artStage3: 'experiments of brands and artists. They are a unique visual feast made',
            artStage4: 'by imagination and artworks.',
            artStageBtn: 'Check All',
            artStore1: 'The Pop-up Store will invite new and unique brands to Fnji living rooms to inject unique',
            artStore2: 'perspectives and tastes into Fnji space and inspire more sparks and possibilities.',
        },
        homeInfo: {
            homeTitle: 'FNJI AT HOME',
            homeAtHome1: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji furniture in',
            homeAtHome2: 'different people\'s homes, it shares different uses of furniture and conveys the',
            homeAtHome3: 'living attitude of furniture owners.',
            homeBtn: 'More',
            homeVisitTitle: 'VISITING FRIENDS',
            homeVisit1: 'In 2009, one year before the founding of Fnji, Guqi (founder and chief',
            homeVisit2: 'designer of Fnji) came to Beijing. At that time, he met with friends either in a',
            homeVisit3: 'coffee shop or a shopping mall. When he was a child, however, parents and',
            homeVisit4: 'friends visited each other at home. With such an unforgettable memory, he',
            homeVisit5: 'launched a “visiting friends” activity among his friends.'
        },
        homeInfoPhone: {
            homeAtHome1: '"FNJI at Home" is the self-media column of Fnji. By showing Fnji',
            homeAtHome2: 'furniture in different people\'s homes, it shares different uses of',
            homeAtHome3: 'furniture and conveys the living attitude of furniture owners.',
            homeVisit1: 'In 2009, one year before the founding of Fnji, Guqi (founder and',
            homeVisit2: 'chief designer of Fnji) came to Beijing. At that time, he met with',
            homeVisit3: 'friends either in a coffee shop or a shopping mall. When he was',
            homeVisit4: 'a child, however, parents and friends visited each other at home.',
            homeVisit5: 'With such an unforgettable memory, he launched a “visiting',
            homeVisit6: 'friends” activity among his friends.'
        },
        typeList: [
            {name: 'All',tab: '',link: '/furniture?tab=all'},
            {name: 'Chair',tab: '#chair',link: '/furniture?tab=all#chair'},
            {name: 'Table',tab: '#desk',link: '/furniture?tab=all#desk'},
            {name: 'Bed',tab: '#bed',link: '/furniture?tab=all#bed'},
            {name: 'Teapoy',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
            {name: 'Cabinet',tab: '#cab',link: '/furniture?tab=all#cab'},
            {name: 'Sofa',tab: '#sofa',link: '/furniture?tab=all#sofa'},
            {name: 'Plank',tab: '#ymb',link: '/furniture?tab=all#ymb'},
            {name: 'Other',tab: '#other',link: '/furniture?tab=all#other'}
        ],
        newTypeList: [
            {name: 'New',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
            {name: 'Crest Line',tab: 'base',link: '/furniture-l2?bom=base'},
            {name: 'Earth Line',tab: 'high',link: '/furniture-l2?bom=high'},
            {name: 'Fnji Fore',tab: 'ff',link: '/furniture-l2?bom=ff'},
            // {name: '回顾',tab: '',link: '/furniture-l2?bom=ff'},
        ],
        groTypeList: [
            {theName: 'All',name: '全部',bom: '',link: '/grocery?tab=all'},
            {theName: 'Lighting',name: '灯具',bom: 'C01-11',link: '/grocery-l2?bom=C01-11'},
            {theName: 'Textiles',name: '家纺',bom: 'C01-12',link: '/grocery-l2?bom=C01-12'},
            {theName: 'Dinning&Kitchen',name: '餐厨用品',bom: 'C01-13',link: '/grocery-l2?bom=C01-13'},
            {theName: 'Storage',name: '收纳杂物',bom: 'C01-14',link: '/grocery-l2?bom=C01-14'},
            {theName: 'Fragrance',name: '香氛洗护',bom: 'C01-15',link: '/grocery-l2?bom=C01-15'},
            {theName: 'Accessories',name: '装饰',bom: 'C01-16',link: '/grocery-l2?bom=C01-16'},
            {theName: 'Electronics',name: '家居电器',bom: 'C01-17',link: '/grocery-l2?bom=C01-17'},
            {theName: 'Outdoor',name: '户外园艺',bom: 'C01-18',link: '/grocery-l2?bom=C01-18'},
            {theName: 'Lifestyle',name: '文创',bom: 'C01-19',link: '/grocery-l2?bom=C01-19'}
        ]
    };
    return  en;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    // 'WebCommon/component/page-header-new',
    // 'WebCommon/component/page-footer-new',
    __webpack_require__(23),
    __webpack_require__(63),

    __webpack_require__(68),
    __webpack_require__(87),
    __webpack_require__(18)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    // PageHeaderPhone,
    PageHeader,
    PageFooter
){
    return {
        components: {
            // PageHeaderPhone: PageHeaderPhone,
            PageHeader: PageHeader,
            PageFooter: PageFooter
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(24),
    __webpack_require__(1),
    __webpack_require__(25),
    __webpack_require__(12),
    __webpack_require__(13),
    __webpack_require__(10),
    __webpack_require__(2),
    __webpack_require__(5),
    __webpack_require__(16),
    __webpack_require__(3),
    __webpack_require__(58),
    __webpack_require__(60),

    // 'css!web/static/fonts/fangzheng.css',
    __webpack_require__(61)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    HeadroomMixin,
    PageReadyMixin,
    AuthMixin,
    Modal,
    Utils,
    Api,
    Api2020,
    _,
    SubNav,
    Newapi
){
    var topBarLinks = [
        {name: '上海客厅预约', class: 'sh-appoint'},

        {name: '实体店', link: '/shop'},
        // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
        {name: '商业合作', link: '/site/cooperate'}
    ];
    var navMenu = [
        {name: '首页', link: '/', menu: []},
        {name: '家具', link: '/furniture?tab=all',category: '1'},
        {name: '家居', link: '/grocery?tab=all',category: '2'},
        {name: '艺术/栏目', link: '/gallery'},
        // {name: '栏目', link: '/home'},
        {name: '新事', link: '/fnjinews', menu: []}
    ];
    return {
        template: tpl,
        mixins: [PageReadyMixin, AuthMixin, HeadroomMixin],
        components: {
            SubNav: SubNav
        },
        data: function(){
            return {
                searchText: '',
                searchShow: false,
                navMenu: [
                    {name: '首页', link: '/', children: []},
                    {name: '家具', link: '/furniture?tab=C09',category: '1', children: []},
                    {name: '家居', link: '/grocery?tab=G01',category: '2', children: []},
                    {name: '案例', link: '/caseNew', children: [
                            {name: '梵几在家',link: '/athome',type: 1},
                            {name: '商业',link: '/project',type: 2}
                        ]},
                    {name: '实体展厅', link: '/shops', children: [
                            {name: '北京·梵几三里屯太古里店',phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                            {name: '北京·梵几颐堤港店',phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                            {name: '北京·梵几客厅国子监店（升级中）',phoneTitle: '国子监店（升级中）',phoneName: '',link: '/exhibitionhall?id=4',type: 1},
                            {name: '上海·梵几上海前滩太古里店',phoneTitle: '上海',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                            {name: '上海·梵几客厅武康路店',phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                            {name: '广州·梵几广州粤海天地店',phoneTitle: '广州',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                            {name: '深圳·梵几万象前海店',phoneTitle: '深圳',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                            {name: '深圳·梵几卓越中心店',phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                            {name: '成都·梵几成都富森店',phoneTitle: '成都',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                            // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                            {name: '杭州·梵几留和路店',phoneTitle: '杭州',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                            {name: '苏州·梵几苏州诚品店',phoneTitle: '苏州',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                            // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                            {name: '南京·梵几南京金鹰世界店',phoneTitle: '南京',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                            {name: '西安·梵几西安万象城店',phoneTitle: '西安',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                        ]},
                    {name: '艺术/栏目', link: '/gallery', children: [
                            {name: '艺术展览·艺术橱窗·艺术快闪',link: '/gallery',type: 1,phoneChildren: [
                                    {name: '艺术展览',link: '/gallery'},
                                    {name: '艺术橱窗',link: '/gallery'},
                                    {name: '艺术快闪',link: '/gallery'}
                                ]},
                            {name: '串门',link: '/home-drop',type: 2}
                        ]},
                    // {name: '栏目', link: '/home'},
                    {name: '关于梵几', link: '/fnjinews', children: []},
                    {name: '下载区', link: '/download', children: [
                            {name: 'Sketchup&3dmax',link: '/download',type: 1},
                            {name: '产品册',link: '/catalog',type: 2},
                        ]},
                    {name: '如何购买', link: '/buyChannel', children: []}
                ],
                navMenuShopsPhone: [
                    {phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {phoneTitle: '',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                    {phoneTitle: '',phoneName: '国子监(升级中)',link: '/exhibitionhall?id=4',type: 1},
                    {phoneTitle: '上海',phoneName: '',link: '/exhibitionhall?id=5',type: 2},
                    {phoneTitle: '',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                    {phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                    {phoneTitle: '广州',phoneName: '',link: '/exhibitionhall?id=7',type: 3},
                    {phoneTitle: '',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                    {phoneTitle: '深圳',phoneName: '',link: '/exhibitionhall?id=8',type: 4},
                    {phoneTitle: '',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                    {phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                    {phoneTitle: '成都',phoneName: '',link: '/exhibitionhall?id=15',type: 5},
                    {phoneTitle: '',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                    {phoneTitle: '杭州',phoneName: '',link: '/exhibitionhall?id=11',type: 6},
                    {phoneTitle: '',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                    {phoneTitle: '苏州',phoneName: '',link: '/exhibitionhall?id=12',type: 7},
                    {phoneTitle: '',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                    {phoneTitle: '南京',phoneName: '',link: '/exhibitionhall?id=14',type: 8},
                    {phoneTitle: '',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                    {phoneTitle: '西安',phoneName: '',link: '/exhibitionhall?id=14',type: 9},
                    {phoneTitle: '',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                ],
                navMenuArt: [
                    {name: '艺术展览',link: '/gallery?tab=1'},
                    {name: '艺术橱窗',link: '/gallery?tab=2'},
                    {name: '艺术快闪',link: '/gallery?tab=3'},
                    {name: '串门',link: '/home-drop'}
                ],
                navMenuList: [],
                navMenuNewList: [],

                topBarLinks: [],
                headLeft: {},
                navMenuOffsetLeft: 903.5,
                // navMenuOffsetLeft: 200,
                newShow: true,
                isZh: true,

                menuShow: false,
                theMenu: 0,
                isPC: true,
                pageHeaderShow: true,
                scrollTimer: {},
                whitchTab: 100,
                memberId: ''
            };
        },
        methods: {
            toLogin: function(){
                window.location.href = "/loginnew";
            },
            Logout: function(){
                var _this = this;
                _this.memberId = '';
                localStorage.removeItem('fnjinew_memberId');
            },
            toSearch: function(){
                window.location.href = "/search";
            },
            init: function(){
                var _this = this;
                var zhOrEn = '';
                if(_this.$i18n.locale=='en'){
                    // _this.topBarLinks = _this.$i18n.messages.en.topBarLinks;
                    _this.headLeft = _this.$i18n.messages.en.headLeft;
                    _this.navMenu = _this.$i18n.messages.en.navMenu;
                    _this.$set(_this.navMenu,_this.navMenu);
                    zhOrEn = 'en';
                    _this.isZh = false;
                }else {
                    // _this.topBarLinks = _this.$i18n.messages.zh.topBarLinks;
                    _this.headLeft = _this.$i18n.messages.zh.headLeft;
                    _this.navMenu = _this.$i18n.messages.zh.navMenu;
                    _this.$set(_this.navMenu,_this.navMenu);
                    zhOrEn = 'zh';
                    _this.isZh = true;
                }
                if(_this.navMenuList.length){
                    // _this.navMenuList = _this.navMenu[_this.theMenu].menu;
                }
                if(_this.navMenuNewList.length){
                    // _this.navMenuNewList = _this.navMenu[_this.theMenu].newMenu;
                }
                if($(window).width()<755){
                    _this.isPC = false;
                }
                var memberid = localStorage.getItem('fnjinew_memberId');
                if(memberid){
                    _this.memberId = memberid;
                }
                Api2020.switchZhEnApi.ajax({language: zhOrEn})
                    .done(function(data){

                    });
                var pr = {
                    fnjiType: 1,
                    lang: ''
                };
                var pr2 = {
                    fnjiType: 2,
                    lang: ''
                };
                if(_this.$i18n.locale=='en'){
                    pr.lang = 'en';
                    pr2.lang = 'en';
                }
                Newapi.getFurnitureApi.ajax(pr)
                    .done(function(data){
                        console.log(data);
                        for(var i=0;i<data.length;i++){
                            _this.navMenu[1].children.push({name: data[i].name,link: '/furniture?tab='+data[i].value})
                        }
                    });
                Newapi.getFurnitureApi.ajax(pr2)
                    .done(function(data){
                        console.log(data);
                        for(var i=0;i<data.length;i++){
                            _this.navMenu[2].children.push({name: data[i].name,link: '/grocery?tab='+data[i].value})
                        }
                    });
            },
            menuClick: function(index){
                var obj = this;
                if(index===1){
                    obj.menuShow = true;
                    $('.page-header-new-menu-one').css({width: '375px'});
                    $('.page-header-new-menu-list-first li').css({opacity: 1});
                }else {
                    obj.menuShow = false;
                    $('.page-header-new-menu-one').css({width: '0'});
                    $('.page-header-new-menu-two').css({width: '0',transform: 'translateX(0)',transition: 'all 0.5s'});
                    obj.navMenuNewList = [];
                    // $('.page-header-new-menu-list li').css({opacity: 0});
                }
            },
            menuItemOver: function(item,index){
                var obj = this;
                obj.theMenu = index;
                if(item.children.length){
                    obj.navMenuList = item.children;
                    // obj.navMenuNewList = item.newMenu;
                    $('.page-header-new-menu-two').css({width: '375px',transform: 'translateX(-375px)',transition: 'all 0.5s'});
                }else {
                    $('.page-header-new-menu-two').css({width: '375px',transform: 'translateX(0)',transition: 'all 0.5s'});
                }
            },
            changeType: function(type){
                localStorage.setItem('locale',type);
                this.$i18n.locale = type;
                console.log(this.$i18n.locale);
                this.init();
            },
            showFnjiWeixinModal: function(){
                Modal.showFnjiWeixinSrvModal();
            },
            search: function(){
                var obj = this;
                if(obj.searchText){
                    window.location.href = Utils.genPageLink('/search-shop?word='+this.searchText);
                }else {
                    obj.searchShow = !obj.searchShow;
                }
            },
            login: function(from){
                Modal.showMemberLoginModal(from);
            },
            register: function(){
                Modal.showMemberRegisterModal();
            },
            genPageLink: Utils.genPageLink,
            isLinkActive: function(link){
                if(link=='/'&&window.location.href=='http://fnji.com/'){
                    return true;
                }else if(link=='/'&&window.location.href!='http://fnji.com/') {
                    return false;
                }else {
                    var pathName = window.location.pathname+'?tab=all';
                    var fullLink = this.genPageLink(link);
                    return pathName.indexOf(fullLink) === 0;
                }
            },
            goNeedAuthPage: function(link){
                var fullLink = this.genPageLink(link);
                if (this.isLoggedIn){
                    window.location.href = fullLink;
                } else {
                    this.login(fullLink);
                }
            },
            initNavMenu: function(){
                var _this = this;
                _.forEach(this.navMenu, function(o){
                    if (o.category){
                        Api.getMenuByCategoryApi.ajax({category: o.category})
                            .done(function(data){
                                o.menu = _.map(data, function(obj){
                                    obj.name = obj.descriptionM;
                                    obj.link = _this.genL2Link(o.category, obj.bom);
                                    return obj;
                                });
                            });
                    }
                });
            },
            updateNavMenuOffsetLeft: function(index)
            {
                var _this = this;
                var $target = $(_this.$refs.menuNavItem[index]);
                console.log($target);
                if(index===1||index===2){
                    _this.navMenuOffsetLeft = 100;
                }else if(index===3){
                    if(_this.isZh){
                        _this.navMenuOffsetLeft = 405;
                    }else {
                        _this.navMenuOffsetLeft = 520;
                    }
                }else if(index===4){
                    if(_this.isZh){
                        _this.navMenuOffsetLeft = 500;
                    }else {
                        _this.navMenuOffsetLeft = 600;
                    }
                }
            },
            getCategoryName: function(category){
                switch(category){
                    case 1:
                        return '';
                    case 2:
                        return '';
                    default:
                        return '';
                }
            },
            genL2Link: function(category, bom){
                var categoryName = this.getCategoryName(category);
                if (!categoryName) return '';
                return '/'+categoryName+'-l2?bom='+bom;
            },
            run: function() {
                // var num = 0;
                // var _this = this;
                // var i = setInterval(function () {
                //     if($(document).scrollTop()==0) {
                //         if (num < 40) {
                //             _this.newShow = false;
                //             // console.log(_this.newShow);
                //             num++;
                //         }
                //     }else {
                //         num = 40;
                //         _this.newShow = true;
                //     }
                // },300);
                // if($(document).scrollTop()!=0) {
                //     window.clearInterval(i);
                //     _this.newShow = true;
                // }
            }
        },
        mounted: function() {
            this.fetchMemberInfo();
            // this.initNavMenu();
            // this.run();
            // window.run = this.run;
            // isTop();
            this.init();
            // var obj = this;
            // $(window).scroll(function() {
            //     var pathname = window.location.pathname;
            //     if((pathname!='/buyChannel'&&pathname!='/gallery')||!obj.isPC){
            //         if(!obj.menuShow){
            //         }
            //     }
            // });
            // document.addEventListener("scroll", function(){
            //     clearTimeout(obj.scrollTimer);
            //     obj.scrollTimer = setTimeout(function() {
            //     }, 300);
            // });
        }
    };
    // function isTop() {
    //     $(document).scroll(function() {
    //         run()
    //     });
    // }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div v-if=\"isPC\" id=\"page-header2024\">\r\n        <div class=\"page-header-row\" style=\"height: 100%;\">\r\n            <img style=\"height: 100%;\" src=\"/view-v2/web/static/img/page-header2024/fnji_logo.png\" alt=\"\">\r\n            <div class=\"page-header2024-con\">\r\n                <div class=\"page-header-row\">\r\n                    <div style=\"flex-grow: 1;\" class=\"page-header-row\">\r\n                        <div style=\"position:relative;\">\r\n                            <div @mouseover=\"whitchTab=index\" @mouseleave=\"whitchTab=100\" :style=\"{marginLeft: index>0?'38px':'0'}\" style=\"position:relative;float: left;\" v-for=\"(item,index) in navMenu\">\r\n                                <a v-if=\"item.link\" :href=\"item.link\">{{item.name}}</a>\r\n                                <a style=\"cursor: pointer\" v-else>{{item.name}}</a>\r\n                                <div class=\"header2024_tab_item\" v-if=\"item.children.length>0&&whitchTab==index\">\r\n                                    <div class=\"header2024_tab_item_in\">\r\n                                        <div v-for=\"(con,ind) in item.children\" :style=\"{marginTop: ind>0&&item.children[ind-1].type!=item.children[ind].type?'20px':'0'}\">\r\n                                            <a :href=\"con.link\">{{con.name}}</a>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div style=\"clear: both;\"></div>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"memberId\" @click=\"Logout\" style=\"cursor: pointer;width: 60px;text-align: right;\">{{$t(\"headLeft.logout\")}}</div>\r\n                    <div v-else @click=\"toLogin\" style=\"cursor: pointer;width: 60px;text-align: right;\">{{$t(\"headLeft.login\")}}</div>\r\n                    <div @click=\"changeType('zh')\" style=\"cursor: pointer;margin-left: 38px;font-family: MiSans-Normal;\">CN</div>\r\n                    <div style=\"margin-left: 9px;font-family: MiSans-Normal;\">|</div>\r\n                    <div @click=\"changeType('en')\" style=\"cursor: pointer;margin-left: 9px;font-family: MiSans-Normal;\">EN</div>\r\n                    <!--                <img @click=\"toLogin\" class=\"page-header2024-con-icon\" src=\"/view-v2/web/static/img/page-header2024/user.png\" alt=\"\">-->\r\n                    <!--                <img class=\"page-header2024-con-icon\" src=\"/view-v2/web/static/img/page-header2024/barcode.png\" alt=\"\">-->\r\n                    <img @click=\"toSearch\" class=\"page-header2024-con-icon\" src=\"/view-v2/web/static/img/page-header2024/search_new.png\" alt=\"\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div v-else id=\"page-header-new\">\r\n        <div class=\"page-header-new\">\r\n            <div class=\"page-header-new-con\">\r\n                <a href=\"/\">\r\n<!--                    <img :style=\"{width: isPC?'64px':'108px',top: isPC?'40px':'78px',left:isPC?'40px':'28px'}\" class=\"page-header-new-fnji\" src=\"https://static.fnji.com/temp/upload/s20480_1630830637_5109.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1\" alt=\"\">-->\r\n                    <img :style=\"{width: isPC?'64px':'108px',top: isPC?'40px':'78px',left:isPC?'40px':'28px'}\" class=\"page-header-new-fnji\" src=\"/view-v2/web/static/img/page-header2024/fnji_logo.png\" alt=\"\">\r\n                </a>\r\n                <div :style=\"{top: isPC?'40px':'78px',right: isPC?'40px':'28px'}\" class=\"page-header-new-right\">\r\n                    <div class=\"page-header-new-cormal\" style=\"height: 32px;padding-top: 2px;\">\r\n<!--                        <img :style=\"{width: isPC?'26px':'44px',height: isPC?'22px':'36px'}\" @click=\"menuClick(1)\" v-if=\"!menuShow\" class=\"page-header-new-menu-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/fnji_menu_new.png\" alt=\"\">-->\r\n                        <img :style=\"{width: isPC?'26px':'44px',height: isPC?'22px':'36px'}\" @click=\"menuClick(1)\" v-if=\"!menuShow\" class=\"page-header-new-menu-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header2024/fnji_menu.png\" alt=\"\">\r\n<!--                        <img :style=\"{width: isPC?'26px':'44px',height: isPC?'22px':'36px'}\" @click=\"menuClick(2)\" v-if=\"menuShow\" class=\"page-header-new-close-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/close_menu_new.png\" alt=\"\">-->\r\n                    </div>\r\n                    <!--                <div :style=\"{'font-size': isPC?'22px':'38px','margin-right': isPC?'12px':'20px'}\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">EN</div>-->\r\n                    <!--                <div :style=\"{'font-size': isPC?'22px':'38px','margin-right': isPC?'12px':'20px'}\" class=\"page-header-new-cormal page-header-new-ls\">|</div>-->\r\n                    <!--                <div :style=\"{'font-size': isPC?'22px':'38px','margin-right': isPC?'12px':'20px'}\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">CN</div>-->\r\n                    <!--                <div class=\"page-header-new-cormal\" style=\"height: 32px;padding-top: 4px;\">-->\r\n                    <!--                    <input :style=\"{'font-size': isPC?'14px':'18px'}\" v-if=\"searchShow\" type=\"text\" class=\"u-search-input\" style=\"margin-right: 5px;\" v-model=\"searchText\" @keyup.enter=\"search()\">-->\r\n                    <!--                    <img :style=\"{width: isPC?'22px':'36px',height: isPC?'22px':'36px'}\" class=\"page-header-new-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/search_new.png\" alt=\"\">-->\r\n                    <!--                </div>-->\r\n                    <div style=\"clear: both;\"></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"page-header-new-menu\">\r\n            <div class=\"page-header-new-right\" style=\"z-index: 1;\">\r\n                <div class=\"page-header-new-cormal\" style=\"height: 32px;padding-top: 2px;\">\r\n                    <img :style=\"{width: isPC?'22px':'36px',height: isPC?'22px':'36px'}\" @click=\"menuClick(2)\" v-if=\"menuShow\" class=\"page-header-new-close-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/close_menu_new.png\" alt=\"\">\r\n                </div>\r\n                <div style=\"clear: both;\"></div>\r\n            </div>\r\n            <div class=\"page-header-new-menu-one\">\r\n                <div :style=\"{'font-size': isPC?'24px':'37px'}\" class=\"page-header-new-menu-list page-header-new-menu-list-first\">\r\n                    <ul>\r\n                        <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(item,index) in navMenu\" :key=\"index\"><a @mouseover=\"menuItemOver(item,index)\" :href=\"index==0||index==6||index==8?item.link:'javascript:void(0)'\" :class=\"{'page-header-new-menuList-color': theMenu==index}\">{{item.name}}</a></li>\r\n                    </ul>\r\n                </div>\r\n                <div class=\"page-header-new-menu-call\">\r\n                    <div class=\"page-header-new-menu-call-con\">\r\n<!--                        <div :style=\"{height:isPC?'72px':'102px'}\" style=\"margin-bottom: 20px;position:relative;\">-->\r\n<!--                            <div :class=\"searchShow?'page-header-new-menuList-search-hover':'page-header-new-menuList-search'\" class=\"page-header-new-cormal\" :style=\"{width:isPC?'213px':'240px','margin-left':isPC?'112px':'84px',height:isPC?'28px':'36px'}\" style=\"float: none;margin-bottom: 10px;margin-right: 0;\">-->\r\n<!--                                <input :style=\"{'font-size': isPC?'14px':'18px',width:isPC?'':'200px'}\" type=\"text\" class=\"u-search-input\" style=\"margin-right: 5px;border: 0;outline: none;\" v-model=\"searchText\" @keyup.enter=\"search()\">-->\r\n<!--                                <img :style=\"{width: isPC?'20px':'26px',height: isPC?'20px':'26px'}\" @click=\"search\" class=\"page-header-new-icon page-header-new-mouseover\" src=\"/view-v2/web/static/img/page-header/search_new_black.png\" alt=\"\">-->\r\n<!--                            </div>-->\r\n<!--                            <div style=\"height: 32px;overflow: hidden;\">-->\r\n<!--                                <div @click=\"changeType('en')\" :style=\"{'font-size': isPC?'18px':'22px','margin-left': isPC?'12px':'20px'}\" style=\"margin-right: 0;\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">EN</div>-->\r\n<!--                                <div :style=\"{'font-size': isPC?'18px':'22px','margin-left': isPC?'12px':'20px'}\" style=\"margin-right: 0;\" class=\"page-header-new-cormal page-header-new-ls\">|</div>-->\r\n<!--                                <div @click=\"changeType('zh')\" :style=\"{'font-size': isPC?'18px':'22px','margin-left': isPC?'12px':'20px'}\" style=\"margin-right: 0;\" class=\"page-header-new-cormal page-header-new-l page-header-new-mouseover\">CN</div>-->\r\n<!--                            </div>-->\r\n<!--                        </div>-->\r\n                        <div v-if=\"isPC\" class=\"page-header-new-menu-call-item\">BEIJING,CHINA 400-641-6399</div>\r\n                        <div v-if=\"!isPC\" style=\"font-size: 16px;line-height: 20px;height: 32px\" class=\"page-header-new-menu-call-item\">400-641-6399</div>\r\n                        <div class=\"page-header-new-menu-call-type\" style=\"margin-top: 5px\">\r\n                            <div :style=\"{'font-size': isPC?'10px':'16px','line-height': isPC?'16px':'30px',height: isPC?'16px':'30px'}\" class=\"page-header-new-menu-call-info\">service@fnji.com  |  marketing@fnji.com</div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"page-header-new-menu-two\" style=\"z-index: -1;border-right: 3px solid #979797;\">\r\n                    <div :style=\"{'font-size': isPC?'24px':'37px'}\" style=\"height: 100%;overflow-y: auto;\" class=\"page-header-new-menu-list page-header-new-menu-list-last\">\r\n                        <ul v-if=\"theMenu==4\" style=\"margin-bottom: 30px;\">\r\n                            <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(items,indexs) in navMenuShopsPhone\" :key=\"indexs\">\r\n                                <div v-if=\"items.phoneTitle!=''\">{{items.phoneTitle}}</div>\r\n                                <a v-else :href=\"items.link\" style=\"font-size: 30px\">{{items.phoneName}}</a>\r\n                            </li>\r\n                        </ul>\r\n                        <ul v-else-if=\"theMenu==5\" style=\"margin-bottom: 30px;\">\r\n                            <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(items,indexs) in navMenuArt\" :key=\"indexs\">\r\n                                <a :href=\"items.link\">{{items.name}}</a>\r\n                            </li>\r\n                        </ul>\r\n                        <ul v-else style=\"margin-bottom: 30px;\">\r\n                            <li :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(items,indexs) in navMenuList\"  v-if=\"items.link!='/download'\" :key=\"indexs\">\r\n                                <a :href=\"items.link\">{{items.name}}</a>\r\n                            </li>\r\n                            <!--                        <li v-if=\"navMenuNewList.length\"><div style=\"width: 100px;height: 1px;background: #C7C7C7;\"></div></li>-->\r\n                        </ul>\r\n                        <ul v-if=\"navMenuNewList&&navMenuNewList.length\" :style=\"{width:isPC?'85px':'150px'}\" style=\"padding-top: 30px;border-top: 2px solid #C7C7C7;padding-left: 0;float: right;\">\r\n                            <li v-if=\"navMenuNewList.length\" :style=\"{height: isPC?'45px':'60px'}\" v-for=\"(itemss,indexss) in navMenuNewList\">\r\n                                <div><a :href=\"itemss.link\">{{itemss.name}}</a></div>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(26)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Headroom
){
    return {
        mounted: function(){
            var headroom = new Headroom(this.$el);
            headroom.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * headroom.js v0.9.4 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

!function(a,b){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b():a.Headroom=b()}(this,function(){"use strict";function a(a){this.callback=a,this.ticking=!1}function b(a){return a&&"undefined"!=typeof window&&(a===window||a.nodeType)}function c(a){if(arguments.length<=0)throw new Error("Missing arguments in extend function");var d,e,f=a||{};for(e=1;e<arguments.length;e++){var g=arguments[e]||{};for(d in g)"object"!=typeof f[d]||b(f[d])?f[d]=f[d]||g[d]:f[d]=c(f[d],g[d])}return f}function d(a){return a===Object(a)?a:{down:a,up:a}}function e(a,b){b=c(b,e.options),this.lastKnownScrollY=0,this.elem=a,this.tolerance=d(b.tolerance),this.classes=b.classes,this.offset=b.offset,this.scroller=b.scroller,this.initialised=!1,this.onPin=b.onPin,this.onUnpin=b.onUnpin,this.onTop=b.onTop,this.onNotTop=b.onNotTop,this.onBottom=b.onBottom,this.onNotBottom=b.onNotBottom}var f={bind:!!function(){}.bind,classList:"classList"in document.documentElement,rAF:!!(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame)};return window.requestAnimationFrame=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame,a.prototype={constructor:a,update:function(){this.callback&&this.callback(),this.ticking=!1},requestTick:function(){this.ticking||(requestAnimationFrame(this.rafCallback||(this.rafCallback=this.update.bind(this))),this.ticking=!0)},handleEvent:function(){this.requestTick()}},e.prototype={constructor:e,init:function(){if(e.cutsTheMustard)return this.debouncer=new a(this.update.bind(this)),this.elem.classList.add(this.classes.initial),setTimeout(this.attachEvent.bind(this),100),this},destroy:function(){var a=this.classes;this.initialised=!1;for(var b in a)a.hasOwnProperty(b)&&this.elem.classList.remove(a[b]);this.scroller.removeEventListener("scroll",this.debouncer,!1)},attachEvent:function(){this.initialised||(this.lastKnownScrollY=this.getScrollY(),this.initialised=!0,this.scroller.addEventListener("scroll",this.debouncer,!1),this.debouncer.handleEvent())},unpin:function(){var a=this.elem.classList,b=this.classes;!a.contains(b.pinned)&&a.contains(b.unpinned)||(a.add(b.unpinned),a.remove(b.pinned),this.onUnpin&&this.onUnpin.call(this))},pin:function(){var a=this.elem.classList,b=this.classes;a.contains(b.unpinned)&&(a.remove(b.unpinned),a.add(b.pinned),this.onPin&&this.onPin.call(this))},top:function(){var a=this.elem.classList,b=this.classes;a.contains(b.top)||(a.add(b.top),a.remove(b.notTop),this.onTop&&this.onTop.call(this))},notTop:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notTop)||(a.add(b.notTop),a.remove(b.top),this.onNotTop&&this.onNotTop.call(this))},bottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.bottom)||(a.add(b.bottom),a.remove(b.notBottom),this.onBottom&&this.onBottom.call(this))},notBottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notBottom)||(a.add(b.notBottom),a.remove(b.bottom),this.onNotBottom&&this.onNotBottom.call(this))},getScrollY:function(){return void 0!==this.scroller.pageYOffset?this.scroller.pageYOffset:void 0!==this.scroller.scrollTop?this.scroller.scrollTop:(document.documentElement||document.body.parentNode||document.body).scrollTop},getViewportHeight:function(){return window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight},getElementPhysicalHeight:function(a){return Math.max(a.offsetHeight,a.clientHeight)},getScrollerPhysicalHeight:function(){return this.scroller===window||this.scroller===document.body?this.getViewportHeight():this.getElementPhysicalHeight(this.scroller)},getDocumentHeight:function(){var a=document.body,b=document.documentElement;return Math.max(a.scrollHeight,b.scrollHeight,a.offsetHeight,b.offsetHeight,a.clientHeight,b.clientHeight)},getElementHeight:function(a){return Math.max(a.scrollHeight,a.offsetHeight,a.clientHeight)},getScrollerHeight:function(){return this.scroller===window||this.scroller===document.body?this.getDocumentHeight():this.getElementHeight(this.scroller)},isOutOfBounds:function(a){var b=a<0,c=a+this.getScrollerPhysicalHeight()>this.getScrollerHeight();return b||c},toleranceExceeded:function(a,b){return Math.abs(a-this.lastKnownScrollY)>=this.tolerance[b]},shouldUnpin:function(a,b){var c=a>this.lastKnownScrollY,d=a>=this.offset;return c&&d&&b},shouldPin:function(a,b){var c=a<this.lastKnownScrollY,d=a<=this.offset;return c&&b||d},update:function(){var a=this.getScrollY(),b=a>this.lastKnownScrollY?"down":"up",c=this.toleranceExceeded(a,b);this.isOutOfBounds(a)||(a<=this.offset?this.top():this.notTop(),a+this.getViewportHeight()>=this.getScrollerHeight()?this.bottom():this.notBottom(),this.shouldUnpin(a,c)?this.unpin():this.shouldPin(a,c)&&this.pin(),this.lastKnownScrollY=a)}},e.options={tolerance:{up:0,down:0},offset:0,scroller:window,classes:{pinned:"headroom--pinned",unpinned:"headroom--unpinned",top:"headroom--top",notTop:"headroom--not-top",bottom:"headroom--bottom",notBottom:"headroom--not-bottom",initial:"headroom"}},e.cutsTheMustard="undefined"!=typeof f&&f.rAF&&f.bind&&f.classList,e});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(28),

    __webpack_require__(29)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl
){
    return {
        template: tpl
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"weui-mask_transparent\"></div>\r\n    <div class=\"weui-toast\">\r\n        <i class=\"weui-loading weui-icon_toast\"></i>\r\n        <p class=\"weui-toast__content\">Loading...</p>\r\n    </div>\r\n</div>"

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(30);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./loading.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./loading.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <member-login-modal\r\n            v-model=\"memberLoginModal.isShow\"\r\n            :modal-data=\"memberLoginModal.data\"\r\n            @register=\"showMemberRegisterModal\"\r\n            @reset-pass=\"showPassResetModal\"\r\n    ></member-login-modal>\r\n    <member-register-modal\r\n            v-model=\"memberRegisterModal.isShow\"\r\n            :modal-data=\"memberRegisterModal.data\"\r\n            @login=\"showMemberLoginModal\"\r\n    ></member-register-modal>\r\n    <pass-reset-modal\r\n            v-model=\"passResetModal.isShow\"\r\n            :modal-data=\"passResetModal.data\"\r\n            @login=\"showMemberLoginModal\"\r\n    ></pass-reset-modal>\r\n    <fnji-weixin-modal\r\n            v-model=\"fnjiWeixinModal.isShow\"\r\n            :modal-data=\"fnjiWeixinModal.data\"\r\n    ></fnji-weixin-modal>\r\n\r\n    <fnji-weixin-srv-modal\r\n            v-model=\"fnjiWeixinSrvModal.isShow\"\r\n            :modal-data=\"fnjiWeixinSrvModal.data\"\r\n    ></fnji-weixin-srv-modal>\r\n</div>"

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(34),
    __webpack_require__(6),
    __webpack_require__(14),
    __webpack_require__(5),

    __webpack_require__(37),
    __webpack_require__(38)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin,
    Auth,
    Api
){
    function genDefaultInfo(){
        return {
            phone: '',
            password: '',
            rememberMe: false
        };
    }
    function genDefaultQuickInfo(){
        return {
            phone: '',
            verifyCode: ''
        };
    }
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {
                info: genDefaultInfo(),
                infoQuick: genDefaultQuickInfo(),
                qrcodeId: 'wx_qrcode',
                isQuickLogin:true
            };
        },
        computed: {
            backUrl: function(){
                return this.modalData.from || window.location.href;
            }
        },
        watch: {
            value: function(v){
                if (v) {
                    this.initWxLogin();
                }
            }
        },
        methods: {
            changeQuickLogin:function()
            {
                this.isQuickLogin = !this.isQuickLogin;
            },
            sendVerifyCode: function(){
                var phone = this.infoQuick.phone;
                if (!phone){
                    return alert('手机或邮箱格式错误');
                }
                Api.sendVerifyCodeApi.ajax({phone:phone, jammer:FNJISite.user.jammer})
                    .done(function(data){
                        alert(data);
                    });
            },
            loginQuick:function(){
                this.infoQuick['isQuickLogin'] = true;
                Auth.login(this.infoQuick, this.modalData.from);
            },
            login: function(){
                this.info['isQuickLogin'] = false;
                Auth.login(this.info, this.modalData.from);
            },
            initWxLogin: function(){
                var _this = this;
                Api.getWxLoginInfoApi.ajax({backUrl: this.backUrl})
                    .done(function(data){
                        new WxLogin({
                            id:_this.qrcodeId,
                            appid: "wx9d5a22c9e6d334c2",
                            scope: "snsapi_login",
                            redirect_uri: data.callback,
                            href: 'data:text/css;base64,KiB7DQogICAgbWFyZ2luOiAwOw0KICAgIHBhZGRpbmc6IDA7DQp9DQouaW1wb3dlckJveCB7DQogICAgbGluZS1oZWlnaHQ6IDE7DQogICAgZm9udC1zaXplOiAwOw0KfQ0KLmltcG93ZXJCb3ggLnRpdGxlLA0KLmltcG93ZXJCb3ggLmluZm8NCnsNCiAgICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogICAgYm9yZGVyOiBub25lOw0KICAgIG1hcmdpbi10b3A6IDA7DQogICAgd2lkdGg6IDE1MHB4Ow0KfQ=='
                        });
                    });
            },
            register: function(){
                this.hide();
                this.$emit('register');
            },
            resetPass: function(){
                this.hide();
                this.$emit('reset-pass');
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-member-login\" v-show=\"value\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <button class=\"close\" @click=\"hide()\">&times;</button>\r\n            <div class=\"d-flex justify-content-between\">\r\n                <div class=\"block-left\">\r\n                    <div class=\"modal-title\">\r\n                        手机扫码登录\r\n                    </div>\r\n                    <div class=\"block-qrcode\">\r\n                        <div :id=\"qrcodeId\"></div>\r\n                    </div>\r\n                    <div class=\"text-muted\">\r\n                        打开微信扫一扫登录\r\n                    </div>\r\n                </div>\r\n<!--                <div class=\"block-right\" v-if=\"!isQuickLogin\">-->\r\n<!--                    <div class=\"modal-title\">-->\r\n<!--                        账户登录-->\r\n<!--                    </div>-->\r\n<!--                    <form @submit.prevent=\"login()\">-->\r\n<!--                        <div class=\"form-row\">-->\r\n<!--                            <input type=\"text\" autocomplete=\"off\" class=\"form-control\" placeholder=\"手机/邮箱\" required v-model=\"info.phone\">-->\r\n<!--                        </div>-->\r\n<!--                        <div class=\"form-row\">-->\r\n<!--                            <input type=\"password\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"密码\" required v-model=\"info.password\">-->\r\n<!--                        </div>-->\r\n<!--                        <div class=\"form-row\">-->\r\n<!--                            <label class=\"control checkbox\">-->\r\n<!--                                <input type=\"checkbox\" v-model=\"info.rememberMe\">-->\r\n<!--                                <span class=\"control-indicator\"></span>-->\r\n<!--                                记住密码-->\r\n<!--                            </label>-->\r\n<!--                            <a class=\"link\" href=\"javascript:\" @click=\"resetPass()\">忘记密码或账号</a>-->\r\n<!--                        </div>-->\r\n<!--                        <div class=\"block-btn\">-->\r\n<!--                            <button class=\"btn\" type=\"submit\">登录</button>-->\r\n<!--                        </div>-->\r\n<!--                    </form>-->\r\n<!--                    <div class=\"text-muted\">-->\r\n<!--                        还没有梵几账号-->\r\n<!--                        <a class=\"link\" href=\"javascript:\" @click=\"register()\">点击注册</a>-->\r\n\r\n\r\n<!--                    </div>-->\r\n\r\n<!--                    <div class=\"block-btn\">-->\r\n<!--                        <button class=\"btn btn-muted\" @click=\"changeQuickLogin()\" >手机快捷登录</button>-->\r\n<!--                    </div>-->\r\n\r\n<!--                </div>-->\r\n\r\n                <div class=\"block-right\" v-if=\"isQuickLogin\">\r\n                    <div class=\"modal-title\">\r\n                        手机快捷登录\r\n                    </div>\r\n                    <form @submit.prevent=\"loginQuick()\">\r\n\r\n                        <div class=\"form-row form-row-phone\">\r\n                            <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"手机\" required v-model=\"infoQuick.phone\">\r\n                            <button class=\"btn verify-code\" type=\"button\" @click=\"sendVerifyCode()\">验证</button>\r\n                        </div>\r\n                        <div class=\"form-row\">\r\n                            <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"验证码\" required v-model=\"infoQuick.verifyCode\">\r\n                        </div>\r\n\r\n                        <div class=\"form-row\" style=\"height: 18px;\">\r\n                        </div>\r\n\r\n                        <div class=\"block-btn\">\r\n                            <button class=\"btn\" type=\"submit\">登录</button>\r\n                        </div>\r\n                    </form>\r\n                    <div class=\"text-muted\">\r\n                        还没有梵几账号\r\n                        <a class=\"link\" href=\"javascript:\" @click=\"register()\">点击注册</a>\r\n\r\n                    </div>\r\n\r\n<!--                    <div class=\"block-btn\">-->\r\n<!--                        <button class=\"btn btn-muted\" @click=\"changeQuickLogin()\" >账户登录</button>-->\r\n<!--                    </div>-->\r\n\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(36);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./modal.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./modal.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

!function(a,b){function d(a){var e,c=b.createElement("iframe"),d="https://open.weixin.qq.com/connect/qrconnect?appid="+a.appid+"&scope="+a.scope+"&redirect_uri="+a.redirect_uri+"&state="+a.state+"&login_type=jssdk";d+=a.style?"&style="+a.style:"",d+=a.href?"&href="+a.href:"",c.src=d,c.frameBorder="0",c.allowTransparency="true",c.scrolling="no",c.sandbox='allow-top-navigation allow-forms allow-scripts allow-same-origin', c.width="300px",c.height="400px",e=b.getElementById(a.id),e.innerHTML="",e.appendChild(c)}a.WxLogin=d}(window,document);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(39);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-login.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-login.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(41),
    __webpack_require__(6),
    __webpack_require__(5),

    __webpack_require__(42)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin,
    Api
){
    function genDefaultInfo(){
        return {
            phone: '',
            verifyCode: '',
            password: '',
            passwordRepeat: '',
            readLaw: false
        };
    }
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {
                info: genDefaultInfo()
            };
        },
        methods: {
            sendVerifyCode: function(){
                var phone = this.info.phone;
                if (!phone){
                    return alert('手机或邮箱格式错误');
                }
                Api.sendVerifyCodeApi.ajax({phone:phone, jammer:FNJISite.user.jammer})
                    .done(function(data){
                        alert(data);
                    });
            },
            onConfirm: function(){
                if (this.info.password !== this.info.passwordRepeat){
                    return alert('两次密码输入不一致');
                }
                var _this = this;
                Api.registerApi.ajax({data_json: JSON.stringify(this.info)})
                    .done(function(){
                        _this.hide();
                        _this.$emit('login');
                    });
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-member-register\" v-show=\"value\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <button class=\"close\" @click=\"hide()\">&times;</button>\r\n            <div class=\"modal-title\">\r\n                注册\r\n            </div>\r\n            <form @submit.prevent=\"onConfirm()\">\r\n                <div class=\"form-row form-row-phone\">\r\n                    <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"手机/邮箱\" required v-model=\"info.phone\">\r\n                    <button style=\"font-size: 12px;\" class=\"btn\" type=\"button\" @click=\"sendVerifyCode()\">验证</button>\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"text\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"验证码\" required v-model=\"info.verifyCode\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"密码\" required v-model=\"info.password\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" autocomplete=\"off\"  class=\"form-control\" placeholder=\"重复密码\" required v-model=\"info.passwordRepeat\">\r\n                </div>\r\n                <div class=\"form-row\" style=\"border: none;\">\r\n                    <label class=\"control checkbox\">\r\n                        <input type=\"checkbox\" v-model=\"info.readLaw\">\r\n                        <span class=\"control-indicator\"></span>\r\n                        我已阅读并同意遵守\r\n                        <a href=\"javascript:\" class=\"link\">法律声明</a>\r\n                        和\r\n                        <a href=\"javascript:\" class=\"link\">隐私条款</a>\r\n                    </label>\r\n                </div>\r\n                <div class=\"block-btn\">\r\n                    <button class=\"btn\">注册</button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(43);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-register.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./member-register.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(45),
    __webpack_require__(6),
    __webpack_require__(5),

    __webpack_require__(46)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin,
    Api
){
    function genDefaultInfo(){
        return {
            phone: '',
            verifyCode: '',
            password: '',
            passwordRepeat: '',
            remember: true
        };
    }
    return {
        template: tpl,
        mixins: [ModalMixin],
        data: function(){
            return {
                info: genDefaultInfo()
            };
        },
        methods: {
            sendVerifyCode: function(){
                var phone = this.info.phone;
                if (!phone){
                    return alert('手机或邮箱格式错误');
                }
                Api.sendVerifyCodeApi.ajax({phone:phone, jammer:FNJISite.user.jammer})
                    .done(function(data){
                        alert(data);
                    });
            },
            onConfirm: function(){
                if (this.info.password !== this.info.passwordRepeat){
                    return alert('两次密码输入不一致');
                }
                var _this = this;
                Api.resetPassApi.ajax({data_json: JSON.stringify(this.info)})
                    .done(function(){
                        _this.$emit('login');
                    });
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-pass-reset\" v-show=\"value\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <button class=\"close\" @click=\"hide()\">&times;</button>\r\n            <div class=\"modal-title\">\r\n                找回密码<br>\r\n                <small>RESET PASSWORD</small>\r\n            </div>\r\n            <form @submit.prevent=\"onConfirm()\">\r\n                <div class=\"form-row form-row-phone\">\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"手机/邮箱\" required v-model=\"info.phone\">\r\n                    <button class=\"btn\" type=\"button\" @click=\"sendVerifyCode()\">验证</button>\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"验证码\" required v-model=\"info.verifyCode\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" class=\"form-control\" placeholder=\"密码\" required v-model=\"info.password\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <input type=\"password\" class=\"form-control\" placeholder=\"重复密码\" required v-model=\"info.passwordRepeat\">\r\n                </div>\r\n                <div class=\"form-row\">\r\n                    <label class=\"control checkbox\">\r\n                        <input type=\"checkbox\" v-model=\"info.remember\">\r\n                        <span class=\"control-indicator\"></span>\r\n                        我已阅读并同意遵守\r\n                        <a href=\"javascript:\">法律声明</a>\r\n                        和\r\n                        <a href=\"javascript:\">隐私条款</a>\r\n                    </label>\r\n                </div>\r\n                <div class=\"block-btn\">\r\n                    <button class=\"btn\">更新密码</button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(47);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./pass-reset.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./pass-reset.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(49),
    __webpack_require__(6),

    __webpack_require__(50)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin
){
    return {
        template: tpl,
        mixins: [ModalMixin]
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-fnji-weixin\" v-show=\"value\" @click=\"hide()\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <i class=\"u-icon u-icon-fnji-weixin\"></i>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(51);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(53),
    __webpack_require__(6),

    __webpack_require__(54)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    ModalMixin
){
    return {
        template: tpl,
        mixins: [ModalMixin]
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal modal-fnji-weixin-srv\" v-show=\"value\" @click=\"hide()\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <i class=\"u-icon u-icon-fnji-weixin\"></i>\r\n            <div style=\"font-size: 12px;padding-top: 10px;line-height: 20px;letter-spacing: 1px;\">微信扫描二维码关注梵几服务号<br>可以进行预约</div>\r\n\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(55);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin-srv.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./fnji-weixin-srv.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(57);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./wtf-forms.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./wtf-forms.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(59),
    __webpack_require__(1),
    __webpack_require__(2)

], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    Utils
){
    return {
        template: tpl,
        props: {
            menu: {
                type: Array
            },
            menuParent: {
                type: Object
            },
            offsetLeft: {
                type: Number,
                default: 0
            }
        },
        computed: {
            innerStyle: function(){
                return {
                    marginLeft: this.offsetLeft+ 'px'
                };
            }
        },
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "<div class=\"block-sub-nav\">\r\n    <div class=\"inner\">\r\n        <ul class=\"nav\" :style=\"{'margin-left': offsetLeft+'px'}\">\r\n\r\n            <!--<li class=\"nav-item\" v-if=\"menuParent.category==2\">-->\r\n                <!--<a class=\"nav-link\" :href=\"'/grocery?tab=recommend' | pageLink \">推荐</a>-->\r\n            <!--</li>-->\r\n\r\n\r\n\r\n            <!--<li class=\"nav-item\" v-if=\"menuParent.category==2\">-->\r\n                <!--<a style=\"font-family: sans-serif;\" class=\"nav-link\" >|</a>-->\r\n            <!--</li>-->\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/grocery?tab=new' | pageLink \">new</a>\r\n            </li>\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a style=\"font-family: sans-serif;\" class=\"nav-link\" >|</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-for=\"(o,index) in menu\">\r\n                <a :href=\"o.link | pageLink\" class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\">{{o.name}}</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2 || menuParent.category==1\">\r\n                <a style=\"font-family: sans-serif;\" class=\"nav-link\" >|</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/grocery-brands?brand=brand' | pageLink \">{{$t('headLeft.brand')}}</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==2\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/grocery?tab=discount' | pageLink \">Sale</a>\r\n            </li>\r\n\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==1\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/furniture-l2?bom=high' | pageLink \">{{$t('headLeft.crest')}}</a>\r\n            </li>\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==1\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/furniture-l2?bom=base' | pageLink \">{{$t('headLeft.earth')}}</a>\r\n            </li>\r\n<!--            <li class=\"nav-item\" v-if=\"menuParent.category==1\">-->\r\n<!--                <a class=\"nav-link\" :href=\"'/furniture-l2?bom=base' | pageLink \">本线</a>-->\r\n<!--            </li>-->\r\n            <li class=\"nav-item\" v-if=\"menuParent.category==1\">\r\n                <a class=\"nav-link\" :style=\"{'font-size': $i18n.locale=='zh'?'14px':'12px'}\" :href=\"'/furniture-l2?bom=ff' | pageLink \">{{$t('headLeft.ff')}}</a>\r\n            </li>\r\n\r\n        </ul>\r\n    </div>\r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    var BaseUrl = 'https://website.fnji.com/mt/s';
    // var BaseUrl = '';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        getFurnitureApi: new Api('/ProductCategoryModel/enum'),//家具列表
        getProListApi: new Api('/ProductSkuModel/getByCategory')//家具产品列表
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(62);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-header2024.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-header2024.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(64),
    __webpack_require__(12),
    __webpack_require__(10),
    __webpack_require__(1),

    __webpack_require__(17),
    __webpack_require__(66)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    PageReadyMixin,
    Modal,
    $
){
    var menuGroups = [
        {
            title: '关于我们',
            list: [
                {name: '梵几STORY', link: '/fnjibrand'},
                {name: '梵几实体店', link: '/shop'},
                {name: '媒体报道', link: '/fnjimedia'},
                {name: '招聘信息', link: '/job'}
            ]
        },
        {
            title: '购物指南',
            list: [
                {name: '购物流程', link: '/howshop'},
                {name: '会员制度', link: '/membership'}
            ]
        },
        {
            title: '关于配送',
            list: [
                {name: '家具配送', link: '/aboutdeliver?index=0'},
                {name: '家居配送', link: '/aboutdeliver?index=1'},
                {name: '一枚板配送', link: '/aboutdeliver?index=2'}
            ]
        },
        {
            title: '售后服务',
            list: [
                {name: '家具售后', link: '/aboutservice?index=0'},
                {name: '家居售后', link: '/aboutservice?index=1'}
            ]
        },
        {
            title: '商业合作',
            list: [
                {name: '项目批量采购', link: '/site/cooperate?type=1'},
                {name: '设计公司合作', link: '/site/cooperate?type=2'},
                {name: '家居品牌合作', link: '/site/cooperate?type=3'},
                {name: '市场&媒体合作', link: '/site/cooperate?type=4'},
                {name: '艺术品合作', link: '/site/cooperate?type=5'},
                {name: '产品目录下载', link: '/temp/upload/productinfo/产品目录.zip'}
            ]
        }
    ];
    return {
        template: tpl,
        mixins: [PageReadyMixin],
        data: function(){
            return {
                menuGroups: [],
                footerNew: [
                    {name: '媒体报道', link: '/fnjimedia'},
                    {name: '招聘信息', link: '/job'},
                    {name: '售后服务', link: '/aboutservice'},
                    {name: '联系我们', link: '/site/cooperate?type=1'}
                ],
                isPC: true,
                isZh: true
            };
        },
        methods: {
            init: function(){
                var _this = this;
                if($(window).width()<755){
                    _this.isPC = false;
                }
                if(_this.$i18n.locale=='en'){
                    _this.footerNew = _this.$i18n.messages.en.footerNew;
                    _this.isZh = false;
                }else {
                    _this.footerNew = _this.$i18n.messages.zh.footerNew;
                    _this.isZh = true;
                }
            },
            showFnjiWeixinModal: function(){
                Modal.showFnjiWeixinModal();
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "<!--<div class=\"page-footer font-sy\" v-show=\"isPageReady\">-->\r\n<div id=\"page-footer-new\" :style=\"{height:isPC?'560px':'940px'}\" :class=\"isPC?'page-footer-new':'page-footer-new-phone'\" style=\"float: none;\" class=\"page-footer font-sy\">\r\n    <div class=\"container\" style=\"margin-right: auto;margin-left: auto;width: 100%;\">\r\n<!--        <div class=\"page-footer-new-header\">-->\r\n<!--            <div class=\"page-footer-new-header-icon\"></div>-->\r\n<!--            <div :style=\"{'font-size':isPC?'16px':'22px','line-height':isPC?'17px':'24px'}\" class=\"page-footer-new-header-info\">-->\r\n<!--                <div>探寻东方与西方之间</div>-->\r\n<!--                <div>现代与传统之间</div>-->\r\n<!--                <div>记忆与未来之间的美学平衡与灵感世界</div>-->\r\n<!--            </div>-->\r\n<!--        </div>-->\r\n        <div v-if=\"!isPC\" class=\"page-footer-new-bottom-phone\">\r\n            <div class=\"page-footer-new-bottom-phone-icon\">\r\n                <a href=\"https://weibo.com/fnji\" target=\"_blank\"><i style=\"margin: 0 26px 0 0;width: 40px;height: 40px;\" class=\"u-icon u-icon-weibo\"></i></a>\r\n                <a href=\"javascript:\" @click=\"showFnjiWeixinModal()\"><i style=\"margin: 0;width: 40px;height: 40px;\" class=\"u-icon u-icon-weixin\"></i></a>\r\n            </div>\r\n            <div class=\"page-footer-new-bottom-info-phone\">\r\n                <div></div><div class=\"page-footer-new-rbt\">service@fnji.com</div>\r\n                <div></div><div class=\"page-footer-new-rbt\">marketing@fnji.com</div>\r\n                <div class=\"page-footer-new-rbt\">TEL</div><div>400-641-6399</div>\r\n            </div>\r\n            <div style=\"justify-content: center;\" class=\"d-flex block-nav\">\r\n                <ul class=\"nav flex-column\" :style=\"{'width': $i18n.locale=='en'?'250px':'180px'}\" :class=\"{'page-fo-first-phone':$i18n.locale=='en'&&indexs===0,'page-fo-second-phone':$i18n.locale=='en'&&indexs===2,'page-fo-seconds-phone':$i18n.locale=='en'&&indexs===1}\" v-for=\"(groups,indexs) in footerNew\" :key=\"indexs\">\r\n                    <li :style=\"{'padding-left': isPC?'25px!important':'36px!important'}\" :class=\"indexs===0?'':'page-footer-new-bottom-header-phone'\" class=\"page-footer-new-bottom-link-phone\">\r\n                        <a style=\"color: #4D4D4D;\" :href=\"groups.link | genUrl\" class=\"nav-link page-footer-new-link\">{{groups.name}}</a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n            <div class=\"page-footer-new-bottom-do-phone\">\r\n                © Fnji Interior design Co,Ltd.Beijing,China 京ICP备13004049号－3\r\n            </div>\r\n        </div>\r\n        <div v-if=\"isPC\" class=\"page-footer-new-bottom\">\r\n            <div class=\"d-flex justify-content-between\">\r\n                <div class=\"d-flex block-nav\">\r\n                    <ul class=\"nav flex-column\" :style=\"{'width': $i18n.locale=='en'?'160px':'150px'}\" :class=\"{'page-fo-first':$i18n.locale=='en'&&index===0,'page-fo-second':$i18n.locale=='en'&&index===2}\" v-for=\"(group,index) in footerNew\" :key=\"index\">\r\n                        <li class=\"nav-header\">\r\n                            <a :href=\"group.link | genUrl\" class=\"nav-link\">{{group.name}}</a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n                <div style=\"margin-bottom: 20px;\">\r\n                    <a href=\"javascript:\" @click=\"showFnjiWeixinModal()\"><i class=\"u-icon u-icon-weixin\"></i></a>\r\n                    <a href=\"https://weibo.com/fnji\" target=\"_blank\"><i class=\"u-icon u-icon-weibo\"></i></a>\r\n                </div>\r\n            </div>\r\n            <div class=\"d-flex justify-content-between\">\r\n                <div class=\"fs-12 align-self-end\" style=\"font-size: 14px;\">\r\n<!--                    梵几独立家居品牌 © 2017 Fnji Interior design Co. Ltd. Beijing, China 京ICP备13004049号-3-->\r\n                    梵几独立家居品牌 © Fnji Interior design Co,Ltd.Beijing,China 京ICP备13004049号－3\r\n                </div>\r\n                <div class=\"text-right align-self-end\">\r\n                    <div class=\"fs-12\" style=\"font-size: 14px;\">\r\n\r\n                        <span class=\"page-footer-new-rbt\">service@fnji.com</span>\r\n                        <span style=\"margin: 0 10px;\">/</span>\r\n\r\n                        <span class=\"page-footer-new-rbt\">marketing@fnji.com</span>\r\n                        <span class=\"page-footer-new-rbt\" style=\"margin: 0 10px;\">/</span>\r\n                        TEL 400-641-6399\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(67);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-footer-new.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-footer-new.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(2),
    __webpack_require__(4),
    __webpack_require__(1),
    __webpack_require__(69),
    __webpack_require__(11),
    __webpack_require__(70),

    __webpack_require__(71),
    __webpack_require__(85)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Utils,
    Vue,
    $,
    VueLazyload,
    VueI18n,
    VueCustom
){
    Vue.use(VueLazyload, {
        preLoad: 1
    });
    Vue.use(VueI18n);
    Vue.use(VueCustom);

    Vue.prototype.V2 = {cdn:'http://static-test.fnji.com'}
    Vue.prototype.V1 = {cdn:'https://static.fnji.com'}

    $(document).on('click', 'a[href="#"]', function(e){
        e.preventDefault();
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Vue-Lazyload.js v1.2.6
 * (c) 2018 Awe <hilongjw@gmail.com>
 * Released under the MIT License.
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.VueLazyload=e()}(this,function(){"use strict";function t(t){return t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}function e(t){t=t||{};var e=arguments.length,i=0;if(1===e)return t;for(;++i<e;){var o=arguments[i];g(t)&&(t=o),r(o)&&n(t,o)}return t}function n(t,n){m(t,n);for(var o in n)if("__proto__"!==o&&i(n,o)){var a=n[o];r(a)?("undefined"===L(t[o])&&"function"===L(a)&&(t[o]=a),t[o]=e(t[o]||{},a)):t[o]=a}return t}function r(t){return"object"===L(t)||"function"===L(t)}function i(t,e){return Object.prototype.hasOwnProperty.call(t,e)}function o(t,e){if(t.length){var n=t.indexOf(e);return n>-1?t.splice(n,1):void 0}}function a(t,e){for(var n=!1,r=0,i=t.length;r<i;r++)if(e(t[r])){n=!0;break}return n}function s(t,e){if("IMG"===t.tagName&&t.getAttribute("data-srcset")){var n=t.getAttribute("data-srcset"),r=[],i=t.parentNode,o=i.offsetWidth*e,a=void 0,s=void 0,u=void 0;n=n.trim().split(","),n.map(function(t){t=t.trim(),a=t.lastIndexOf(" "),-1===a?(s=t,u=999998):(s=t.substr(0,a),u=parseInt(t.substr(a+1,t.length-a-2),10)),r.push([u,s])}),r.sort(function(t,e){if(t[0]<e[0])return-1;if(t[0]>e[0])return 1;if(t[0]===e[0]){if(-1!==e[1].indexOf(".webp",e[1].length-5))return 1;if(-1!==t[1].indexOf(".webp",t[1].length-5))return-1}return 0});for(var l="",d=void 0,c=r.length,h=0;h<c;h++)if(d=r[h],d[0]>=o){l=d[1];break}return l}}function u(t,e){for(var n=void 0,r=0,i=t.length;r<i;r++)if(e(t[r])){n=t[r];break}return n}function l(){if(!E)return!1;var t=!0,e=document;try{var n=e.createElement("object");n.type="image/webp",n.style.visibility="hidden",n.innerHTML="!",e.body.appendChild(n),t=!n.offsetWidth,e.body.removeChild(n)}catch(e){t=!1}return t}function d(t,e){var n=null,r=0;return function(){if(!n){var i=Date.now()-r,o=this,a=arguments,s=function(){r=Date.now(),n=!1,t.apply(o,a)};i>=e?s():n=setTimeout(s,e)}}}function c(t){return null!==t&&"object"===(void 0===t?"undefined":p(t))}function h(t){if(!(t instanceof Object))return[];if(Object.keys)return Object.keys(t);var e=[];for(var n in t)t.hasOwnProperty(n)&&e.push(n);return e}function f(t){for(var e=t.length,n=[],r=0;r<e;r++)n.push(t[r]);return n}function v(){}var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},b=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},y=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),g=function(t){return null==t||"function"!=typeof t&&"object"!==(void 0===t?"undefined":p(t))},m=function(t,e){if(null===t||void 0===t)throw new TypeError("expected first argument to be an object.");if(void 0===e||"undefined"==typeof Symbol)return t;if("function"!=typeof Object.getOwnPropertySymbols)return t;for(var n=Object.prototype.propertyIsEnumerable,r=Object(t),i=arguments.length,o=0;++o<i;)for(var a=Object(arguments[o]),s=Object.getOwnPropertySymbols(a),u=0;u<s.length;u++){var l=s[u];n.call(a,l)&&(r[l]=a[l])}return r},w=Object.prototype.toString,L=function(e){var n=void 0===e?"undefined":p(e);return"undefined"===n?"undefined":null===e?"null":!0===e||!1===e||e instanceof Boolean?"boolean":"string"===n||e instanceof String?"string":"number"===n||e instanceof Number?"number":"function"===n||e instanceof Function?void 0!==e.constructor.name&&"Generator"===e.constructor.name.slice(0,9)?"generatorfunction":"function":void 0!==Array.isArray&&Array.isArray(e)?"array":e instanceof RegExp?"regexp":e instanceof Date?"date":(n=w.call(e),"[object RegExp]"===n?"regexp":"[object Date]"===n?"date":"[object Arguments]"===n?"arguments":"[object Error]"===n?"error":"[object Promise]"===n?"promise":t(e)?"buffer":"[object Set]"===n?"set":"[object WeakSet]"===n?"weakset":"[object Map]"===n?"map":"[object WeakMap]"===n?"weakmap":"[object Symbol]"===n?"symbol":"[object Map Iterator]"===n?"mapiterator":"[object Set Iterator]"===n?"setiterator":"[object String Iterator]"===n?"stringiterator":"[object Array Iterator]"===n?"arrayiterator":"[object Int8Array]"===n?"int8array":"[object Uint8Array]"===n?"uint8array":"[object Uint8ClampedArray]"===n?"uint8clampedarray":"[object Int16Array]"===n?"int16array":"[object Uint16Array]"===n?"uint16array":"[object Int32Array]"===n?"int32array":"[object Uint32Array]"===n?"uint32array":"[object Float32Array]"===n?"float32array":"[object Float64Array]"===n?"float64array":"object")},_=e,E="undefined"!=typeof window,A=E&&"IntersectionObserver"in window,k={event:"event",observer:"observer"},z=function(){function t(t,e){e=e||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(t,e.bubbles,e.cancelable,e.detail),n}if(E)return"function"==typeof window.CustomEvent?window.CustomEvent:(t.prototype=window.Event.prototype,t)}(),j=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return E?window.devicePixelRatio||t:t},T=function(){if(E){var t=!1;try{var e=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("test",null,e)}catch(t){}return t}}(),S={on:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];T?t.addEventListener(e,n,{capture:r,passive:!0}):t.addEventListener(e,n,r)},off:function(t,e,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];t.removeEventListener(e,n,r)}},I=function(t,e,n){var r=new Image;r.src=t.src,r.onload=function(){e({naturalHeight:r.naturalHeight,naturalWidth:r.naturalWidth,src:r.src})},r.onerror=function(t){n(t)}},O=function(t,e){return"undefined"!=typeof getComputedStyle?getComputedStyle(t,null).getPropertyValue(e):t.style[e]},$=function(t){return O(t,"overflow")+O(t,"overflow-y")+O(t,"overflow-x")},x=function(t){if(E){if(!(t instanceof HTMLElement))return window;for(var e=t;e&&e!==document.body&&e!==document.documentElement&&e.parentNode;){if(/(scroll|auto)/.test($(e)))return e;e=e.parentNode}return window}},H={},Q=function(){function t(e){var n=e.el,r=e.src,i=e.error,o=e.loading,a=e.bindType,s=e.$parent,u=e.options,l=e.elRenderer;b(this,t),this.el=n,this.src=r,this.error=i,this.loading=o,this.bindType=a,this.attempt=0,this.naturalHeight=0,this.naturalWidth=0,this.options=u,this.rect=null,this.$parent=s,this.elRenderer=l,this.performanceData={init:Date.now(),loadStart:0,loadEnd:0},this.filter(),this.initState(),this.render("loading",!1)}return y(t,[{key:"initState",value:function(){"dataset"in this.el?this.el.dataset.src=this.src:this.el.setAttribute("data-src",this.src),this.state={error:!1,loaded:!1,rendered:!1}}},{key:"record",value:function(t){this.performanceData[t]=Date.now()}},{key:"update",value:function(t){var e=t.src,n=t.loading,r=t.error,i=this.src;this.src=e,this.loading=n,this.error=r,this.filter(),i!==this.src&&(this.attempt=0,this.initState())}},{key:"getRect",value:function(){this.rect=this.el.getBoundingClientRect()}},{key:"checkInView",value:function(){return this.getRect(),this.rect.top<window.innerHeight*this.options.preLoad&&this.rect.bottom>this.options.preLoadTop&&this.rect.left<window.innerWidth*this.options.preLoad&&this.rect.right>0}},{key:"filter",value:function(){var t=this;h(this.options.filter).map(function(e){t.options.filter[e](t,t.options)})}},{key:"renderLoading",value:function(t){var e=this;I({src:this.loading},function(n){e.render("loading",!1),t()},function(){t(),e.options.silent||console.warn("VueLazyload log: load failed with loading image("+e.loading+")")})}},{key:"load",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v;return this.attempt>this.options.attempt-1&&this.state.error?(this.options.silent||console.log("VueLazyload log: "+this.src+" tried too more than "+this.options.attempt+" times"),void e()):this.state.loaded||H[this.src]?(this.state.loaded=!0,e(),this.render("loaded",!0)):void this.renderLoading(function(){t.attempt++,t.record("loadStart"),I({src:t.src},function(n){t.naturalHeight=n.naturalHeight,t.naturalWidth=n.naturalWidth,t.state.loaded=!0,t.state.error=!1,t.record("loadEnd"),t.render("loaded",!1),H[t.src]=1,e()},function(e){!t.options.silent&&console.error(e),t.state.error=!0,t.state.loaded=!1,t.render("error",!1)})})}},{key:"render",value:function(t,e){this.elRenderer(this,t,e)}},{key:"performance",value:function(){var t="loading",e=0;return this.state.loaded&&(t="loaded",e=(this.performanceData.loadEnd-this.performanceData.loadStart)/1e3),this.state.error&&(t="error"),{src:this.src,state:t,time:e}}},{key:"destroy",value:function(){this.el=null,this.src=null,this.error=null,this.loading=null,this.bindType=null,this.attempt=0}}]),t}(),C="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",R=["scroll","wheel","mousewheel","resize","animationend","transitionend","touchmove"],W={rootMargin:"0px",threshold:0},B=function(t){return function(){function e(t){var n=t.preLoad,r=t.error,i=t.throttleWait,o=t.preLoadTop,a=t.dispatchEvent,s=t.loading,u=t.attempt,c=t.silent,h=void 0===c||c,f=t.scale,v=t.listenEvents,p=(t.hasbind,t.filter),y=t.adapter,g=t.observer,m=t.observerOptions;b(this,e),this.version="1.2.6",this.mode=k.event,this.ListenerQueue=[],this.TargetIndex=0,this.TargetQueue=[],this.options={silent:h,dispatchEvent:!!a,throttleWait:i||200,preLoad:n||1.3,preLoadTop:o||0,error:r||C,loading:s||C,attempt:u||3,scale:f||j(f),ListenEvents:v||R,hasbind:!1,supportWebp:l(),filter:p||{},adapter:y||{},observer:!!g,observerOptions:m||W},this._initEvent(),this.lazyLoadHandler=d(this._lazyLoadHandler.bind(this),this.options.throttleWait),this.setMode(this.options.observer?k.observer:k.event)}return y(e,[{key:"config",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};_(this.options,t)}},{key:"performance",value:function(){var t=[];return this.ListenerQueue.map(function(e){t.push(e.performance())}),t}},{key:"addLazyBox",value:function(t){this.ListenerQueue.push(t),E&&(this._addListenerTarget(window),this._observer&&this._observer.observe(t.el),t.$el&&t.$el.parentNode&&this._addListenerTarget(t.$el.parentNode))}},{key:"add",value:function(e,n,r){var i=this;if(a(this.ListenerQueue,function(t){return t.el===e}))return this.update(e,n),t.nextTick(this.lazyLoadHandler);var o=this._valueFormatter(n.value),u=o.src,l=o.loading,d=o.error;t.nextTick(function(){u=s(e,i.options.scale)||u,i._observer&&i._observer.observe(e);var o=Object.keys(n.modifiers)[0],a=void 0;o&&(a=r.context.$refs[o],a=a?a.$el||a:document.getElementById(o)),a||(a=x(e));var c=new Q({bindType:n.arg,$parent:a,el:e,loading:l,error:d,src:u,elRenderer:i._elRenderer.bind(i),options:i.options});i.ListenerQueue.push(c),E&&(i._addListenerTarget(window),i._addListenerTarget(a)),i.lazyLoadHandler(),t.nextTick(function(){return i.lazyLoadHandler()})})}},{key:"update",value:function(e,n){var r=this,i=this._valueFormatter(n.value),o=i.src,a=i.loading,l=i.error;o=s(e,this.options.scale)||o;var d=u(this.ListenerQueue,function(t){return t.el===e});d&&d.update({src:o,loading:a,error:l}),this._observer&&(this._observer.unobserve(e),this._observer.observe(e)),this.lazyLoadHandler(),t.nextTick(function(){return r.lazyLoadHandler()})}},{key:"remove",value:function(t){if(t){this._observer&&this._observer.unobserve(t);var e=u(this.ListenerQueue,function(e){return e.el===t});e&&(this._removeListenerTarget(e.$parent),this._removeListenerTarget(window),o(this.ListenerQueue,e)&&e.destroy())}}},{key:"removeComponent",value:function(t){t&&(o(this.ListenerQueue,t),this._observer&&this._observer.unobserve(t.el),t.$parent&&t.$el.parentNode&&this._removeListenerTarget(t.$el.parentNode),this._removeListenerTarget(window))}},{key:"setMode",value:function(t){var e=this;A||t!==k.observer||(t=k.event),this.mode=t,t===k.event?(this._observer&&(this.ListenerQueue.forEach(function(t){e._observer.unobserve(t.el)}),this._observer=null),this.TargetQueue.forEach(function(t){e._initListen(t.el,!0)})):(this.TargetQueue.forEach(function(t){e._initListen(t.el,!1)}),this._initIntersectionObserver())}},{key:"_addListenerTarget",value:function(t){if(t){var e=u(this.TargetQueue,function(e){return e.el===t});return e?e.childrenCount++:(e={el:t,id:++this.TargetIndex,childrenCount:1,listened:!0},this.mode===k.event&&this._initListen(e.el,!0),this.TargetQueue.push(e)),this.TargetIndex}}},{key:"_removeListenerTarget",value:function(t){var e=this;this.TargetQueue.forEach(function(n,r){n.el===t&&(--n.childrenCount||(e._initListen(n.el,!1),e.TargetQueue.splice(r,1),n=null))})}},{key:"_initListen",value:function(t,e){var n=this;this.options.ListenEvents.forEach(function(r){return S[e?"on":"off"](t,r,n.lazyLoadHandler)})}},{key:"_initEvent",value:function(){var t=this;this.Event={listeners:{loading:[],loaded:[],error:[]}},this.$on=function(e,n){t.Event.listeners[e]||(t.Event.listeners[e]=[]),t.Event.listeners[e].push(n)},this.$once=function(e,n){function r(){i.$off(e,r),n.apply(i,arguments)}var i=t;t.$on(e,r)},this.$off=function(e,n){if(!n){if(!t.Event.listeners[e])return;return void(t.Event.listeners[e].length=0)}o(t.Event.listeners[e],n)},this.$emit=function(e,n,r){t.Event.listeners[e]&&t.Event.listeners[e].forEach(function(t){return t(n,r)})}}},{key:"_lazyLoadHandler",value:function(){var t=this,e=[];this.ListenerQueue.forEach(function(t,n){if(!t.state.error&&t.state.loaded)return e.push(t);t.checkInView()&&t.load()}),e.forEach(function(e){return o(t.ListenerQueue,e)})}},{key:"_initIntersectionObserver",value:function(){var t=this;A&&(this._observer=new IntersectionObserver(this._observerHandler.bind(this),this.options.observerOptions),this.ListenerQueue.length&&this.ListenerQueue.forEach(function(e){t._observer.observe(e.el)}))}},{key:"_observerHandler",value:function(t,e){var n=this;t.forEach(function(t){t.isIntersecting&&n.ListenerQueue.forEach(function(e){if(e.el===t.target){if(e.state.loaded)return n._observer.unobserve(e.el);e.load()}})})}},{key:"_elRenderer",value:function(t,e,n){if(t.el){var r=t.el,i=t.bindType,o=void 0;switch(e){case"loading":o=t.loading;break;case"error":o=t.error;break;default:o=t.src}if(i?r.style[i]='url("'+o+'")':r.getAttribute("src")!==o&&r.setAttribute("src",o),r.setAttribute("lazy",e),this.$emit(e,t,n),this.options.adapter[e]&&this.options.adapter[e](t,this.options),this.options.dispatchEvent){var a=new z(e,{detail:t});r.dispatchEvent(a)}}}},{key:"_valueFormatter",value:function(t){var e=t,n=this.options.loading,r=this.options.error;return c(t)&&(t.src||this.options.silent||console.error("Vue Lazyload warning: miss src with "+t),e=t.src,n=t.loading||this.options.loading,r=t.error||this.options.error),{src:e,loading:n,error:r}}}]),e}()},D=function(t){return{props:{tag:{type:String,default:"div"}},render:function(t){return!1===this.show?t(this.tag):t(this.tag,null,this.$slots.default)},data:function(){return{el:null,state:{loaded:!1},rect:{},show:!1}},mounted:function(){this.el=this.$el,t.addLazyBox(this),t.lazyLoadHandler()},beforeDestroy:function(){t.removeComponent(this)},methods:{getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),E&&this.rect.top<window.innerHeight*t.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*t.options.preLoad&&this.rect.right>0},load:function(){this.show=!0,this.state.loaded=!0,this.$emit("show",this)}}}},V=function(){function t(e){var n=e.lazy;b(this,t),this.lazy=n,n.lazyContainerMananger=this,this._queue=[]}return y(t,[{key:"bind",value:function(t,e,n){var r=new N({el:t,binding:e,vnode:n,lazy:this.lazy});this._queue.push(r)}},{key:"update",value:function(t,e,n){var r=u(this._queue,function(e){return e.el===t});r&&r.update({el:t,binding:e,vnode:n})}},{key:"unbind",value:function(t,e,n){var r=u(this._queue,function(e){return e.el===t});r&&(r.clear(),o(this._queue,r))}}]),t}(),M={selector:"img"},N=function(){function t(e){var n=e.el,r=e.binding,i=e.vnode,o=e.lazy;b(this,t),this.el=null,this.vnode=i,this.binding=r,this.options={},this.lazy=o,this._queue=[],this.update({el:n,binding:r})}return y(t,[{key:"update",value:function(t){var e=this,n=t.el,r=t.binding;this.el=n,this.options=_({},M,r.value),this.getImgs().forEach(function(t){e.lazy.add(t,_({},e.binding,{value:{src:"dataset"in t?t.dataset.src:t.getAttribute("data-src"),error:"dataset"in t?t.dataset.error:t.getAttribute("data-error"),loading:"dataset"in t?t.dataset.loading:t.getAttribute("data-loading")}}),e.vnode)})}},{key:"getImgs",value:function(){return f(this.el.querySelectorAll(this.options.selector))}},{key:"clear",value:function(){var t=this;this.getImgs().forEach(function(e){return t.lazy.remove(e)}),this.vnode=null,this.binding=null,this.lazy=null}}]),t}(),P=function(t){return{props:{src:[String,Object],tag:{type:String,default:"img"}},render:function(t){return t(this.tag,{attrs:{src:this.renderSrc}},this.$slots.default)},data:function(){return{el:null,options:{src:"",error:"",loading:"",attempt:t.options.attempt},state:{loaded:!1,error:!1,attempt:0},rect:{},renderSrc:""}},watch:{src:function(){this.init(),t.addLazyBox(this),t.lazyLoadHandler()}},created:function(){this.init(),this.renderSrc=this.options.loading},mounted:function(){this.el=this.$el,t.addLazyBox(this),t.lazyLoadHandler()},beforeDestroy:function(){t.removeComponent(this)},methods:{init:function(){var e=t._valueFormatter(this.src),n=e.src,r=e.loading,i=e.error;this.state.loaded=!1,this.options.src=n,this.options.error=i,this.options.loading=r,this.renderSrc=this.options.loading},getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),E&&this.rect.top<window.innerHeight*t.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*t.options.preLoad&&this.rect.right>0},load:function(){var e=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v;if(this.state.attempt>this.options.attempt-1&&this.state.error)return t.options.silent||console.log("VueLazyload log: "+this.options.src+" tried too more than "+this.options.attempt+" times"),void n();var r=this.options.src;I({src:r},function(t){var n=t.src;e.renderSrc=n,e.state.loaded=!0},function(t){e.state.attempt++,e.renderSrc=e.options.error,e.state.error=!0})}}}};return{install:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=B(t),r=new n(e),i=new V({lazy:r}),o="2"===t.version.split(".")[0];t.prototype.$Lazyload=r,e.lazyComponent&&t.component("lazy-component",D(r)),e.lazyImage&&t.component("lazy-image",P(r)),o?(t.directive("lazy",{bind:r.add.bind(r),update:r.update.bind(r),componentUpdated:r.lazyLoadHandler.bind(r),unbind:r.remove.bind(r)}),t.directive("lazy-container",{bind:i.bind.bind(i),update:i.update.bind(i),unbind:i.unbind.bind(i)})):(t.directive("lazy",{bind:r.lazyLoadHandler.bind(r),update:function(t,e){_(this.vm.$refs,this.vm.$els),r.add(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){r.remove(this.el)}}),t.directive("lazy-container",{update:function(t,e){i.update(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:t,oldValue:e},{context:this.vm})},unbind:function(){i.unbind(this.el)}}))}}});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(2)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Utils
){
    return {
        install: function(Vue, options){
            Vue.mixin({
                methods: {
                    fnjiImage: Utils.genFnjiImageUrl,
                    cdnImage: Utils.genCdnImageUrl
                },
                filters: {
                    fnjiImage: Utils.genFnjiImageUrl,
                    cdnImage: Utils.genCdnImageUrl,
                    cdnImageOrg: Utils.genCdnImageUrlOrg,
                    pageLink: Utils.genPageLink,
                    genUrl: Utils.genPageLink
                }
            });
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(72),
    __webpack_require__(4),
    __webpack_require__(1),
    __webpack_require__(2),
    __webpack_require__(73),
    __webpack_require__(77),

    __webpack_require__(83)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    Vue,
    $,
    Utils,
    TalkBtn,
    ShareBtn
){
    var $overlay = $('<div/>').appendTo('body');

    return new Vue({
        el: $overlay[0],
        template: tpl,
        components: {
            TalkBtn: TalkBtn,
            ShareBtn: ShareBtn
        },
        data: {
            isBottomBtnShow: true,
            isTopBtnShow: false,
            shareBtnData: null
        },
        methods: {
            initTopBtn: function(){
                var $window = $(window);
                var height = $window.height();
                var _this = this;

                $window.on('scroll resize', function(){
                    var scrollTop = $window.scrollTop();
                    _this.isTopBtnShow = scrollTop > height;
                });
            },
            scrollToTop: function(){
                Utils.scrollTo(0);
            },
            setShareBtnData: function(obj){
                this.shareBtnData = obj;
            },
            scrollToBottom: function () {
                var $windows = $(window);
                var heights = $windows.height();
                var bodyHeight = document.body.scrollHeight;
                var scrollHeight = bodyHeight - heights;
                Utils.scrollTo(scrollHeight)
            }
        },
        mounted: function(){
            this.initTopBtn();
        }
    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fixed-menu\">\r\n    <share-btn class=\"icon\" :item=\"shareBtnData\"></share-btn>\r\n<!--    <talk-btn class=\"icon\"></talk-btn>-->\r\n    <div class=\"icon icon-top\" v-show=\"isTopBtnShow\" @click=\"scrollToTop()\">\r\n        <i class=\"u-icon u-icon-top\"></i>\r\n    </div>\r\n    <div class=\"icon icon-top\" @click=\"scrollToBottom()\">\r\n        <i class=\"u-icon u-icon-bottom\"></i>\r\n    </div>\r\n</div>"

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(74),
    __webpack_require__(1),
    __webpack_require__(13),
    __webpack_require__(3),
    __webpack_require__(2),
    __webpack_require__(10),

    __webpack_require__(15),
    __webpack_require__(75)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    AuthMixin,
    _,
    Utils,
    Modal
){
    var chatOrigin = '//talk.fnji.com';
    var hidePages = [
        '/fnjihome',
        '/fnjidrop',
        '/fnjiartist',
        '/fnjiad',
        '/fnjithings'
    ];
    hidePages = _.map(hidePages, Utils.genPageLink);

    return {
        template: tpl,
        mixins: [AuthMixin],
        data: function(){
            return {
                chatOrigin: chatOrigin,
                hidePages: hidePages,
                isShow: false,
                hashKey: 'showChat'
            };
        },
        computed: {
            chatJsUrl: function(){
                return this.chatOrigin + '/php/app.php?widget-init.js';
            },
            hasNewMessageUrl: function(){
                return this.chatOrigin + '/php/app.php?guest-has-unread-message';
            },
            isHidePage: function(){
                var pathname = location.pathname;
                return _.some(this.hidePages, function(o){
                    return pathname.indexOf(o) === 0;
                });
            }
        },
        methods: {
            init: function(){
                if (this.isHidePage) return;
                var _this = this;
                $.getScript(_this.chatJsUrl)
                    .done(function(){
                        if (!window.phpLiveChat) {
                            return onError();
                        }
                        _this.isShow = true;
                        _this.checkShowChatHash();
                    })
                    .fail(onError);

                function onError(){
                    console.warn('Load Chat JS Error');
                }
            },
            toggle: function(){
                if (!window.phpLiveChat) return;
                if (!this.isLoggedIn){
                    var obj = {};
                    obj[this.hashKey] = 1;
                    var from = $.param.fragment(location.href, obj);
                    Modal.showMemberLoginModal(from);
                } else {
                    window.phpLiveChat.toggle();
                }
            },
            checkShowChatHash: function(){
                var hashObj = $.deparam.fragment();
                var key = this.hashKey;
                if (hashObj[key]) {
                    delete hashObj[key];
                    var url = $.param.fragment(location.pathname+location.search, hashObj);
                    location.replace(url);
                    this.toggle();
                }
            }
        },
        mounted: function(){
            this.init();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-talk-btn\" v-if=\"isShow\" @click=\"toggle()\">\r\n    <i class=\"u-icon u-icon-talk\"></i>\r\n</div>"

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(76);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./talk-btn.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./talk-btn.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(78),
    __webpack_require__(1),
    __webpack_require__(79),

    __webpack_require__(15),
    __webpack_require__(81)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    $,
    Qrcode
){
    return {
        template: tpl,
        props: {
            item: {
                type: Object
            }
        },
        components: {
            Qrcode: Qrcode
        },
        computed: {
            twitterUrl: function(){
                var url = 'https://www.tumblr.com/widgets/share/tool';
                var query = {
                    canonicalUrl: this.item.url,
                    posttype: 'phone',
                    title: this.item.title,
                    content: this.item.pic
                };
                return $.param.querystring(url, query);
            },
            pinterestUrl: function(){
                var url = 'http://pinterest.com/pin/create/button/';
                var query = {
                    url: this.item.url,
                    media: this.item.pic
                };
                return $.param.querystring(url, query);
            },
            weiboUrl: function(){
                var url = 'http://service.weibo.com/share/share.php';
                var query = {
                    url: this.item.url,
                    title: this.item.title,
                    pic: this.item.pic
                };
                return $.param.querystring(url, query);
            },
            url: function(){
                return this.item.url || window.location.href;
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-share-btn\" v-if=\"item\">\r\n    <div class=\"control-btn\">\r\n        <i class=\"u-icon u-icon-share\"></i>\r\n    </div>\r\n    <div class=\"popover\">\r\n        <ul class=\"nav\">\r\n            <li class=\"nav-item\">\r\n                <a :href=\"weiboUrl\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-weibo\"></i>\r\n                </a>\r\n            </li>\r\n            <li class=\"nav-item nav-item-weixin\">\r\n                <a href=\"javascript:\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-weixin\"></i>\r\n                </a>\r\n                <div class=\"weixin-qrcode\">\r\n                    <div class=\"qrcode\">\r\n                        <qrcode :url=\"url\"></qrcode>\r\n                    </div>\r\n                    <div class=\"title\">微信扫一扫 分享</div>\r\n                </div>\r\n            </li>\r\n            <li class=\"nav-item\">\r\n                <a :href=\"pinterestUrl\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-pinterest\"></i>\r\n                </a>\r\n            </li>\r\n            <li class=\"nav-item\" style=\"display: none;\">\r\n                <a :href=\"twitterUrl\" target=\"_blank\" class=\"nav-link\">\r\n                    <i class=\"u-icon u-icon-twitter\"></i>\r\n                </a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>"

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),

    __webpack_require__(80)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $
){
    return {
        template: '<span class="u-qrcode"></span>',
        props: {
            url: {
                type: String
            }
        },
        watch: {
            url: 'updateQrcode'
        },
        methods: {
            updateQrcode: function(){
                $(this.$el).empty().qrcode({
                    width: 100,
                    height: 100,
                    text: this.url
                });
            }
        },
        mounted: function(){
            this.updateQrcode();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 80 */
/***/ (function(module, exports) {

(function(r){r.fn.qrcode=function(h){var s;function u(a){this.mode=s;this.data=a}function o(a,c){this.typeNumber=a;this.errorCorrectLevel=c;this.modules=null;this.moduleCount=0;this.dataCache=null;this.dataList=[]}function q(a,c){if(void 0==a.length)throw Error(a.length+"/"+c);for(var d=0;d<a.length&&0==a[d];)d++;this.num=Array(a.length-d+c);for(var b=0;b<a.length-d;b++)this.num[b]=a[b+d]}function p(a,c){this.totalCount=a;this.dataCount=c}function t(){this.buffer=[];this.length=0}u.prototype={getLength:function(){return this.data.length},
write:function(a){for(var c=0;c<this.data.length;c++)a.put(this.data.charCodeAt(c),8)}};o.prototype={addData:function(a){this.dataList.push(new u(a));this.dataCache=null},isDark:function(a,c){if(0>a||this.moduleCount<=a||0>c||this.moduleCount<=c)throw Error(a+","+c);return this.modules[a][c]},getModuleCount:function(){return this.moduleCount},make:function(){if(1>this.typeNumber){for(var a=1,a=1;40>a;a++){for(var c=p.getRSBlocks(a,this.errorCorrectLevel),d=new t,b=0,e=0;e<c.length;e++)b+=c[e].dataCount;
for(e=0;e<this.dataList.length;e++)c=this.dataList[e],d.put(c.mode,4),d.put(c.getLength(),j.getLengthInBits(c.mode,a)),c.write(d);if(d.getLengthInBits()<=8*b)break}this.typeNumber=a}this.makeImpl(!1,this.getBestMaskPattern())},makeImpl:function(a,c){this.moduleCount=4*this.typeNumber+17;this.modules=Array(this.moduleCount);for(var d=0;d<this.moduleCount;d++){this.modules[d]=Array(this.moduleCount);for(var b=0;b<this.moduleCount;b++)this.modules[d][b]=null}this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-
7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(a,c);7<=this.typeNumber&&this.setupTypeNumber(a);null==this.dataCache&&(this.dataCache=o.createData(this.typeNumber,this.errorCorrectLevel,this.dataList));this.mapData(this.dataCache,c)},setupPositionProbePattern:function(a,c){for(var d=-1;7>=d;d++)if(!(-1>=a+d||this.moduleCount<=a+d))for(var b=-1;7>=b;b++)-1>=c+b||this.moduleCount<=c+b||(this.modules[a+d][c+b]=
0<=d&&6>=d&&(0==b||6==b)||0<=b&&6>=b&&(0==d||6==d)||2<=d&&4>=d&&2<=b&&4>=b?!0:!1)},getBestMaskPattern:function(){for(var a=0,c=0,d=0;8>d;d++){this.makeImpl(!0,d);var b=j.getLostPoint(this);if(0==d||a>b)a=b,c=d}return c},createMovieClip:function(a,c,d){a=a.createEmptyMovieClip(c,d);this.make();for(c=0;c<this.modules.length;c++)for(var d=1*c,b=0;b<this.modules[c].length;b++){var e=1*b;this.modules[c][b]&&(a.beginFill(0,100),a.moveTo(e,d),a.lineTo(e+1,d),a.lineTo(e+1,d+1),a.lineTo(e,d+1),a.endFill())}return a},
setupTimingPattern:function(){for(var a=8;a<this.moduleCount-8;a++)null==this.modules[a][6]&&(this.modules[a][6]=0==a%2);for(a=8;a<this.moduleCount-8;a++)null==this.modules[6][a]&&(this.modules[6][a]=0==a%2)},setupPositionAdjustPattern:function(){for(var a=j.getPatternPosition(this.typeNumber),c=0;c<a.length;c++)for(var d=0;d<a.length;d++){var b=a[c],e=a[d];if(null==this.modules[b][e])for(var f=-2;2>=f;f++)for(var i=-2;2>=i;i++)this.modules[b+f][e+i]=-2==f||2==f||-2==i||2==i||0==f&&0==i?!0:!1}},setupTypeNumber:function(a){for(var c=
j.getBCHTypeNumber(this.typeNumber),d=0;18>d;d++){var b=!a&&1==(c>>d&1);this.modules[Math.floor(d/3)][d%3+this.moduleCount-8-3]=b}for(d=0;18>d;d++)b=!a&&1==(c>>d&1),this.modules[d%3+this.moduleCount-8-3][Math.floor(d/3)]=b},setupTypeInfo:function(a,c){for(var d=j.getBCHTypeInfo(this.errorCorrectLevel<<3|c),b=0;15>b;b++){var e=!a&&1==(d>>b&1);6>b?this.modules[b][8]=e:8>b?this.modules[b+1][8]=e:this.modules[this.moduleCount-15+b][8]=e}for(b=0;15>b;b++)e=!a&&1==(d>>b&1),8>b?this.modules[8][this.moduleCount-
b-1]=e:9>b?this.modules[8][15-b-1+1]=e:this.modules[8][15-b-1]=e;this.modules[this.moduleCount-8][8]=!a},mapData:function(a,c){for(var d=-1,b=this.moduleCount-1,e=7,f=0,i=this.moduleCount-1;0<i;i-=2)for(6==i&&i--;;){for(var g=0;2>g;g++)if(null==this.modules[b][i-g]){var n=!1;f<a.length&&(n=1==(a[f]>>>e&1));j.getMask(c,b,i-g)&&(n=!n);this.modules[b][i-g]=n;e--; -1==e&&(f++,e=7)}b+=d;if(0>b||this.moduleCount<=b){b-=d;d=-d;break}}}};o.PAD0=236;o.PAD1=17;o.createData=function(a,c,d){for(var c=p.getRSBlocks(a,
c),b=new t,e=0;e<d.length;e++){var f=d[e];b.put(f.mode,4);b.put(f.getLength(),j.getLengthInBits(f.mode,a));f.write(b)}for(e=a=0;e<c.length;e++)a+=c[e].dataCount;if(b.getLengthInBits()>8*a)throw Error("code length overflow. ("+b.getLengthInBits()+">"+8*a+")");for(b.getLengthInBits()+4<=8*a&&b.put(0,4);0!=b.getLengthInBits()%8;)b.putBit(!1);for(;!(b.getLengthInBits()>=8*a);){b.put(o.PAD0,8);if(b.getLengthInBits()>=8*a)break;b.put(o.PAD1,8)}return o.createBytes(b,c)};o.createBytes=function(a,c){for(var d=
0,b=0,e=0,f=Array(c.length),i=Array(c.length),g=0;g<c.length;g++){var n=c[g].dataCount,h=c[g].totalCount-n,b=Math.max(b,n),e=Math.max(e,h);f[g]=Array(n);for(var k=0;k<f[g].length;k++)f[g][k]=255&a.buffer[k+d];d+=n;k=j.getErrorCorrectPolynomial(h);n=(new q(f[g],k.getLength()-1)).mod(k);i[g]=Array(k.getLength()-1);for(k=0;k<i[g].length;k++)h=k+n.getLength()-i[g].length,i[g][k]=0<=h?n.get(h):0}for(k=g=0;k<c.length;k++)g+=c[k].totalCount;d=Array(g);for(k=n=0;k<b;k++)for(g=0;g<c.length;g++)k<f[g].length&&
(d[n++]=f[g][k]);for(k=0;k<e;k++)for(g=0;g<c.length;g++)k<i[g].length&&(d[n++]=i[g][k]);return d};s=4;for(var j={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,
78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:1335,G18:7973,G15_MASK:21522,getBCHTypeInfo:function(a){for(var c=a<<10;0<=j.getBCHDigit(c)-j.getBCHDigit(j.G15);)c^=j.G15<<j.getBCHDigit(c)-j.getBCHDigit(j.G15);return(a<<10|c)^j.G15_MASK},getBCHTypeNumber:function(a){for(var c=a<<12;0<=j.getBCHDigit(c)-
j.getBCHDigit(j.G18);)c^=j.G18<<j.getBCHDigit(c)-j.getBCHDigit(j.G18);return a<<12|c},getBCHDigit:function(a){for(var c=0;0!=a;)c++,a>>>=1;return c},getPatternPosition:function(a){return j.PATTERN_POSITION_TABLE[a-1]},getMask:function(a,c,d){switch(a){case 0:return 0==(c+d)%2;case 1:return 0==c%2;case 2:return 0==d%3;case 3:return 0==(c+d)%3;case 4:return 0==(Math.floor(c/2)+Math.floor(d/3))%2;case 5:return 0==c*d%2+c*d%3;case 6:return 0==(c*d%2+c*d%3)%2;case 7:return 0==(c*d%3+(c+d)%2)%2;default:throw Error("bad maskPattern:"+
a);}},getErrorCorrectPolynomial:function(a){for(var c=new q([1],0),d=0;d<a;d++)c=c.multiply(new q([1,l.gexp(d)],0));return c},getLengthInBits:function(a,c){if(1<=c&&10>c)switch(a){case 1:return 10;case 2:return 9;case s:return 8;case 8:return 8;default:throw Error("mode:"+a);}else if(27>c)switch(a){case 1:return 12;case 2:return 11;case s:return 16;case 8:return 10;default:throw Error("mode:"+a);}else if(41>c)switch(a){case 1:return 14;case 2:return 13;case s:return 16;case 8:return 12;default:throw Error("mode:"+
a);}else throw Error("type:"+c);},getLostPoint:function(a){for(var c=a.getModuleCount(),d=0,b=0;b<c;b++)for(var e=0;e<c;e++){for(var f=0,i=a.isDark(b,e),g=-1;1>=g;g++)if(!(0>b+g||c<=b+g))for(var h=-1;1>=h;h++)0>e+h||c<=e+h||0==g&&0==h||i==a.isDark(b+g,e+h)&&f++;5<f&&(d+=3+f-5)}for(b=0;b<c-1;b++)for(e=0;e<c-1;e++)if(f=0,a.isDark(b,e)&&f++,a.isDark(b+1,e)&&f++,a.isDark(b,e+1)&&f++,a.isDark(b+1,e+1)&&f++,0==f||4==f)d+=3;for(b=0;b<c;b++)for(e=0;e<c-6;e++)a.isDark(b,e)&&!a.isDark(b,e+1)&&a.isDark(b,e+
2)&&a.isDark(b,e+3)&&a.isDark(b,e+4)&&!a.isDark(b,e+5)&&a.isDark(b,e+6)&&(d+=40);for(e=0;e<c;e++)for(b=0;b<c-6;b++)a.isDark(b,e)&&!a.isDark(b+1,e)&&a.isDark(b+2,e)&&a.isDark(b+3,e)&&a.isDark(b+4,e)&&!a.isDark(b+5,e)&&a.isDark(b+6,e)&&(d+=40);for(e=f=0;e<c;e++)for(b=0;b<c;b++)a.isDark(b,e)&&f++;a=Math.abs(100*f/c/c-50)/5;return d+10*a}},l={glog:function(a){if(1>a)throw Error("glog("+a+")");return l.LOG_TABLE[a]},gexp:function(a){for(;0>a;)a+=255;for(;256<=a;)a-=255;return l.EXP_TABLE[a]},EXP_TABLE:Array(256),
LOG_TABLE:Array(256)},m=0;8>m;m++)l.EXP_TABLE[m]=1<<m;for(m=8;256>m;m++)l.EXP_TABLE[m]=l.EXP_TABLE[m-4]^l.EXP_TABLE[m-5]^l.EXP_TABLE[m-6]^l.EXP_TABLE[m-8];for(m=0;255>m;m++)l.LOG_TABLE[l.EXP_TABLE[m]]=m;q.prototype={get:function(a){return this.num[a]},getLength:function(){return this.num.length},multiply:function(a){for(var c=Array(this.getLength()+a.getLength()-1),d=0;d<this.getLength();d++)for(var b=0;b<a.getLength();b++)c[d+b]^=l.gexp(l.glog(this.get(d))+l.glog(a.get(b)));return new q(c,0)},mod:function(a){if(0>
this.getLength()-a.getLength())return this;for(var c=l.glog(this.get(0))-l.glog(a.get(0)),d=Array(this.getLength()),b=0;b<this.getLength();b++)d[b]=this.get(b);for(b=0;b<a.getLength();b++)d[b]^=l.gexp(l.glog(a.get(b))+c);return(new q(d,0)).mod(a)}};p.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],
[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,
116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,
43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,
3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,
55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,
45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];p.getRSBlocks=function(a,c){var d=p.getRsBlockTable(a,c);if(void 0==d)throw Error("bad rs block @ typeNumber:"+a+"/errorCorrectLevel:"+c);for(var b=d.length/3,e=[],f=0;f<b;f++)for(var h=d[3*f+0],g=d[3*f+1],j=d[3*f+2],l=0;l<h;l++)e.push(new p(g,j));return e};p.getRsBlockTable=function(a,c){switch(c){case 1:return p.RS_BLOCK_TABLE[4*(a-1)+0];case 0:return p.RS_BLOCK_TABLE[4*(a-1)+1];case 3:return p.RS_BLOCK_TABLE[4*
(a-1)+2];case 2:return p.RS_BLOCK_TABLE[4*(a-1)+3]}};t.prototype={get:function(a){return 1==(this.buffer[Math.floor(a/8)]>>>7-a%8&1)},put:function(a,c){for(var d=0;d<c;d++)this.putBit(1==(a>>>c-d-1&1))},getLengthInBits:function(){return this.length},putBit:function(a){var c=Math.floor(this.length/8);this.buffer.length<=c&&this.buffer.push(0);a&&(this.buffer[c]|=128>>>this.length%8);this.length++}};"string"===typeof h&&(h={text:h});h=r.extend({},{render:"canvas",width:256,height:256,typeNumber:-1,
correctLevel:2,background:"#ffffff",foreground:"#000000"},h);return this.each(function(){var a;if("canvas"==h.render){a=new o(h.typeNumber,h.correctLevel);a.addData(h.text);a.make();var c=document.createElement("canvas");c.width=h.width;c.height=h.height;for(var d=c.getContext("2d"),b=h.width/a.getModuleCount(),e=h.height/a.getModuleCount(),f=0;f<a.getModuleCount();f++)for(var i=0;i<a.getModuleCount();i++){d.fillStyle=a.isDark(f,i)?h.foreground:h.background;var g=Math.ceil((i+1)*b)-Math.floor(i*b),
j=Math.ceil((f+1)*b)-Math.floor(f*b);d.fillRect(Math.round(i*b),Math.round(f*e),g,j)}}else{a=new o(h.typeNumber,h.correctLevel);a.addData(h.text);a.make();c=r("<table></table>").css("width",h.width+"px").css("height",h.height+"px").css("border","0px").css("border-collapse","collapse").css("background-color",h.background);d=h.width/a.getModuleCount();b=h.height/a.getModuleCount();for(e=0;e<a.getModuleCount();e++){f=r("<tr></tr>").css("height",b+"px").appendTo(c);for(i=0;i<a.getModuleCount();i++)r("<td></td>").css("width",
d+"px").css("background-color",a.isDark(e,i)?h.foreground:h.background).appendTo(f)}}a=c;jQuery(a).appendTo(this)})}})(jQuery);


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(82);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./share-btn.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./share-btn.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(84);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./menu.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./menu.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(86);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./lazyload.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./lazyload.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(88);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./global.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./global.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.inView=e():t.inView=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}var i=n(2),o=r(i);t.exports=o["default"]},function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(9),o=r(i),u=n(3),f=r(u),s=n(4),c=function(){if("undefined"!=typeof window){var t=100,e=["scroll","resize","load"],n={history:[]},r={offset:{},threshold:0,test:s.inViewport},i=(0,o["default"])(function(){n.history.forEach(function(t){n[t].check()})},t);e.forEach(function(t){return addEventListener(t,i)}),window.MutationObserver&&addEventListener("DOMContentLoaded",function(){new MutationObserver(i).observe(document.body,{attributes:!0,childList:!0,subtree:!0})});var u=function(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return n.history.indexOf(t)>-1?n[t].elements=e:(n[t]=(0,f["default"])(e,r),n.history.push(t)),n[t]}};return u.offset=function(t){if(void 0===t)return r.offset;var e=function(t){return"number"==typeof t};return["top","right","bottom","left"].forEach(e(t)?function(e){return r.offset[e]=t}:function(n){return e(t[n])?r.offset[n]=t[n]:null}),r.offset},u.threshold=function(t){return"number"==typeof t&&t>=0&&t<=1?r.threshold=t:r.threshold},u.test=function(t){return"function"==typeof t?r.test=t:r.test},u.is=function(t){return r.test(t,r)},u.offset(0),u}};e["default"]=c()},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,r){n(this,t),this.options=r,this.elements=e,this.current=[],this.handlers={enter:[],exit:[]},this.singles={enter:[],exit:[]}}return r(t,[{key:"check",value:function(){var t=this;return this.elements.forEach(function(e){var n=t.options.test(e,t.options),r=t.current.indexOf(e),i=r>-1,o=n&&!i,u=!n&&i;o&&(t.current.push(e),t.emit("enter",e)),u&&(t.current.splice(r,1),t.emit("exit",e))}),this}},{key:"on",value:function(t,e){return this.handlers[t].push(e),this}},{key:"once",value:function(t,e){return this.singles[t].unshift(e),this}},{key:"emit",value:function(t,e){for(;this.singles[t].length;)this.singles[t].pop()(e);for(var n=this.handlers[t].length;--n>-1;)this.handlers[t][n](e);return this}}]),t}();e["default"]=function(t,e){return new i(t,e)}},function(t,e){"use strict";function n(t,e){var n=t.getBoundingClientRect(),r=n.top,i=n.right,o=n.bottom,u=n.left,f=n.width,s=n.height,c={t:o,r:window.innerWidth-u,b:window.innerHeight-r,l:i},a={x:e.threshold*f,y:e.threshold*s};return c.t>e.offset.top+a.y&&c.r>e.offset.right+a.x&&c.b>e.offset.bottom+a.y&&c.l>e.offset.left+a.x}Object.defineProperty(e,"__esModule",{value:!0}),e.inViewport=n},function(t,e){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,function(){return this}())},function(t,e,n){var r=n(5),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){function r(t,e,n){function r(e){var n=x,r=m;return x=m=void 0,E=e,w=t.apply(r,n)}function a(t){return E=t,j=setTimeout(h,e),M?r(t):w}function l(t){var n=t-O,r=t-E,i=e-n;return _?c(i,g-r):i}function d(t){var n=t-O,r=t-E;return void 0===O||n>=e||n<0||_&&r>=g}function h(){var t=o();return d(t)?p(t):void(j=setTimeout(h,l(t)))}function p(t){return j=void 0,T&&x?r(t):(x=m=void 0,w)}function v(){void 0!==j&&clearTimeout(j),E=0,x=O=m=j=void 0}function y(){return void 0===j?w:p(o())}function b(){var t=o(),n=d(t);if(x=arguments,m=this,O=t,n){if(void 0===j)return a(O);if(_)return j=setTimeout(h,e),r(O)}return void 0===j&&(j=setTimeout(h,e)),w}var x,m,g,w,j,O,E=0,M=!1,_=!1,T=!0;if("function"!=typeof t)throw new TypeError(f);return e=u(e)||0,i(n)&&(M=!!n.leading,_="maxWait"in n,g=_?s(u(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),b.cancel=v,b.flush=y,b}var i=n(1),o=n(8),u=n(10),f="Expected a function",s=Math.max,c=Math.min;t.exports=r},function(t,e,n){var r=n(6),i=function(){return r.Date.now()};t.exports=i},function(t,e,n){function r(t,e,n){var r=!0,f=!0;if("function"!=typeof t)throw new TypeError(u);return o(n)&&(r="leading"in n?!!n.leading:r,f="trailing"in n?!!n.trailing:f),i(t,e,{leading:r,maxWait:e,trailing:f})}var i=n(7),o=n(1),u="Expected a function";t.exports=r},function(t,e){function n(t){return t}t.exports=n}])});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                return _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(93);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../build-v2/node_modules/style-loader/index.js!../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./slick.css", function() {
		var newContent = require("!!../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../build-v2/node_modules/style-loader/index.js!../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./slick.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(95);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../build-v2/node_modules/style-loader/index.js!../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./slick-theme.css", function() {
		var newContent = require("!!../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../build-v2/node_modules/style-loader/index.js!../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./slick-theme.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(100);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./image-slick.css", function() {
		var newContent = require("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./image-slick.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(1),
    __webpack_require__(3),
    __webpack_require__(9)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    $,
    _,
    Toast
){
    // var BaseUrl = 'http://fnji.com';
    var BaseUrl = '';
    var BUrl = 'https://website.fnji.com';
    var ErrorEnum = {
        DataError: {
            code: 'DATA_ERROR',
            data: '数据异常'
        },
        NetworkError: {
            code: 'NETWORK_ERROR',
            data: '网络异常'
        },
        ParamError: {
            code: 'PARAM_ERROR',
            data: '参数错误'
        }
    };
    function Api(path, defaultOptions){
        this.url = BaseUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    function NewApi(path, defaultOptions){
        this.url = BUrl + path;
        this.defaultOptions = defaultOptions || {};
    }
    Api.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    Api.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };
    NewApi.prototype.ajaxPromise = function(params, options){
        var dfd = $.Deferred();
        var opts = {
            url: this.url,
            dataType: 'json'
        };
        if (params) opts.data = params;
        opts = _.assign(opts, this.defaultOptions, options);

        $.ajax(opts)
            .done(function(result){
                if (!result){
                    dfd.reject(ErrorEnum.DataError);
                } else if (result.error === 0) {
                    dfd.resolve(result.data);
                } else {
                    dfd.reject(result);
                }
            })
            .fail(function(){
                dfd.reject(ErrorEnum.NetworkError);
            });

        return dfd.promise();
    };
    NewApi.prototype.ajax = function(params, options){
        Toast.showLoadingToast();
        return this.ajaxPromise(params, options)
            .fail(function(error){
                alert(error.data);
            })
            .always(function(){
                Toast.hideLoadingToast();
            });
    };

    return {
        Api: Api,
        NewApi: NewApi,
        uploadNewApi: new NewApi('/upload', {
            type:'POST',
            processData: false,
            contentType: false
        }),
        applyInfoApi: new NewApi('/mt/s/IpadDesignerModel/apply'),//提交
        // ridgeListApi: new Api('/m/s/SiteIndexEntity/ridge'),//山脊线产品（高端线）
        // earthListApi: new Api('/m/s/SiteIndexEntity/earth'),//大地线产品（高端线）
        // highListApi: new Api('/s/product-list/getLineProducts'),//高端线产品
        getIndexImagesApi: new Api('/m/s/SiteIndexEntity/getIndexImages'),//首页图片
        getShopListApi: new NewApi('/mt/s/ShopInfoModel/getList'),
        switchZhEnApi: new Api('/m/s/SiteIndexEntity/switchZhEn'),//中英文切换

        getIndexApi: new Api('/m/s/MagazineHome/getIndex')//栏目
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(5)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    CommonApi
){
    var Api = CommonApi.Api;
    return {
        multiPromise: CommonApi.multiPromise,
        getCooperateCfgApi: new Api('/s/sitecooperate/getCfg'),
        addCooperateApi: new Api('/s/sitecooperate/add', {type: 'POST'}),
        uploadApi: new Api('/m/s/upload', {
            type:'POST',
            processData: false,
            contentType: false
        }),
        getCommonEnumApi: new Api('/m/s/common/enum')
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports) {

module.exports = "<form id=\"buyChannel2024\" class=\"form\" @submit.prevent=\"submit()\">\r\n    <div class=\"form-row\">\r\n        <input name=\"companyName\" v-model=\"form.companyName\" type=\"text\" class=\"form-control is-required\" placeholder=\"公司名称(必填)\" required>\r\n<!--    </div>-->\r\n<!--    <div class=\"form-row\">-->\r\n        <input name=\"contact\" v-model=\"form.contact\" type=\"text\" class=\"form-control is-required\" placeholder=\"联系人(必填)\" required>\r\n    </div>\r\n    <div class=\"form-row\">\r\n        <input name=\"phone\" v-model=\"form.phone\" type=\"text\" class=\"form-control is-required\" placeholder=\"电话(必填)\" required>\r\n<!--    </div>-->\r\n<!--    <div class=\"form-row\">-->\r\n        <input name=\"email\" v-model=\"form.email\" type=\"text\" class=\"form-control is-required\" placeholder=\"邮箱（很重要，请填写常用邮箱）(必填)\" required>\r\n    </div>\r\n    <div class=\"form-row-attach\">\r\n        <input-attach v-model=\"attachments\"></input-attach>\r\n    </div>\r\n    <div class=\"form-row\">\r\n        <textarea name=\"remark\" v-model=\"form.remark\" class=\"form-control\" rows=\"5\" :placeholder=\"$t('cooperateFnji.note')\"></textarea>\r\n    </div>\r\n    <div class=\"form-row-btn\">\r\n        <button class=\"btn\" type=\"submit\">{{$t(\"cooperateFnji.submit\")}}</button>\r\n    </div>\r\n</form>\r\n"

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(141),
    __webpack_require__(122),
    __webpack_require__(110),
    __webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    InputAttach,
    Api,
    NewApi,
    _
){
    return {
        components: {
            InputAttach: InputAttach
        },
        data: function(){
            return {
                form: {},
                attachments: []
            };
        },
        methods: {
            submit: function(){
                var _this = this;
                _this.form.attch = _.chain(_this.attachments)
                    .map('uploadFilePath')
                    .join(';')
                    .value();
                var memberId = localStorage.getItem('fnjinew_memberId');
                if(memberId){
                    _this.form.memberId = memberId;
                }
                NewApi.applyInfoApi.ajax({data: JSON.stringify(_this.form)})
                    .done(function(){
                        _this.resetForm();
                        _this.attachments = [];
                        alert('提交成功');
                    });
            },
            resetForm: function(){
                this.form = {};
            }
        },
        created: function(){
            this.resetForm();
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(142),
    __webpack_require__(3),
    __webpack_require__(122),
    __webpack_require__(110),

    __webpack_require__(143)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    _,
    Api,
    NewApi
){
    return {
        template: tpl,
        props: {
            value: {
                type: Array
            }
        },
        data: function(){
            return {
                maxFileCount: 5
            };
        },
        methods: {
            onInputFileChange: function(event){
                var files = event.target.files;
                if (files.length + this.value.length > this.maxFileCount){
                    return alert('最多上传'+this.maxFileCount+'个文件');
                }
                var _this = this;
                var all = _.map(files, function(file){
                    return _this.uploadFile(file);
                });
                Api.multiPromise(all)
                    .always(function(){
                        event.target.value = '';
                    });
            },
            uploadFile: function(file){
                var uploadFileType = /^image/.test(file.type) ? 'img' : 'doc';
                var formData = new FormData();
                formData.append('file', file);
                formData.append('fileName', 'file');
                formData.append('type', uploadFileType);
                formData.append('uploadPath', '');
                formData.append('imgSize', file.size);

                var _this = this;
                return NewApi.uploadNewApi.ajaxPromise(formData).done(function(data){
                    console.log(data);
                    var obj = _.pick(file, ['name', 'size', 'type']);
                    obj.uploadFileType = uploadFileType;
                    obj.uploadFilePath = uploadFileType === 'img' ? data : data.split(':')[0];
                    console.log(obj);
                    _this.value.push(obj);
                });
            },
            removeFile: function(index){
                this.value.splice(index, 1);
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "<div class=\"u-input-attach\">\r\n    <a class=\"custom-file\"\r\n       :href=\"o.uploadFilePath | uploadUrl\"\r\n       target=\"_blank\"\r\n       v-for=\"(o, index) in value\"\r\n    >\r\n        <div class=\"custom-file-content\">\r\n            <div>{{o.name}}</div>\r\n        </div>\r\n        <div class=\"custom-file-tool\">\r\n            <div class=\"tool\" @click.prevent.stop=\"removeFile(index)\">&times;</div>\r\n        </div>\r\n    </a>\r\n    <div class=\"d-inline-flex col-input\">\r\n        <div class=\"custom-file\">\r\n            <label class=\"custom-file-label\">\r\n                <i class=\"u-icon u-icon-plus\"></i>\r\n            </label>\r\n            <input name=\"attach\" type=\"file\" class=\"custom-file-input\" multiple @change=\"onInputFileChange($event)\">\r\n        </div>\r\n        <div class=\"col-right align-self-center\">\r\n            <div class=\"title\" style=\"font-size: 14px!important;color: rgb(169, 169, 169)!important;margin-bottom: 6px !important;\">{{$t(\"cooperateFnji.attachFile\")}}</div>\r\n            <div class=\"descs\">({{$t(\"cooperateFnji.fileTips\")}})(营业执照/合作项目信息)</div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(144);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./input-attach.css", function() {
		var newContent = require("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./input-attach.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(146);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./main.css", function() {
		var newContent = require("!!../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../build-v2/node_modules/style-loader/index.js!../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./main.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(4),
    __webpack_require__(19),
    __webpack_require__(22),
    __webpack_require__(343),

    // 'WebCommon/init'
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    Vue,
    i18n,
    PageMixin,

    PageContent
){
    var app = new Vue({
        mixins: [PageMixin],
        components: {
            PageContent: PageContent
        },
        i18n: i18n
    });
    app.$mount('#app');

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(344),
    __webpack_require__(110),
    __webpack_require__(1),
    __webpack_require__(345),
    __webpack_require__(90),
    __webpack_require__(346),
    __webpack_require__(91),
    __webpack_require__(347),
    __webpack_require__(92),
    __webpack_require__(94),
    __webpack_require__(99)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    Api,
    $,
    Utils,
    inView,
    ItemDesign
){
    return {
        template: tpl,
        components: {
            ItemDesign: ItemDesign
        },
        data: function(){
            return {
                onlineList: [
                    {id: '100',place: '淘宝',name: '梵几天猫旗舰店',btn: '点击进入天猫',link: 'tianmao'},
                    {id: '101',place: '',name: 'by fnji 淘宝店',btn: '点击进入店铺',link: 'taobao'},
                    {id: '102',place: '小程序',name: '梵几官方小程序商城',btn: '',link: ''},
                ],
                onlineListEn: [
                    {id: '100',place: '',name: 'FNJI Tmall Shop',btn: 'Click to enter the store',link: 'tianmao'},
                    {id: '101',place: '',name: 'FNJI Taobao Shop',btn: 'Click to enter the store',link: 'taobao'},
                    {id: '102',place: '',name: 'FNJI Wechat Shop',btn: '',link: ''},
                ],
                onlineIndex: [{num:2,theIndex:0},{num:1,theIndex:2}],//滚动
                shopList: [
                    {city: '北京',name: '梵几三里屯太古里店',link: '/exhibitionhall?id=2',place: '北京市三里屯太古里北区NLG-07、08',info: '10:00~22:00  |  010-84388131',img: 's20480_1709199849_7346.jpg'},
                    {city: '',name: '梵几颐堤港店',link: '/exhibitionhall?id=3',place: '北京市朝阳区酒仙桥路18号颐堤港LG50A梵几',info: '10:00~22:00  |  010-84176728',img: 's20480_1632628395_5424.png'},
                    {city: '',name: '「梵几客厅」国子监店（升级中）',link: '/exhibitionhall?id=4',place: '北京市东城区安定门内国子监街41号',info: '10:30~19:00  |  010-53672899',img: 's20480_1629778762_2844.png'},
                    // {city: '上海',name: '「梵几客厅」武康路店',place: '上海市徐汇区武康路近湖南路',info: '11:00~19:30（周一店休）  |  021-54961966',img: 's20480_1629778834_4482.png'},
                    {city: '上海',name: '梵几客厅武康路店',link: '/exhibitionhall?id=6',place: '上海市徐汇区武康路370号',info: '11:00～19:00｜021-54668987',img: 's20480_1718864994_4686.png'},
                    {city: '',name: '梵几上海前滩太古里店',link: '/exhibitionhall?id=5',place: '上海市浦东新区东育路500号前滩太古里石区4楼梵几',info: '10:00-22:00  |  021-61017656',img: 's20480_1709199693_2655.jpg'},
                    {city: '广州',name: '梵几广州粤海天地店',link: '/exhibitionhall?id=7',place: '广州市天河区珠江西路21号粤海天地L1梵几',info: '10:00-22:00  |  020-66837669',img: 's20480_1713005658_4806.jpg'},
                    // {city: '深圳',name: '梵几深业上城店',place: '深圳市福田区皇岗路5001号深业上城小镇L3层T3062铺-00L4层T4006铺',info: '10:00~22:00  |  0755-82799649',img: 's20480_1629778871_4586.png'},
                    // {city: '',name: '梵几万象天地快闪店',place: '深圳市南山市深南大道9668号万象天地LG层LG60店铺',info: '10:00~22:00  |  2021.3.20——2021.8.27',img: 's20480_1629778888_5579.png'},
                    {city: '深圳',name: '梵几万象前海店',link: '/exhibitionhall?id=8',place: '深圳市前海深港合作区南山街道桂湾四路169号万象前海购物中心L167——L267',info: '10:00~22:00  |  88986489',img: 's20480_1644804940_4680.jpg'},
                    {city: '',name: '梵几卓悦中心店',link: '/exhibitionhall?id=9',place: '深圳市福田区福田街道岗厦社区深南大道卓悦中心北区L1、L2层N124-N216-217号',info: '10:00~22:00  |  0755-61687786',img: 's20480_1644805198_8163.jpg'},
                    // {city: '成都',name: '梵几远洋太古里店',place: '成都市锦江区中纱帽街8号成都远洋太古里第二层2230a、2230b号商铺及其三层',info: '10:00~22:00  |  028-65100422',img: 's20480_1629778920_1077.png'},
                    {city: '杭州',name: '梵几留和路店',link: '/exhibitionhall?id=11',place: '杭州市西湖区留和路139号东信和创园15栋',info: '10:00~18:00  |  0571-88963099',img: 's20480_1629778937_2880.png'},
                    {city: '苏州',name: '梵几苏州诚品店',link: '/exhibitionhall?id=12',place: '苏州市诚品生活1F L107',info: '10:00~22:00  |  0512-67209366',img: 's20480_1629778952_1493.png'},
                    // {city: '',name: '梵几苏州春风里店',place: '苏州市相城区御窑路大悦春风里L1-29/30',info: '12:00~21:00  |  0512-83912386',img: 's20480_1709199528_2401.jpg'},
                    {city: '南京',name: '梵几南京金鹰世界店',link: '/exhibitionhall?id=14',place: '南京市建邺区应天大街888号金鹰世界2层',info: '10:00-22:00  |  025-58805881',img: 's20480_1629778971_2466.png'},
                    {city: '成都',name: '梵几成都富森店',link: '/exhibitionhall?id=15',place: '成都市高新区盛和二路18号成都富森美家居3号店（家具馆）2楼2117、2118、2119、2130',info: '周一-周五 10:00-18:00 周末或节假日：10:00-19:00  |  028-85358515',img: 's20480_1629778920_1077.png'}
                ],
                shopIndex: [
                    {num:3,theIndex:0},
                    {num:2,theIndex:3},
                    {num:1,theIndex:5},
                    {num:2,theIndex:6},
                    {num:1,theIndex:8},
                    {num:1,theIndex:9},
                    {num:1,theIndex:10},
                    {num:1,theIndex:11}
                ],
                onlineh: 0,
                shoph: 0,
                isOnline: true,
                isZh: true,
                isPC: true,
                lineNum: 1
            };
        },
        methods: {
            toTab: function(){
                console.log(111);
                var _this = this;
                var url = window.location.href;
                console.log(url);
                if(url.indexOf('tab=3')>-1){
                    _this.toScroll(3);
                }
            },

            initShopList: function () {
                var _this = this;
                Api.getShopListApi.ajax({lang:_this.$i18n.locale})
                    .done(function(data){
                        _this.shopList = data;
                        console.log(data)
                    });
            },
            init: function(){
                this.initShopList();
                var _this = this;
                _this.onlineh = $('.index2021-buyChannel-shopLine-item').eq(_this.onlineList.length-1).offset()['top']-84;
                _this.shoph = $('.index2021-buyChannel-shop-item').eq(0).offset()['top']-150;
                if($(window).width()<=750){
                    _this.isPC = false;
                    $('.fixed-menu').css({'display': 'none'});
                }else {
                    _this.isPC = true;
                }
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    _this.onlineList = _this.onlineListEn;
                }else {
                    _this.isZh = true;
                }
            },
            toTianMao: function () {
                window.open('https://fanjijiaju.tmall.com','_blank');
            },
            getScroll: function () {
                var obj = this;
                var onlineChange = obj.onlineh;
                var scrollTop = $(window).scrollTop();
                if(onlineChange<=scrollTop){
                    // obj.isOnline = false;
                    $('.index2021-buyChannel-line1').css({width: '0',transtion: 'width 0.8s'});
                    if(obj.isPC){
                        // $('.index2021-buyChannel-line2').css({width: '104px',transtion: 'width 1.5s'});
                    }else {
                        // $('.index2021-buyChannel-line2').css({width: '155px',transtion: 'width 1.5s'});
                    }
                    obj.lineNum = 2;
                }else {
                    // obj.isOnline = true;
                    $('.index2021-buyChannel-line2').css({width: '0',transtion: 'width 0.8s'});
                    // $('.index2021-buyChannel-line1').css({width: '104px',transtion: 'width 1.5s'});
                    if(obj.isPC){
                        $('.index2021-buyChannel-line1').css({width: '104px',transtion: 'width 1.5s'});
                    }else {
                        $('.index2021-buyChannel-line1').css({width: '155px',transtion: 'width 1.5s'});
                    }
                    obj.lineNum = 1;
                }
                var scrollHeight = 360;
                var toHeight = 360;
                obj.onlineIndex.forEach(function (item,index) {
                    scrollHeight = toHeight;
                    toHeight = toHeight+item.num*99;
                    if(scrollHeight>=scrollTop){
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'relative',top:'0'});
                    }else if(toHeight-33>scrollTop&&scrollTop>scrollHeight){
                        // console.log(scrollHeight);
                        // console.log(scrollTop);
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'fixed',top:'150px'});
                    }else if(toHeight>scrollTop&&scrollTop>toHeight-33){
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'fixed',top:117-scrollTop+toHeight+'px'});
                    }else {
                        console.log(scrollTop);
                        $('.index2021-buyChannel-shopLine-item').eq(item.theIndex).find('.index2021-buyChannel-place-scroll').css({position:'fixed',top:117+'px'});
                    }
                });


                var shopHeight = obj.shoph;
                var toShopHeight = shopHeight;
                obj.shopIndex.forEach(function (items,indexs) {
                    shopHeight = toShopHeight;
                    toShopHeight = toShopHeight+items.num*256;
                    if(shopHeight>=scrollTop){
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'relative',top:'0'});
                    }else if(toShopHeight-33>scrollTop&&scrollTop>shopHeight){
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'fixed',top:'150px'});
                    }else if(toShopHeight>scrollTop&&scrollTop>toShopHeight-33){
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'fixed',top:117-scrollTop+toShopHeight+'px'});
                    }else {
                        $('.index2021-buyChannel-shop-item').eq(items.theIndex).find('.index2021-buyChannel-city-scroll').css({position:'fixed',top:117+'px'});
                    }
                });
            },
            toScroll: function(index){
                var toThePlace = 0;
                this.lineNum = index;
                if(index===1){
                    // toThePlace = $('#buyChannel-online').offset().top;
                    toThePlace = 0;
                }else if(index===3){
                    toThePlace = $('#buyChannel-procure').offset().top-300;
                }else {
                    // window.location.hash('#buyChannel-shop');
                    toThePlace = $('#buyChannel-shop').offset().top-300;
                }
                Utils.scrollTo(toThePlace);
            },
            toShop: function (link) {
                if(link=='tianmao'){
                    window.open('https://fanjijiaju.tmall.com','_blank');
                }else if(link=='taobao'){
                    window.open('https://shop444867519.taobao.com/?spm=a230r.7195193.1997079397.2.3e2a71d6az7bqM','_blank');
                }
            },
            toTheShops: function (link) {
                window.location.href = link;
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.init();
            }
        },
        mounted: function(){
            this.toTab();
            this.init();
            // this.initAnimate();
            Utils.emitPageReady();
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
            $(window).scroll(function () {
                obj.getScroll();
            });
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "<div class=\"index2021-buyChannel-normal\" style=\"background: #ffffff\">\r\n    <div v-if=\"isPC\" class=\"index2021-buyChannel-top\"></div>\r\n    <div class=\"index2021-buyChannel\">\r\n        <div id=\"buyChannel-online\" class=\"index2021-buyChannel-shop-title\"> {{$t(\"buyChannel.online\")}}</div>\r\n        <div class=\"index2021-buyChannel-normal\" v-if=\"isPC\">\r\n            <div v-for=\"(item,index) in onlineList\" :key=\"item.id\" class=\"index2021-buyChannel-shopLine-item\">\r\n                <div class=\"index2021-buyChannel-place-name\">\r\n                    <div class=\"index2021-buyChannel-place-scroll\">{{item.place}}</div>\r\n                </div>\r\n                <div :style=\"{'border-bottom':index===2?'1px solid #ffffff':'1px solid #979797'}\" class=\"index2021-buyChannel-shop-right\">\r\n                    <div class=\"index2021-buyChannel-shop-name\">{{item.name}}</div>\r\n                    <div style=\"flex: 1;\"></div>\r\n                    <div @click=\"toShop(item.link)\" class=\"index2021-buyChannel-shop-btn\">{{item.btn}}</div>\r\n                    <div v-if=\"!item.btn\" class=\"index2021-buyChannel-mini\"></div>\r\n                </div>\r\n                <div style=\"clear: both;\"></div>\r\n            </div>\r\n        </div>\r\n        <div class=\"index2021-buyChannel-normal\" v-if=\"!isPC\">\r\n            <div v-for=\"(item,index) in onlineList\" :key=\"item.id\">\r\n                <div v-if=\"item.place\" style=\"margin-top: 83px;\" class=\"index2021-buyChannel-place-name-phone\">\r\n                    <div class=\"index2021-buyChannel-place-scroll\">{{item.place}}</div>\r\n                </div>\r\n                <div class=\"index2021-buyChannel-online-con\">\r\n                    <div class=\"index2021-buyChannel-online-name\">{{item.name}}</div>\r\n                    <div style=\"flex: 1;\"></div>\r\n                    <div @click=\"toShop(item.link)\" class=\"index2021-buyChannel-shop-btn-phone\">{{item.btn}}</div>\r\n                    <div v-if=\"!item.btn\" class=\"index2021-buyChannel-mini-phone\"></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div id=\"buyChannel-procure\" :style=\"{'margin-top': isPC?'280px':'196px'}\" class=\"index2021-buyChannel-shop-title\">{{$t(\"buyChannel.project\")}}</div>\r\n        <ItemDesign></ItemDesign>\r\n        <div id=\"buyChannel-shop\" :style=\"{'margin-top': isPC?'280px':'196px'}\" class=\"index2021-buyChannel-shop-title\">{{$t(\"buyChannel.shop\")}}</div>\r\n        <div class=\"index2021-buyChannel-normal\" v-if=\"isPC\">\r\n            <div v-for=\"(items,indexs) in shopList\" :key=\"indexs\" class=\"index2021-buyChannel-shop-item\">\r\n                <div class=\"index2021-buyChannel-place-name\">\r\n                    <div class=\"index2021-buyChannel-city-scroll\">{{items.city}}</div>\r\n                </div>\r\n                <div @click=\"toTheShops(items.link)\" style=\"cursor: pointer\" :style=\"{'border-bottom':indexs===shopList.length-1?'1px solid #ffffff':'1px solid #979797'}\" class=\"index2021-buyChannel-shop-right\">\r\n                    <div class=\"index2021-buyChannel-normal\">\r\n                        <div :style=\"{'text-indent':indexs===2?'0':'15px'}\" class=\"index2021-buyChannel-shop-name\">{{items.name}}</div>\r\n                        <div class=\"index2021-buyChannel-shop-info\">\r\n                            <div>{{items.place}}</div>\r\n                            <div>{{items.info}}</div>\r\n                        </div>\r\n                    </div>\r\n                    <div style=\"flex: 1;\"></div>\r\n                    <div class=\"index2021-buyChannel-shop-img\">\r\n                        <img style=\"width: 275px!important;height: 170px!important;\" :src=\"'https://omsv2-static.fnji.com/'+items.img+'?imageMogr2/thumbnail/1200x%3E/quality/100!/sharpen/1'\" alt=\"\">\r\n                    </div>\r\n                </div>\r\n                <div style=\"clear: both;\"></div>\r\n            </div>\r\n        </div>\r\n        <div class=\"index2021-buyChannel-normal\" v-if=\"!isPC\">\r\n            <div v-for=\"(items,indexs) in shopList\" :key=\"indexs\">\r\n                <div v-if=\"items.city\" style=\"text-indent: 15px;\" class=\"index2021-buyChannel-place-name-phone\">{{items.city}}</div>\r\n                <div style=\"display: flex;padding-bottom: 52px;margin-bottom: 43px;\" :style=\"{'border-bottom':indexs===shopList.length-1?'1px solid #ffffff':'1px solid #979797'}\" class=\"index2021-buyChannel-normal\">\r\n                    <div class=\"index2021-buyChannel-normal\" style=\"height: 170px;\">\r\n                        <div :style=\"{'padding-left':indexs===0||indexs===3?'0':'15px'}\" class=\"index2021-buyChannel-shop-name-phone\">{{items.name}}</div>\r\n                        <div class=\"index2021-buyChannel-shop-info-phone index2021-buyChannel-shop-info\">\r\n                            <div style=\"width: 300px;\">{{items.place}}</div>\r\n                            <div>{{items.info}}</div>\r\n                        </div>\r\n                    </div>\r\n                    <div style=\"flex: 1;\"></div>\r\n                    <div class=\"index2021-buyChannel-shop-img\">\r\n                        <img style=\"width: 275px!important;height: 170px!important;\" :src=\"'https://omsv2-static.fnji.com/'+items.img+'?imageMogr2/thumbnail/1200x%3E/quality/100!/sharpen/1'\" alt=\"\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div :style=\"{paddingTop:isPC?'200px':'240px',fontSize:isPC?'24px':'36px'}\" class=\"index2021-buyChannel-title\">\r\n        <!--        <div style=\"mix-blend-mode: difference;\">-->\r\n        <!--            <img style=\"position:fixed;z-index: 111;\" :style=\"{width: isPC?'64px':'108px',top: isPC?'40px':'78px',left:isPC?'40px':'28px'}\" src=\"/view-v2/web/static/img/page-header/fnji_header_newer.png\" alt=\"\">-->\r\n        <!--        </div>-->\r\n        <div class=\"index2021-buyChannel-normal\">\r\n            <div @click=\"toScroll(1)\" :style=\"{color: lineNum===1?'#000000':'#7b7b7b',width:isPC?'204px':'155px'}\" class=\"index2021-buyChannel-title-words\">\r\n                {{$t(\"buyChannel.online\")}}\r\n                <div :style=\"{width:isPC?'204px':'155px'}\" class=\"index2021-buyChannel-title-line\">\r\n                    <div :style=\"{width:isPC?'204px':'155px'}\" class=\"index2021-buyChannel-line index2021-buyChannel-line1\"></div>\r\n                </div>\r\n            </div>\r\n            <div v-if=\"isPC\" @click=\"toScroll(3)\" :style=\"{color: lineNum===3?'#000000':'#7b7b7b',width:isPC?'264px':'155px'}\" class=\"index2021-buyChannel-title-words\">\r\n                {{$t(\"buyChannel.project\")}}\r\n                <div :style=\"{width:isPC?'264px':'155px'}\" class=\"index2021-buyChannel-title-line\">\r\n                    <div class=\"index2021-buyChannel-line index2021-buyChannel-line2\"></div>\r\n                </div>\r\n            </div>\r\n            <div @click=\"toScroll(2)\" :style=\"{color: lineNum===2?'#000000':'#7b7b7b',width:isPC?'204px':'155px'}\" class=\"index2021-buyChannel-title-words\">\r\n                {{$t(\"buyChannel.shop\")}}\r\n                <div :style=\"{width:isPC?'204px':'155px'}\" class=\"index2021-buyChannel-title-line\">\r\n                    <div class=\"index2021-buyChannel-line index2021-buyChannel-line2\"></div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(7),
    __webpack_require__(8),
    __webpack_require__(2),
    __webpack_require__(3)
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    EventBus,
    Events,
    Utils,
    _
){
    function ln2br(str){
        return (str||'').replace(/\n/g,'<br/>');
    }

    function uniqueId(){
        return Math.random().toString(36).substr(2, 4) + Date.now().toString(36);
    }

    function genGroceryDetailLink(id){
        return Utils.genPageLink('/grocery-detail?id='+id);
    }
    function genFurnitureDetailLink(id){
        return Utils.genPageLink('/furniture-detail?id='+id);
    }
    function genGalleryDetailLink(id){
        return Utils.genPageLink('/gallery-detail?id='+id);
    }

    function genGroceryL2Link(bom){
        return Utils.genPageLink('/grocery-l2?bom='+bom);
    }

    function genFurnitureL2Link(bom){
        return Utils.genPageLink('/furniture-l2?bom='+bom);
    }

    function genProductDetailLink(id, type){
        switch(parseInt(type)){
            case 1:
                return genFurnitureDetailLink(id);
            case 2:
                return genGroceryDetailLink(id);
            case 3:
                return genGalleryDetailLink(id);
            default:
                return genGroceryDetailLink(id);
        }
    }

    function getSkuMainImage(sku){
        var options = {
            color: sku.bgColorBase64,
            width: 500
        };
        return Utils.genFnjiImageUrl(sku.mainImage, options) || Utils.genCdnImageUrl(sku.mainImg, options);
    }
    function getSkuBgColor(sku){
        return sku.bgColor || '#f7f7f7';
    }
    function isSkuSoldOut(sku){
        return parseInt(sku.storeNum) <= 0;
    }
    function isSkuDiscount(sku){
        return sku.discountRate && parseFloat(sku.discountRate) > 0;
    }

    return _.assign({}, Utils, {
        ln2br: ln2br,

        genGroceryDetailLink: genGroceryDetailLink,
        genFurnitureDetailLink: genFurnitureDetailLink,
        uniqueId: uniqueId,
        genProductDetailLink: genProductDetailLink,
        getSkuMainImage: getSkuMainImage,
        getSkuBgColor: getSkuBgColor,
        genGroceryL2Link: genGroceryL2Link,
        genFurnitureL2Link: genFurnitureL2Link,
        isSkuSoldOut: isSkuSoldOut,
        isSkuDiscount: isSkuDiscount

    });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
    __webpack_require__(139),
    __webpack_require__(140),
    __webpack_require__(110),

    __webpack_require__(145),
], __WEBPACK_AMD_DEFINE_RESULT__ = (function(
    tpl,
    FormMixin,
    Api
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 2,
                    companyName: '',
                    contact: '',
                    phone: '',
                    email: '',
                    attch: '',
                    remark: '',
                    memberId: ''
                };
            }
        }
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(348);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(0)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-content.css", function() {
		var newContent = require("!!../../../../../build-v2/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../../build-v2/node_modules/style-loader/index.js!../../../../../build-v2/node_modules/css-loader/index.js??ref--0-2!./page-content.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/index2024-buyChannel.js?cd4ebfb9